"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2190],{

/***/ 77122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ registerBackgroundTabDetection; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4124);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76190);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92957);
/* harmony import */ var _common_debug_build_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4395);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76292);




/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function registerBackgroundTabDetection() {
    if (_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document */ .m.document) {
        _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document.addEventListener */ .m.document.addEventListener("visibilitychange", function() {
            // eslint-disable-next-line deprecation/deprecation
            var activeTransaction = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getActiveTransaction */ .x1)();
            if (_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document.hidden */ .m.document.hidden && activeTransaction) {
                var statusType = "cancelled";
                var ref = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .spanToJSON */ .XU)(activeTransaction), op = ref.op, status = ref.status;
                _common_debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log("[Tracing] Transaction: ".concat(statusType, " -> since tab moved to the background, op: ").concat(op));
                // We should not set status if it is already set, this prevent important statuses like
                // error or data loss from being overwritten on transaction.
                if (!status) {
                    activeTransaction.setStatus(statusType);
                }
                // TODO: Can we rewrite this to an attribute?
                // eslint-disable-next-line deprecation/deprecation
                activeTransaction.setTag("visibilitychange", "document.hidden");
                activeTransaction.end();
            }
        });
    } else {
        _common_debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.warn */ .kg.warn("[Tracing] Could not set up background tab detection due to lack of global document");
    }
}
 //# sourceMappingURL=backgroundtab.js.map


/***/ }),

/***/ 81610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E8": function() { return /* binding */ browserTracingIntegration; },
/* harmony export */   "Wo": function() { return /* binding */ startBrowserTracingPageLoadSpan; },
/* harmony export */   "og": function() { return /* binding */ startBrowserTracingNavigationSpan; }
/* harmony export */ });
/* unused harmony exports BROWSER_TRACING_INTEGRATION_ID, getMetaContent */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14483);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19217);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97576);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76190);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(91292);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(19381);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(4124);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(77668);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84907);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92957);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96233);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(41549);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(41413);
/* harmony import */ var _common_debug_build_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4395);
/* harmony import */ var _backgroundtab_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(77122);
/* harmony import */ var _instrument_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(56534);
/* harmony import */ var _metrics_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85153);
/* harmony import */ var _request_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24366);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76292);











var BROWSER_TRACING_INTEGRATION_ID = "BrowserTracing";
/** Options for Browser Tracing integration */ var DEFAULT_BROWSER_TRACING_OPTIONS = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, _sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .TRACING_DEFAULTS */ .AT), {
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {}
}), _request_js__WEBPACK_IMPORTED_MODULE_3__/* .defaultRequestInstrumentationOptions */ .k3);
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ var browserTracingIntegration = function() {
    var _options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _createRouteTransaction = /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        var hub = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_4__/* .getCurrentHub */ .Gd)();
        var beforeStartSpan = options.beforeStartSpan, idleTimeout = options.idleTimeout, finalTimeout = options.finalTimeout, heartbeatInterval = options.heartbeatInterval;
        var isPageloadTransaction = context.op === "pageload";
        var expandedContext;
        if (isPageloadTransaction) {
            var sentryTrace = isPageloadTransaction ? getMetaContent("sentry-trace") : "";
            var baggage = isPageloadTransaction ? getMetaContent("baggage") : undefined;
            var ref = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .propagationContextFromHeaders */ .pT)(sentryTrace, baggage), traceId = ref.traceId, dsc = ref.dsc, parentSpanId = ref.parentSpanId, sampled = ref.sampled;
            expandedContext = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled
            }, context), {
                metadata: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, context.metadata), {
                    dynamicSamplingContext: dsc
                }),
                trimEnd: true
            });
        } else {
            expandedContext = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                trimEnd: true
            }, context);
        }
        var finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, finalContext.metadata), {
            source: "custom"
        }) : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) {
            _common_debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.log */ .kg.log("[Tracing] Will not send ".concat(finalContext.op, " transaction because of beforeNavigate."));
        }
        _common_debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.log */ .kg.log("[Tracing] Starting ".concat(finalContext.op, " transaction on scope"));
        var location = _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.location */ .m.location;
        var idleTransaction = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_9__/* .startIdleTransaction */ .l)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.document */ .m.document) {
            _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.document.addEventListener */ .m.document.addEventListener("readystatechange", function() {
                if ([
                    "interactive",
                    "complete"
                ].includes(_types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.document.readyState */ .m.document.readyState)) {
                    idleTransaction.sendAutoFinishSignal();
                }
            });
            if ([
                "interactive",
                "complete"
            ].includes(_types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.document.readyState */ .m.document.readyState)) {
                idleTransaction.sendAutoFinishSignal();
            }
        }
        idleTransaction.registerBeforeFinishCallback(function(transaction) {
            _collectWebVitals();
            (0,_metrics_index_js__WEBPACK_IMPORTED_MODULE_10__/* .addPerformanceEntries */ .f7)(transaction);
        });
        return idleTransaction;
    };
    var _hasSetTracePropagationTargets = _common_debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_9__/* .addTracingExtensions */ .T)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) {
        // eslint-disable-next-line deprecation/deprecation
        _options.tracePropagationTargets = _options.tracingOrigins;
    }
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, DEFAULT_BROWSER_TRACING_OPTIONS, _options);
    var _collectWebVitals = (0,_metrics_index_js__WEBPACK_IMPORTED_MODULE_10__/* .startTrackingWebVitals */ .PR)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ var interactionIdToRouteNameMapping = {};
    if (options.enableInp) {
        (0,_metrics_index_js__WEBPACK_IMPORTED_MODULE_10__/* .startTrackingINP */ .NR)(interactionIdToRouteNameMapping, options.interactionsSampleRate);
    }
    if (options.enableLongTask) {
        (0,_metrics_index_js__WEBPACK_IMPORTED_MODULE_10__/* .startTrackingLongTasks */ .Fv)();
    }
    if (options._experiments.enableInteractions) {
        (0,_metrics_index_js__WEBPACK_IMPORTED_MODULE_10__/* .startTrackingInteractions */ .sn)();
    }
    var latestRoute = {
        name: undefined,
        context: undefined
    };
    return {
        name: BROWSER_TRACING_INTEGRATION_ID,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: function() {},
        afterAllSetup: function afterAllSetup(client) {
            var clientOptions = client.getOptions();
            var markBackgroundSpan = options.markBackgroundSpan, traceFetch = options.traceFetch, traceXHR = options.traceXHR, shouldCreateSpanForRequest = options.shouldCreateSpanForRequest, enableHTTPTimings = options.enableHTTPTimings, _experiments = options._experiments;
            var clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            var tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if (_common_debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) {
                _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.warn */ .kg.warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
            }
            var activeSpan;
            var startingUrl = _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.location */ .m.location && _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.location.href */ .m.location.href;
            if (client.on) {
                client.on("startNavigationSpan", function(context) {
                    if (activeSpan) {
                        _common_debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.log */ .kg.log("[Tracing] Finishing current transaction with op: ".concat((0,_sentry_core__WEBPACK_IMPORTED_MODULE_11__/* .spanToJSON */ .XU)(activeSpan).op));
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                        op: "navigation"
                    }, context));
                });
                client.on("startPageLoadSpan", function(context) {
                    if (activeSpan) {
                        _common_debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.log */ .kg.log("[Tracing] Finishing current transaction with op: ".concat((0,_sentry_core__WEBPACK_IMPORTED_MODULE_11__/* .spanToJSON */ .XU)(activeSpan).op));
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                        op: "pageload"
                    }, context));
                });
            }
            if (options.instrumentPageLoad && client.emit && _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.location */ .m.location) {
                var context = {
                    name: _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.location.pathname */ .m.location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: _sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .browserPerformanceTimeOrigin */ .Z1 ? _sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .browserPerformanceTimeOrigin */ .Z1 / 1000 : undefined,
                    origin: "auto.pageload.browser",
                    attributes: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, _sentry_core__WEBPACK_IMPORTED_MODULE_14__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj, "url")
                };
                startBrowserTracingPageLoadSpan(client, context);
            }
            if (options.instrumentNavigation && client.emit && _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.location */ .m.location) {
                (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_15__/* .addHistoryInstrumentationHandler */ .a)(function(param) {
                    var to = param.to, from = param.from;
                    /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    if (from !== to) {
                        startingUrl = undefined;
                        var context = {
                            name: _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.location.pathname */ .m.location.pathname,
                            origin: "auto.navigation.browser",
                            attributes: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, _sentry_core__WEBPACK_IMPORTED_MODULE_14__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj, "url")
                        };
                        startBrowserTracingNavigationSpan(client, context);
                    }
                });
            }
            if (markBackgroundSpan) {
                (0,_backgroundtab_js__WEBPACK_IMPORTED_MODULE_16__/* .registerBackgroundTabDetection */ .j)();
            }
            if (_experiments.enableInteractions) {
                registerInteractionListener(options, latestRoute);
            }
            if (options.enableInp) {
                registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
            }
            (0,_request_js__WEBPACK_IMPORTED_MODULE_3__/* .instrumentOutgoingRequests */ .L7)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options: options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function startBrowserTracingPageLoadSpan(client, spanOptions) {
    if (!client.emit) {
        return;
    }
    client.emit("startPageLoadSpan", spanOptions);
    var span = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_17__/* .getActiveSpan */ .HN)();
    var op = span && (0,_sentry_core__WEBPACK_IMPORTED_MODULE_11__/* .spanToJSON */ .XU)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function startBrowserTracingNavigationSpan(client, spanOptions) {
    if (!client.emit) {
        return;
    }
    client.emit("startNavigationSpan", spanOptions);
    var span = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_17__/* .getActiveSpan */ .HN)();
    var op = span && (0,_sentry_core__WEBPACK_IMPORTED_MODULE_11__/* .spanToJSON */ .XU)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function getMetaContent(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    var metaTag = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_18__/* .getDomElement */ .qT)("meta[name=".concat(metaName, "]"));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function registerInteractionListener(options, latestRoute) {
    var inflightInteractionTransaction;
    var registerInteractionTransaction = function() {
        var idleTimeout = options.idleTimeout, finalTimeout = options.finalTimeout, heartbeatInterval = options.heartbeatInterval;
        var op = "ui.action.click";
        // eslint-disable-next-line deprecation/deprecation
        var currentTransaction = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_19__/* .getActiveTransaction */ .x1)();
        if (currentTransaction && currentTransaction.op && [
            "navigation",
            "pageload"
        ].includes(currentTransaction.op)) {
            _common_debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.warn */ .kg.warn("[Tracing] Did not create ".concat(op, " transaction because a pageload or navigation transaction is in progress."));
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason("interactionInterrupted");
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            _common_debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.warn */ .kg.warn("[Tracing] Did not create ".concat(op, " transaction because _latestRouteName is missing."));
            return undefined;
        }
        var location = _types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.location */ .m.location;
        var context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, _sentry_core__WEBPACK_IMPORTED_MODULE_14__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj, latestRoute.context ? getSource(latestRoute.context) : "url")
        };
        inflightInteractionTransaction = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_9__/* .startIdleTransaction */ .l)(// eslint-disable-next-line deprecation/deprecation
        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_4__/* .getCurrentHub */ .Gd)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        "click"
    ].forEach(function(type) {
        if (_types_js__WEBPACK_IMPORTED_MODULE_8__/* .WINDOW.document */ .m.document) {
            addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        }
    });
}
function isPerformanceEventTiming(entry) {
    return "duration" in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ var MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute) {
    var handleEntries = function(param) {
        var entries = param.entries;
        var client = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_20__/* .getClient */ .s3)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        var replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
        var replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        var activeTransaction = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_19__/* .getActiveTransaction */ .x1)();
        var currentScope = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_20__/* .getCurrentScope */ .nZ)();
        var user = currentScope !== undefined ? currentScope.getUser() : undefined;
        entries.forEach(function(entry) {
            if (isPerformanceEventTiming(entry)) {
                var interactionId = entry.interactionId;
                if (interactionId === undefined) {
                    return;
                }
                var existingInteraction = interactionIdToRouteNameMapping[interactionId];
                var duration = entry.duration;
                var startTime = entry.startTime;
                var keys = Object.keys(interactionIdToRouteNameMapping);
                var minInteractionId = keys.length > 0 ? keys.reduce(function(a, b) {
                    return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration ? a : b;
                }) : undefined;
                // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                // This is also checked in the web-vitals library.
                if (entry.entryType === "first-input") {
                    var matchingEntry = keys.map(function(key) {
                        return interactionIdToRouteNameMapping[key];
                    }).some(function(interaction) {
                        return interaction.duration === duration && interaction.startTime === startTime;
                    });
                    if (matchingEntry) {
                        return;
                    }
                }
                // Interactions with an id of 0 and are not first-input are not valid.
                if (!interactionId) {
                    return;
                }
                // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                if (existingInteraction) {
                    existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                } else if (keys.length < MAX_INTERACTIONS || minInteractionId === undefined || duration > interactionIdToRouteNameMapping[minInteractionId].duration) {
                    // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                    var routeName = latestRoute.name;
                    var parentContext = latestRoute.context;
                    if (routeName && parentContext) {
                        if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= MAX_INTERACTIONS) {
                            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                            delete interactionIdToRouteNameMapping[minInteractionId];
                        }
                        interactionIdToRouteNameMapping[interactionId] = {
                            routeName: routeName,
                            duration: duration,
                            parentContext: parentContext,
                            user: user,
                            activeTransaction: activeTransaction,
                            replayId: replayId,
                            startTime: startTime
                        };
                    }
                }
            }
        });
    };
    (0,_instrument_js__WEBPACK_IMPORTED_MODULE_21__/* .addPerformanceInstrumentationHandler */ ._j)("event", handleEntries);
    (0,_instrument_js__WEBPACK_IMPORTED_MODULE_21__/* .addPerformanceInstrumentationHandler */ ._j)("first-input", handleEntries);
}
function getSource(context) {
    var sourceFromAttributes = context.attributes && context.attributes[_sentry_core__WEBPACK_IMPORTED_MODULE_14__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj];
    // eslint-disable-next-line deprecation/deprecation
    var sourceFromData = context.data && context.data[_sentry_core__WEBPACK_IMPORTED_MODULE_14__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj];
    // eslint-disable-next-line deprecation/deprecation
    var sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
 //# sourceMappingURL=browserTracingIntegration.js.map


/***/ }),

/***/ 87097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gE": function() { return /* binding */ BrowserTracing; }
});

// UNUSED EXPORTS: BROWSER_TRACING_INTEGRATION_ID, getMetaContent

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/idletransaction.js
var idletransaction = __webpack_require__(14483);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(97576);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/utils.js
var utils = __webpack_require__(4124);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(91292);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(77668);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(92957);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/tracing.js
var tracing = __webpack_require__(84907);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(41413);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/common/debug-build.js
var debug_build = __webpack_require__(4395);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/backgroundtab.js
var backgroundtab = __webpack_require__(77122);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/instrument.js + 11 modules
var instrument = __webpack_require__(56534);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/metrics/index.js + 2 modules
var metrics = __webpack_require__(85153);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/request.js + 1 modules
var request = __webpack_require__(24366);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(96233);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument/history.js + 1 modules
var instrument_history = __webpack_require__(41549);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/types.js
var types = __webpack_require__(76292);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/router.js



/**
 * Default function implementing pageload and navigation transactions
 */ function instrumentRoutingWithDefaults(customStartTransaction) {
    var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!types/* WINDOW */.m || !types/* WINDOW.location */.m.location) {
        debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    var startingUrl = types/* WINDOW.location.href */.m.location.href;
    var activeTransaction;
    if (startTransactionOnPageLoad) {
        activeTransaction = customStartTransaction({
            name: types/* WINDOW.location.pathname */.m.location.pathname,
            // pageload should always start at timeOrigin (and needs to be in s, not ms)
            startTimestamp: time/* browserPerformanceTimeOrigin */.Z1 ? time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
            op: "pageload",
            origin: "auto.pageload.browser",
            metadata: {
                source: "url"
            }
        });
    }
    if (startTransactionOnLocationChange) {
        (0,instrument_history/* addHistoryInstrumentationHandler */.a)(function(param) {
            var to = param.to, from = param.from;
            /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                startingUrl = undefined;
                return;
            }
            if (from !== to) {
                startingUrl = undefined;
                if (activeTransaction) {
                    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Tracing] Finishing current transaction with op: ".concat(activeTransaction.op));
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeTransaction.end();
                }
                activeTransaction = customStartTransaction({
                    name: types/* WINDOW.location.pathname */.m.location.pathname,
                    op: "navigation",
                    origin: "auto.navigation.browser",
                    metadata: {
                        source: "url"
                    }
                });
            }
        });
    }
}
 //# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/browsertracing.js














var BROWSER_TRACING_INTEGRATION_ID = "BrowserTracing";
/** Options for Browser Tracing integration */ var DEFAULT_BROWSER_TRACING_OPTIONS = (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, idletransaction/* TRACING_DEFAULTS */.AT), {
    markBackgroundTransactions: true,
    routingInstrumentation: instrumentRoutingWithDefaults,
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {}
}), request/* defaultRequestInstrumentationOptions */.k3);
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ var MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ var BrowserTracing = /*#__PURE__*/ function() {
    "use strict";
    function BrowserTracing(_options) {
        (0,_class_call_check/* default */.Z)(this, BrowserTracing);
        this.name = BROWSER_TRACING_INTEGRATION_ID;
        this._hasSetTracePropagationTargets = false;
        (0,hubextensions/* addTracingExtensions */.T)();
        if (debug_build/* DEBUG_BUILD */.X) {
            this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
            (_options.tracePropagationTargets || _options.tracingOrigins));
        }
        this.options = (0,_object_spread/* default */.Z)({}, DEFAULT_BROWSER_TRACING_OPTIONS, _options);
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) {
            this.options.enableLongTask = this.options._experiments.enableLongTask;
        }
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) {
            // eslint-disable-next-line deprecation/deprecation
            this.options.tracePropagationTargets = _options.tracingOrigins;
        }
        this._collectWebVitals = (0,metrics/* startTrackingWebVitals */.PR)();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) {
            (0,metrics/* startTrackingINP */.NR)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        }
        if (this.options.enableLongTask) {
            (0,metrics/* startTrackingLongTasks */.Fv)();
        }
        if (this.options._experiments.enableInteractions) {
            (0,metrics/* startTrackingInteractions */.sn)();
        }
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
    (0,_create_class/* default */.Z)(BrowserTracing, [
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                var _this = this;
                this._getCurrentHub = getCurrentHub;
                var hub = getCurrentHub();
                // eslint-disable-next-line deprecation/deprecation
                var client = hub.getClient();
                var clientOptions = client && client.getOptions();
                var _options = this.options, instrumentRouting = _options.routingInstrumentation, startTransactionOnLocationChange = _options.startTransactionOnLocationChange, startTransactionOnPageLoad = _options.startTransactionOnPageLoad, markBackgroundTransactions = _options.markBackgroundTransactions, traceFetch = _options.traceFetch, traceXHR = _options.traceXHR, shouldCreateSpanForRequest = _options.shouldCreateSpanForRequest, enableHTTPTimings = _options.enableHTTPTimings, _experiments = _options._experiments;
                var clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
                // There are three ways to configure tracePropagationTargets:
                // 1. via top level client option `tracePropagationTargets`
                // 2. via BrowserTracing option `tracePropagationTargets`
                // 3. via BrowserTracing option `tracingOrigins` (deprecated)
                //
                // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
                // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
                // This is done as it minimizes bundle size (we don't have to have undefined checks).
                //
                // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
                // eslint-disable-next-line deprecation/deprecation
                var tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
                if (debug_build/* DEBUG_BUILD */.X && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) {
                    logger/* logger.warn */.kg.warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
                }
                instrumentRouting(function(context) {
                    var transaction = _this._createRouteTransaction(context);
                    _this.options._experiments.onStartRouteTransaction && _this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
                    return transaction;
                }, startTransactionOnPageLoad, startTransactionOnLocationChange);
                if (markBackgroundTransactions) {
                    (0,backgroundtab/* registerBackgroundTabDetection */.j)();
                }
                if (_experiments.enableInteractions) {
                    this._registerInteractionListener();
                }
                if (this.options.enableInp) {
                    this._registerInpInteractionListener();
                }
                (0,request/* instrumentOutgoingRequests */.L7)({
                    traceFetch: traceFetch,
                    traceXHR: traceXHR,
                    tracePropagationTargets: tracePropagationTargets,
                    shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                    enableHTTPTimings: enableHTTPTimings
                });
            }
        },
        {
            /** Create routing idle transaction. */ key: "_createRouteTransaction",
            value: function _createRouteTransaction(context) {
                var _this = this;
                if (!this._getCurrentHub) {
                    debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("[Tracing] Did not create ".concat(context.op, " transaction because _getCurrentHub is invalid."));
                    return undefined;
                }
                var hub = this._getCurrentHub();
                var _options = this.options, beforeNavigate = _options.beforeNavigate, idleTimeout = _options.idleTimeout, finalTimeout = _options.finalTimeout, heartbeatInterval = _options.heartbeatInterval;
                var isPageloadTransaction = context.op === "pageload";
                var expandedContext;
                if (isPageloadTransaction) {
                    var sentryTrace = isPageloadTransaction ? getMetaContent("sentry-trace") : "";
                    var baggage = isPageloadTransaction ? getMetaContent("baggage") : undefined;
                    var ref = (0,tracing/* propagationContextFromHeaders */.pT)(sentryTrace, baggage), traceId = ref.traceId, dsc = ref.dsc, parentSpanId = ref.parentSpanId, sampled = ref.sampled;
                    expandedContext = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        traceId: traceId,
                        parentSpanId: parentSpanId,
                        parentSampled: sampled
                    }, context), {
                        metadata: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, context.metadata), {
                            dynamicSamplingContext: dsc
                        }),
                        trimEnd: true
                    });
                } else {
                    expandedContext = (0,_object_spread/* default */.Z)({
                        trimEnd: true
                    }, context);
                }
                var modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
                // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
                // from being sent to Sentry).
                var finalContext = modifiedContext === undefined ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, expandedContext), {
                    sampled: false
                }) : modifiedContext;
                // If `beforeNavigate` set a custom name, record that fact
                // eslint-disable-next-line deprecation/deprecation
                finalContext.metadata = finalContext.name !== expandedContext.name ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, finalContext.metadata), {
                    source: "custom"
                }) : finalContext.metadata;
                this._latestRoute.name = finalContext.name;
                this._latestRoute.context = finalContext;
                // eslint-disable-next-line deprecation/deprecation
                if (finalContext.sampled === false) {
                    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Tracing] Will not send ".concat(finalContext.op, " transaction because of beforeNavigate."));
                }
                debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Tracing] Starting ".concat(finalContext.op, " transaction on scope"));
                var location = types/* WINDOW.location */.m.location;
                var idleTransaction = (0,hubextensions/* startIdleTransaction */.l)(hub, finalContext, idleTimeout, finalTimeout, true, {
                    location: location
                }, heartbeatInterval, isPageloadTransaction);
                if (isPageloadTransaction) {
                    if (types/* WINDOW.document */.m.document) {
                        types/* WINDOW.document.addEventListener */.m.document.addEventListener("readystatechange", function() {
                            if ([
                                "interactive",
                                "complete"
                            ].includes(types/* WINDOW.document.readyState */.m.document.readyState)) {
                                idleTransaction.sendAutoFinishSignal();
                            }
                        });
                        if ([
                            "interactive",
                            "complete"
                        ].includes(types/* WINDOW.document.readyState */.m.document.readyState)) {
                            idleTransaction.sendAutoFinishSignal();
                        }
                    }
                }
                idleTransaction.registerBeforeFinishCallback(function(transaction) {
                    _this._collectWebVitals();
                    (0,metrics/* addPerformanceEntries */.f7)(transaction);
                });
                return idleTransaction;
            }
        },
        {
            /** Start listener for interaction transactions */ key: "_registerInteractionListener",
            value: function _registerInteractionListener() {
                var _this = this;
                var inflightInteractionTransaction;
                var registerInteractionTransaction = function() {
                    var _options = _this.options, idleTimeout = _options.idleTimeout, finalTimeout = _options.finalTimeout, heartbeatInterval = _options.heartbeatInterval;
                    var op = "ui.action.click";
                    // eslint-disable-next-line deprecation/deprecation
                    var currentTransaction = (0,utils/* getActiveTransaction */.x1)();
                    if (currentTransaction && currentTransaction.op && [
                        "navigation",
                        "pageload"
                    ].includes(currentTransaction.op)) {
                        debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("[Tracing] Did not create ".concat(op, " transaction because a pageload or navigation transaction is in progress."));
                        return undefined;
                    }
                    if (inflightInteractionTransaction) {
                        inflightInteractionTransaction.setFinishReason("interactionInterrupted");
                        inflightInteractionTransaction.end();
                        inflightInteractionTransaction = undefined;
                    }
                    if (!_this._getCurrentHub) {
                        debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("[Tracing] Did not create ".concat(op, " transaction because _getCurrentHub is invalid."));
                        return undefined;
                    }
                    if (!_this._latestRoute.name) {
                        debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("[Tracing] Did not create ".concat(op, " transaction because _latestRouteName is missing."));
                        return undefined;
                    }
                    var hub = _this._getCurrentHub();
                    var location = types/* WINDOW.location */.m.location;
                    var context = {
                        name: _this._latestRoute.name,
                        op: op,
                        trimEnd: true,
                        data: (0,_define_property/* default */.Z)({}, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, _this._latestRoute.context ? getSource(_this._latestRoute.context) : "url")
                    };
                    inflightInteractionTransaction = (0,hubextensions/* startIdleTransaction */.l)(hub, context, idleTimeout, finalTimeout, true, {
                        location: location
                    }, heartbeatInterval);
                };
                [
                    "click"
                ].forEach(function(type) {
                    if (types/* WINDOW.document */.m.document) {
                        addEventListener(type, registerInteractionTransaction, {
                            once: false,
                            capture: true
                        });
                    }
                });
            }
        },
        {
            /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ key: "_registerInpInteractionListener",
            value: function _registerInpInteractionListener() {
                var _this = this;
                var handleEntries = function(param) {
                    var entries = param.entries;
                    var client = (0,esm_exports/* getClient */.s3)();
                    // We need to get the replay, user, and activeTransaction from the current scope
                    // so that we can associate replay id, profile id, and a user display to the span
                    var replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
                    var replayId = replay !== undefined ? replay.getReplayId() : undefined;
                    // eslint-disable-next-line deprecation/deprecation
                    var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
                    var currentScope = (0,esm_exports/* getCurrentScope */.nZ)();
                    var user = currentScope !== undefined ? currentScope.getUser() : undefined;
                    entries.forEach(function(entry) {
                        if (isPerformanceEventTiming(entry)) {
                            var interactionId = entry.interactionId;
                            if (interactionId === undefined) {
                                return;
                            }
                            var existingInteraction = _this._interactionIdToRouteNameMapping[interactionId];
                            var duration = entry.duration;
                            var startTime = entry.startTime;
                            var keys = Object.keys(_this._interactionIdToRouteNameMapping);
                            var minInteractionId = keys.length > 0 ? keys.reduce(function(a, b) {
                                return _this._interactionIdToRouteNameMapping[a].duration < _this._interactionIdToRouteNameMapping[b].duration ? a : b;
                            }) : undefined;
                            // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                            // This is also checked in the web-vitals library.
                            if (entry.entryType === "first-input") {
                                var matchingEntry = keys.map(function(key) {
                                    return _this._interactionIdToRouteNameMapping[key];
                                }).some(function(interaction) {
                                    return interaction.duration === duration && interaction.startTime === startTime;
                                });
                                if (matchingEntry) {
                                    return;
                                }
                            }
                            // Interactions with an id of 0 and are not first-input are not valid.
                            if (!interactionId) {
                                return;
                            }
                            // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                            if (existingInteraction) {
                                existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                            } else if (keys.length < MAX_INTERACTIONS || minInteractionId === undefined || duration > _this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                                // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                                var routeName = _this._latestRoute.name;
                                var parentContext = _this._latestRoute.context;
                                if (routeName && parentContext) {
                                    if (minInteractionId && Object.keys(_this._interactionIdToRouteNameMapping).length >= MAX_INTERACTIONS) {
                                        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                                        delete _this._interactionIdToRouteNameMapping[minInteractionId];
                                    }
                                    _this._interactionIdToRouteNameMapping[interactionId] = {
                                        routeName: routeName,
                                        duration: duration,
                                        parentContext: parentContext,
                                        user: user,
                                        activeTransaction: activeTransaction,
                                        replayId: replayId,
                                        startTime: startTime
                                    };
                                }
                            }
                        }
                    });
                };
                (0,instrument/* addPerformanceInstrumentationHandler */._j)("event", handleEntries);
                (0,instrument/* addPerformanceInstrumentationHandler */._j)("first-input", handleEntries);
            }
        }
    ]);
    return BrowserTracing;
}();
/** Returns the value of a meta tag */ function getMetaContent(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    var metaTag = (0,browser/* getDomElement */.qT)("meta[name=".concat(metaName, "]"));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
function getSource(context) {
    var sourceFromAttributes = context.attributes && context.attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj];
    // eslint-disable-next-line deprecation/deprecation
    var sourceFromData = context.data && context.data[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj];
    // eslint-disable-next-line deprecation/deprecation
    var sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function isPerformanceEventTiming(entry) {
    return "duration" in entry;
}
 //# sourceMappingURL=browsertracing.js.map


/***/ }),

/***/ 56534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PR": function() { return /* binding */ addClsInstrumentationHandler; },
  "to": function() { return /* binding */ addFidInstrumentationHandler; },
  "YF": function() { return /* binding */ addInpInstrumentationHandler; },
  "$A": function() { return /* binding */ addLcpInstrumentationHandler; },
  "_j": function() { return /* binding */ addPerformanceInstrumentationHandler; },
  "_4": function() { return /* binding */ addTtfbInstrumentationHandler; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(92957);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(91987);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/common/debug-build.js
var debug_build = __webpack_require__(4395);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/bindReporter.js
var bindReporter = function(callback, metric, reportAllChanges) {
    var prevValue;
    var delta;
    return function(forceReport) {
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};
 //# sourceMappingURL=bindReporter.js.map

// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/types.js
var types = __webpack_require__(76292);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ var generateUniqueID = function() {
    return "v3-".concat(Date.now(), "-").concat(Math.floor(Math.random() * (9e12 - 1)) + 1e12);
};
 //# sourceMappingURL=generateUniqueID.js.map

// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js
var getNavigationEntry = __webpack_require__(64687);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getActivationStart.js

/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var getActivationStart = function() {
    var navEntry = (0,getNavigationEntry/* getNavigationEntry */.W)();
    return navEntry && navEntry.activationStart || 0;
};
 //# sourceMappingURL=getActivationStart.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/initMetric.js




/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var initMetric = function(name, value) {
    var navEntry = (0,getNavigationEntry/* getNavigationEntry */.W)();
    var navigationType = "navigate";
    if (navEntry) {
        if (types/* WINDOW.document */.m.document && types/* WINDOW.document.prerendering */.m.document.prerendering || getActivationStart() > 0) {
            navigationType = "prerender";
        } else {
            navigationType = navEntry.type.replace(/_/g, "-");
        }
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: generateUniqueID(),
        navigationType: navigationType
    };
};
 //# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/observe.js
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ var observe = function(type, callback, opts) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            var po = new PerformanceObserver(function(list) {
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};
 //# sourceMappingURL=observe.js.map

// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/onHidden.js
var onHidden = __webpack_require__(96626);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getCLS.js




/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ var onCLS = function(onReport) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var metric = initMetric("CLS", 0);
    var report;
    var sessionValue = 0;
    var sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    var handleEntries = function(entries) {
        entries.forEach(function(entry) {
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                var firstSessionEntry = sessionEntries[0];
                var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) {
                        report();
                    }
                }
            }
        });
    };
    var po = observe("layout-shift", handleEntries);
    if (po) {
        report = bindReporter(onReport, metric, options.reportAllChanges);
        var stopListening = function() {
            handleEntries(po.takeRecords());
            report(true);
        };
        (0,onHidden/* onHidden */.u)(stopListening);
        return stopListening;
    }
    return;
};
 //# sourceMappingURL=getCLS.js.map

// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js
var getVisibilityWatcher = __webpack_require__(33191);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getFID.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ var onFID = function(onReport) {
    var visibilityWatcher = (0,getVisibilityWatcher/* getVisibilityWatcher */.Y)();
    var metric = initMetric("FID");
    // eslint-disable-next-line prefer-const
    var report;
    var handleEntry = function(entry) {
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    var handleEntries = function(entries) {
        entries.forEach(handleEntry);
    };
    var po = observe("first-input", handleEntries);
    report = bindReporter(onReport, metric);
    if (po) {
        (0,onHidden/* onHidden */.u)(function() {
            handleEntries(po.takeRecords());
            po.disconnect();
        }, true);
    }
};
 //# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/polyfills/interactionCountPolyfill.js

var interactionCountEstimate = 0;
var minKnownInteractionId = Infinity;
var maxKnownInteractionId = 0;
var updateEstimate = function(entries) {
    entries.forEach(function(e) {
        if (e.interactionId) {
            minKnownInteractionId = Math.min(minKnownInteractionId, e.interactionId);
            maxKnownInteractionId = Math.max(maxKnownInteractionId, e.interactionId);
            interactionCountEstimate = maxKnownInteractionId ? (maxKnownInteractionId - minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
var po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ var getInteractionCount = function() {
    return po ? interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ var initInteractionCountPolyfill = function() {
    if ("interactionCount" in performance || po) return;
    po = observe("event", updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};
 //# sourceMappingURL=interactionCountPolyfill.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getINP.js





/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ var getInteractionCountForNavigation = function() {
    return getInteractionCount();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
var MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
var longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
var longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ var processEntry = function(entry) {
    // The least-long of the 10 longest interactions.
    var minLongestInteraction = longestInteractionList[longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var existingInteraction = longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || longestInteractionList.length < MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            var interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            longestInteractionMap[interaction.id] = interaction;
            longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        longestInteractionList.sort(function(a, b) {
            return b.latency - a.latency;
        });
        longestInteractionList.splice(MAX_INTERACTIONS_TO_CONSIDER).forEach(function(i) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ var estimateP98LongestInteraction = function() {
    var candidateInteractionIndex = Math.min(longestInteractionList.length - 1, Math.floor(getInteractionCountForNavigation() / 50));
    return longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ var onINP = function(onReport, opts) {
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    initInteractionCountPolyfill();
    var metric = initMetric("INP");
    // eslint-disable-next-line prefer-const
    var report;
    var handleEntries = function(entries) {
        entries.forEach(function(entry) {
            if (entry.interactionId) {
                processEntry(entry);
            }
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === "first-input") {
                var noMatchingEntry = !longestInteractionList.some(function(interaction) {
                    return interaction.entries.some(function(prevEntry) {
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) {
                    processEntry(entry);
                }
            }
        });
        var inp = estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    var po = observe("event", handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = bindReporter(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: "first-input",
            buffered: true
        });
        (0,onHidden/* onHidden */.u)(function() {
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};
 //# sourceMappingURL=getINP.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getLCP.js







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ var onLCP = function(onReport) {
    var visibilityWatcher = (0,getVisibilityWatcher/* getVisibilityWatcher */.Y)();
    var metric = initMetric("LCP");
    var report;
    var handleEntries = function(entries) {
        var lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            var value = Math.max(lastEntry.startTime - getActivationStart(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    var po = observe("largest-contentful-paint", handleEntries);
    if (po) {
        report = bindReporter(onReport, metric);
        var stopListening = function() {
            if (!reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach(function(type) {
            if (types/* WINDOW.document */.m.document) {
                addEventListener(type, stopListening, {
                    once: true,
                    capture: true
                });
            }
        });
        (0,onHidden/* onHidden */.u)(stopListening, true);
        return stopListening;
    }
    return;
};
 //# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/onTTFB.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ var whenReady = function(callback) {
    if (!types/* WINDOW.document */.m.document) {
        return;
    }
    if (types/* WINDOW.document.prerendering */.m.document.prerendering) {
        addEventListener("prerenderingchange", function() {
            return whenReady(callback);
        }, true);
    } else if (types/* WINDOW.document.readyState */.m.document.readyState !== "complete") {
        addEventListener("load", function() {
            return whenReady(callback);
        }, true);
    } else {
        // Queue a task so the callback runs after `loadEventEnd`.
        setTimeout(callback, 0);
    }
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ var onTTFB = function(onReport, opts) {
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    var metric = initMetric("TTFB");
    var report = bindReporter(onReport, metric, opts.reportAllChanges);
    whenReady(function() {
        var navEntry = (0,getNavigationEntry/* getNavigationEntry */.W)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - getActivationStart(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};
 //# sourceMappingURL=onTTFB.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/instrument.js








var handlers = {};
var instrumented = {};
var _previousCls;
var _previousFid;
var _previousLcp;
var _previousTtfb;
var _previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function addClsInstrumentationHandler(callback) {
    var stopOnCallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return addMetricObserver("cls", callback, instrumentCls, _previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function addLcpInstrumentationHandler(callback) {
    var stopOnCallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return addMetricObserver("lcp", callback, instrumentLcp, _previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function addTtfbInstrumentationHandler(callback) {
    return addMetricObserver("ttfb", callback, instrumentTtfb, _previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function addFidInstrumentationHandler(callback) {
    return addMetricObserver("fid", callback, instrumentFid, _previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function addInpInstrumentationHandler(callback) {
    return addMetricObserver("inp", callback, instrumentInp, _previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function addPerformanceInstrumentationHandler(type, callback) {
    addHandler(type, callback);
    if (!instrumented[type]) {
        instrumentPerformanceObserver(type);
        instrumented[type] = true;
    }
    return getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function triggerHandlers(type, data) {
    var typeHandlers = handlers[type];
    if (!typeHandlers || !typeHandlers.length) {
        return;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = typeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            try {
                handler(data);
            } catch (e) {
                debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error("Error while triggering instrumentation handler.\nType: ".concat(type, "\nName: ").concat((0,stacktrace/* getFunctionName */.$P)(handler), "\nError:"), e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function instrumentCls() {
    return onCLS(function(metric) {
        triggerHandlers("cls", {
            metric: metric
        });
        _previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function instrumentFid() {
    return onFID(function(metric) {
        triggerHandlers("fid", {
            metric: metric
        });
        _previousFid = metric;
    });
}
function instrumentLcp() {
    return onLCP(function(metric) {
        triggerHandlers("lcp", {
            metric: metric
        });
        _previousLcp = metric;
    });
}
function instrumentTtfb() {
    return onTTFB(function(metric) {
        triggerHandlers("ttfb", {
            metric: metric
        });
        _previousTtfb = metric;
    });
}
function instrumentInp() {
    return onINP(function(metric) {
        triggerHandlers("inp", {
            metric: metric
        });
        _previousInp = metric;
    });
}
function addMetricObserver(type, callback, instrumentFn, previousValue) {
    var stopOnCallback = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    addHandler(type, callback);
    var stopListening;
    if (!instrumented[type]) {
        stopListening = instrumentFn();
        instrumented[type] = true;
    }
    if (previousValue) {
        callback({
            metric: previousValue
        });
    }
    return getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function instrumentPerformanceObserver(type) {
    var options = {};
    // Special per-type options we want to use
    if (type === "event") {
        options.durationThreshold = 0;
    }
    observe(type, function(entries) {
        triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function addHandler(type, handler) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function getCleanupCallback(type, callback, stopListening) {
    return function() {
        if (stopListening) {
            stopListening();
        }
        var typeHandlers = handlers[type];
        if (!typeHandlers) {
            return;
        }
        var index = typeHandlers.indexOf(callback);
        if (index !== -1) {
            typeHandlers.splice(index, 1);
        }
    };
}
 //# sourceMappingURL=instrument.js.map


/***/ }),

/***/ 85153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f7": function() { return /* binding */ addPerformanceEntries; },
  "NR": function() { return /* binding */ startTrackingINP; },
  "sn": function() { return /* binding */ startTrackingInteractions; },
  "Fv": function() { return /* binding */ startTrackingLongTasks; },
  "PR": function() { return /* binding */ startTrackingWebVitals; }
});

// UNUSED EXPORTS: _addMeasureSpans, _addResourceSpans

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/utils.js
var utils = __webpack_require__(4124);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(77668);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/span.js
var tracing_span = __webpack_require__(95293);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/dsn.js
var esm_dsn = __webpack_require__(74094);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/envelope.js
var envelope = __webpack_require__(62486);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/span.js

/**
 * Create envelope from Span item.
 */ function createSpanEnvelope(spans, dsn) {
    var headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) {
        headers.dsn = (0,esm_dsn/* dsnToString */.RA)(dsn);
    }
    var items = spans.map(createSpanItem);
    return (0,envelope/* createEnvelope */.Jd)(headers, items);
}
function createSpanItem(span) {
    var spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        span
    ];
}
 //# sourceMappingURL=span.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(76190);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/measurement.js
var measurement = __webpack_require__(99770);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/hasTracingEnabled.js
var hasTracingEnabled = __webpack_require__(67007);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/sampling.js
var sampling = __webpack_require__(4249);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(96233);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(41413);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(92957);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/url.js
var url = __webpack_require__(57323);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/common/debug-build.js
var debug_build = __webpack_require__(4395);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/instrument.js + 11 modules
var instrument = __webpack_require__(56534);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/types.js
var types = __webpack_require__(76292);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js
var getVisibilityWatcher = __webpack_require__(33191);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */ 

function isMeasurementValue(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function _startChild(transaction, _param) {
    var startTimestamp = _param.startTimestamp, ctx = (0,_object_without_properties/* default */.Z)(_param, [
        "startTimestamp"
    ]);
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.startTimestamp = startTimestamp;
    }
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild((0,_object_spread/* default */.Z)({
        startTimestamp: startTimestamp
    }, ctx));
}
 //# sourceMappingURL=utils.js.map

// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js
var getNavigationEntry = __webpack_require__(64687);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/metrics/index.js









var MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function msToSec(time) {
    return time / 1000;
}
function getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return types/* WINDOW */.m && types/* WINDOW.addEventListener */.m.addEventListener && types/* WINDOW.performance */.m.performance;
}
var _performanceCursor = 0;
var _measurements = {};
var _lcpEntry;
var _clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function startTrackingWebVitals() {
    var performance = getBrowserPerformanceAPI();
    if (performance && time/* browserPerformanceTimeOrigin */.Z1) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) {
            types/* WINDOW.performance.mark */.m.performance.mark("sentry-tracing-init");
        }
        var fidCallback = _trackFID();
        var clsCallback = _trackCLS();
        var lcpCallback = _trackLCP();
        var ttfbCallback = _trackTtfb();
        return function() {
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return function() {
        return undefined;
    };
}
/**
 * Start tracking long tasks.
 */ function startTrackingLongTasks() {
    (0,instrument/* addPerformanceInstrumentationHandler */._j)("longtask", function(param) {
        var entries = param.entries;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                // eslint-disable-next-line deprecation/deprecation
                var transaction = (0,utils/* getActiveTransaction */.x1)();
                if (!transaction) {
                    return;
                }
                var startTime = msToSec(time/* browserPerformanceTimeOrigin */.Z1 + entry.startTime);
                var duration = msToSec(entry.duration);
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild({
                    description: "Main UI thread blocked",
                    op: "ui.long-task",
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
/**
 * Start tracking interaction events.
 */ function startTrackingInteractions() {
    (0,instrument/* addPerformanceInstrumentationHandler */._j)("event", function(param) {
        var entries = param.entries;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                // eslint-disable-next-line deprecation/deprecation
                var transaction = (0,utils/* getActiveTransaction */.x1)();
                if (!transaction) {
                    return;
                }
                if (entry.name === "click") {
                    var startTime = msToSec(time/* browserPerformanceTimeOrigin */.Z1 + entry.startTime);
                    var duration = msToSec(entry.duration);
                    var span = {
                        description: (0,browser/* htmlTreeAsString */.Rt)(entry.target),
                        op: "ui.interaction.".concat(entry.name),
                        origin: "auto.ui.browser.metrics",
                        startTimestamp: startTime,
                        endTimestamp: startTime + duration
                    };
                    var componentName = (0,browser/* getComponentName */.iY)(entry.target);
                    if (componentName) {
                        span.attributes = {
                            "ui.component_name": componentName
                        };
                    }
                    // eslint-disable-next-line deprecation/deprecation
                    transaction.startChild(span);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function startTrackingINP(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    var performance = getBrowserPerformanceAPI();
    if (performance && time/* browserPerformanceTimeOrigin */.Z1) {
        var inpCallback = _trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return function() {
            inpCallback();
        };
    }
    return function() {
        return undefined;
    };
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function _trackCLS() {
    return (0,instrument/* addClsInstrumentationHandler */.PR)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) {
            return;
        }
        debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Measurements] Adding CLS");
        _measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        _clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function _trackLCP() {
    return (0,instrument/* addLcpInstrumentationHandler */.$A)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) {
            return;
        }
        debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Measurements] Adding LCP");
        _measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        _lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function _trackFID() {
    return (0,instrument/* addFidInstrumentationHandler */.to)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) {
            return;
        }
        var timeOrigin = msToSec(time/* browserPerformanceTimeOrigin */.Z1);
        var startTime = msToSec(entry.startTime);
        debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Measurements] Adding FID");
        _measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        _measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function _trackTtfb() {
    return (0,instrument/* addTtfbInstrumentationHandler */._4)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) {
            return;
        }
        debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Measurements] Adding TTFB");
        _measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
var INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function _trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0,instrument/* addInpInstrumentationHandler */.YF)(function(param) {
        var metric = param.metric;
        if (metric.value === undefined) {
            return;
        }
        var entry = metric.entries.find(function(entry) {
            return entry.duration === metric.value && INP_ENTRY_MAP[entry.name] !== undefined;
        });
        var client = (0,esm_exports/* getClient */.s3)();
        if (!entry || !client) {
            return;
        }
        var interactionType = INP_ENTRY_MAP[entry.name];
        var options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ var startTime = msToSec(time/* browserPerformanceTimeOrigin */.Z1 + entry.startTime);
        var duration = msToSec(metric.value);
        var interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) {
            return;
        }
        var routeName = interaction.routeName, parentContext = interaction.parentContext, activeTransaction = interaction.activeTransaction, user = interaction.user, replayId = interaction.replayId;
        var userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        var profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        var span = new tracing_span/* Span */.D({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: "ui.interaction.".concat(interactionType),
            name: (0,browser/* htmlTreeAsString */.Rt)(entry.target),
            attributes: (0,_object_spread/* default */.Z)({
                release: options.release,
                environment: options.environment,
                transaction: routeName
            }, userDisplay !== undefined && userDisplay !== "" ? {
                user: userDisplay
            } : {}, profileId !== undefined ? {
                profile_id: profileId
            } : {}, replayId !== undefined ? {
                replay_id: replayId
            } : {}),
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: "millisecond"
                }
            }
        });
        /** Check to see if the span should be sampled */ var sampleRate = getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) {
            return;
        }
        if (Math.random() < sampleRate) {
            var envelope = span ? createSpanEnvelope([
                span
            ], client.getDsn()) : undefined;
            var transport = client && client.getTransport();
            if (transport && envelope) {
                transport.send(envelope).then(null, function(reason) {
                    debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error("Error while sending interaction:", reason);
                });
            }
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function addPerformanceEntries(transaction) {
    var performance = getBrowserPerformanceAPI();
    if (!performance || !types/* WINDOW.performance.getEntries */.m.performance.getEntries || !time/* browserPerformanceTimeOrigin */.Z1) {
        // Gatekeeper if performance API not available
        return;
    }
    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Tracing] Adding & adjusting spans using Performance API");
    var timeOrigin = msToSec(time/* browserPerformanceTimeOrigin */.Z1);
    var performanceEntries = performance.getEntries();
    var ref = (0,spanUtils/* spanToJSON */.XU)(transaction), op = ref.op, transactionStartTime = ref.start_timestamp;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice(_performanceCursor).forEach(function(entry) {
        var startTime = msToSec(entry.startTime);
        var duration = msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) {
            return;
        }
        switch(entry.entryType){
            case "navigation":
                {
                    _addNavigationSpans(transaction, entry, timeOrigin);
                    break;
                }
            case "mark":
            case "paint":
            case "measure":
                {
                    _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    var firstHidden = (0,getVisibilityWatcher/* getVisibilityWatcher */.Y)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Measurements] Adding FP");
                        _measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Measurements] Adding FCP");
                        _measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                {
                    _addResourceSpans(transaction, entry, entry.name, startTime, duration, timeOrigin);
                    break;
                }
        }
    });
    _performanceCursor = Math.max(performanceEntries.length - 1, 0);
    _trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        _addTtfbRequestTimeToMeasurements(_measurements);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach(function(name) {
            if (!_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) {
                return;
            }
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            var oldValue = _measurements[name].value;
            var measurementTimestamp = timeOrigin + msToSec(oldValue);
            // normalizedValue should be in milliseconds
            var normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            var delta = normalizedValue - oldValue;
            debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Measurements] Normalized ".concat(name, " from ").concat(oldValue, " to ").concat(normalizedValue, " (").concat(delta, ")"));
            _measurements[name].value = normalizedValue;
        });
        var fidMark = _measurements["mark.fid"];
        if (fidMark && _measurements["fid"]) {
            // create span for FID
            _startChild(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + msToSec(_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete _measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in _measurements)) {
            delete _measurements.cls;
        }
        Object.keys(_measurements).forEach(function(measurementName) {
            (0,measurement/* setMeasurement */.o)(measurementName, _measurements[measurementName].value, _measurements[measurementName].unit);
        });
        _tagMetricInfo(transaction);
    }
    _lcpEntry = undefined;
    _clsEntry = undefined;
    _measurements = {};
}
/** Create measure related spans */ function _addMeasureSpans(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    var measureStartTimestamp = timeOrigin + startTime;
    var measureEndTimestamp = measureStartTimestamp + duration;
    _startChild(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach(function(event) {
        _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    _addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    _addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    _addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    _addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function _addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    var end = eventEnd ? entry[eventEnd] : entry["".concat(event, "End")];
    var start = entry["".concat(event, "Start")];
    if (!start || !end) {
        return;
    }
    _startChild(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + msToSec(start),
        endTimestamp: timeOrigin + msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        _startChild(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + msToSec(entry.requestStart),
            endTimestamp: timeOrigin + msToSec(entry.responseEnd)
        });
        _startChild(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + msToSec(entry.responseStart),
            endTimestamp: timeOrigin + msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function _addResourceSpans(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") {
        return;
    }
    var parsedUrl = (0,url/* parseUrl */.en)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var data = {};
    setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) {
        data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    }
    if (parsedUrl.protocol) {
        data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    }
    if (parsedUrl.host) {
        data["server.address"] = parsedUrl.host;
    }
    data["url.same_origin"] = resourceUrl.includes(types/* WINDOW.location.origin */.m.location.origin);
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    _startChild(transaction, {
        description: resourceUrl.replace(types/* WINDOW.location.origin */.m.location.origin, ""),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? "resource.".concat(entry.initiatorType) : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function _trackNavigator(transaction) {
    var navigator = types/* WINDOW.navigator */.m.navigator;
    if (!navigator) {
        return;
    }
    // track network connectivity
    var connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) {
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag("effectiveConnectionType", connection.effectiveType);
        }
        if (connection.type) {
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag("connectionType", connection.type);
        }
        if (isMeasurementValue(connection.rtt)) {
            _measurements["connection.rtt"] = {
                value: connection.rtt,
                unit: "millisecond"
            };
        }
    }
    if (isMeasurementValue(navigator.deviceMemory)) {
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("deviceMemory", "".concat(navigator.deviceMemory, " GB"));
    }
    if (isMeasurementValue(navigator.hardwareConcurrency)) {
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
    }
}
/** Add LCP / CLS data to transaction to allow debugging */ function _tagMetricInfo(transaction) {
    if (_lcpEntry) {
        debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if (_lcpEntry.element) {
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag("lcp.element", (0,browser/* htmlTreeAsString */.Rt)(_lcpEntry.element));
        }
        if (_lcpEntry.id) {
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag("lcp.id", _lcpEntry.id);
        }
        if (_lcpEntry.url) {
            // Trim URL to the first 200 characters.
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag("lcp.url", _lcpEntry.url.trim().slice(0, 200));
        }
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", _lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if (_clsEntry && _clsEntry.sources) {
        debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Measurements] Adding CLS Data");
        _clsEntry.sources.forEach(function(source, index) {
            return(// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag("cls.source.".concat(index + 1), (0,browser/* htmlTreeAsString */.Rt)(source.node)));
        });
    }
}
function setResourceEntrySizeData(data, entry, key, dataKey) {
    var entryVal = entry[key];
    if (entryVal != null && entryVal < MAX_INT_AS_BYTES) {
        data[dataKey] = entryVal;
    }
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function _addTtfbRequestTimeToMeasurements(_measurements) {
    var navEntry = (0,getNavigationEntry/* getNavigationEntry */.W)();
    if (!navEntry) {
        return;
    }
    var responseStart = navEntry.responseStart, requestStart = navEntry.requestStart;
    if (requestStart <= responseStart) {
        debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Measurements] Adding TTFB Request Time");
        _measurements["ttfb.requestTime"] = {
            value: responseStart - requestStart,
            unit: "millisecond"
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)(options)) {
        return false;
    }
    var sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            transactionContext: transactionContext,
            name: transactionContext.name,
            parentSampled: transactionContext.parentSampled,
            attributes: (0,_object_spread/* default */.Z)({}, transactionContext.data, transactionContext.attributes),
            location: types/* WINDOW.location */.m.location
        });
    } else if (transactionContext !== undefined && transactionContext.sampled !== undefined) {
        sampleRate = transactionContext.sampled;
    } else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
    } else {
        sampleRate = 1;
    }
    if (!(0,sampling/* isValidSampleRate */.X)(sampleRate)) {
        debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("[Tracing] Discarding interaction span because of invalid sample rate.");
        return false;
    }
    if (sampleRate === true) {
        return interactionsSampleRate;
    } else if (sampleRate === false) {
        return 0;
    }
    return sampleRate * interactionsSampleRate;
}
 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 24366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k3": function() { return /* binding */ defaultRequestInstrumentationOptions; },
  "L7": function() { return /* binding */ instrumentOutgoingRequests; }
});

// UNUSED EXPORTS: DEFAULT_TRACE_PROPAGATION_TARGETS, extractNetworkProtocol, shouldAttachHeaders, xhrCallback

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(76190);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/hasTracingEnabled.js
var hasTracingEnabled = __webpack_require__(67007);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/spanstatus.js
var spanstatus = __webpack_require__(86912);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(77668);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(19217);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/trace.js
var trace = __webpack_require__(19381);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(91292);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/dynamicSamplingContext.js
var dynamicSamplingContext = __webpack_require__(63055);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument/fetch.js
var fetch = __webpack_require__(99096);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/url.js
var esm_url = __webpack_require__(57323);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument/xhr.js
var instrument_xhr = __webpack_require__(33224);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var esm_time = __webpack_require__(96233);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(68813);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/tracing.js
var tracing = __webpack_require__(84907);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/baggage.js
var baggage = __webpack_require__(50257);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(74020);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/common/fetch.js






/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    var spanOrigin = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "auto.http.browser";
    if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)() || !handlerData.fetchData) {
        return undefined;
    }
    var shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        var spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        var span = spans[spanId];
        if (span) {
            endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    var scope = (0,esm_exports/* getCurrentScope */.nZ)();
    var client = (0,esm_exports/* getClient */.s3)();
    var _fetchData = handlerData.fetchData, method = _fetchData.method, url = _fetchData.url;
    var fullUrl = getFullURL(url);
    var host = fullUrl ? (0,esm_url/* parseUrl */.en)(fullUrl).host : undefined;
    var span1 = shouldCreateSpanResult ? (0,trace/* startInactiveSpan */.qp)({
        name: "".concat(method, " ").concat(url),
        onlyIfParent: true,
        attributes: (0,_define_property/* default */.Z)({
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host
        }, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3, spanOrigin),
        op: "http.client"
    }) : undefined;
    if (span1) {
        handlerData.fetchData.__span = span1.spanContext().spanId;
        spans[span1.spanContext().spanId] = span1;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        var request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = addTracingHeadersToFetchRequest(request, client, scope, options, span1);
    }
    return span1;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function addTracingHeadersToFetchRequest(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    var span = requestSpan || scope.getSpan();
    var isolationScope = (0,hub/* getIsolationScope */.aF)();
    var ref = (0,_object_spread/* default */.Z)({}, isolationScope.getPropagationContext(), scope.getPropagationContext()), traceId = ref.traceId, spanId = ref.spanId, sampled = ref.sampled, dsc = ref.dsc;
    var sentryTraceHeader = span ? (0,spanUtils/* spanToTraceHeader */.Hb)(span) : (0,tracing/* generateSentryTraceHeader */.$p)(traceId, spanId, sampled);
    var sentryBaggageHeader = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(dsc || (span ? (0,dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(span) : (0,dynamicSamplingContext/* getDynamicSamplingContextFromClient */._)(traceId, client, scope)));
    var headers = options.headers || (typeof Request !== "undefined" && (0,is/* isInstanceOf */.V9)(request, Request) ? request.headers : undefined);
    if (!headers) {
        return {
            "sentry-trace": sentryTraceHeader,
            baggage: sentryBaggageHeader
        };
    } else if (typeof Headers !== "undefined" && (0,is/* isInstanceOf */.V9)(headers, Headers)) {
        var newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) {
            // If the same header is appended multiple times the browser will merge the values into a single request header.
            // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
            newHeaders.append(baggage/* BAGGAGE_HEADER_NAME */.bU, sentryBaggageHeader);
        }
        return newHeaders;
    } else if (Array.isArray(headers)) {
        var newHeaders1 = (0,_to_consumable_array/* default */.Z)(headers).concat([
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ]);
        if (sentryBaggageHeader) {
            // If there are multiple entries with the same key, the browser will merge the values into a single request header.
            // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
            newHeaders1.push([
                baggage/* BAGGAGE_HEADER_NAME */.bU,
                sentryBaggageHeader
            ]);
        }
        return newHeaders1;
    } else {
        var existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        var newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) {
            var _newBaggageHeaders;
            (_newBaggageHeaders = newBaggageHeaders).push.apply(_newBaggageHeaders, (0,_to_consumable_array/* default */.Z)(existingBaggageHeader));
        } else if (existingBaggageHeader) {
            newBaggageHeaders.push(existingBaggageHeader);
        }
        if (sentryBaggageHeader) {
            newBaggageHeaders.push(sentryBaggageHeader);
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headers), {
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        });
    }
}
function getFullURL(url) {
    try {
        var parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function endSpan(span, handlerData) {
    if (handlerData.response) {
        (0,spanstatus/* setHttpStatus */.Q0)(span, handlerData.response.status);
        var contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            var contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) {
                span.setAttribute("http.response_content_length", contentLengthNum);
            }
        }
    } else if (handlerData.error) {
        span.setStatus("internal_error");
    }
    span.end();
}
 //# sourceMappingURL=fetch.js.map

// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/instrument.js + 11 modules
var instrument = __webpack_require__(56534);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/types.js
var types = __webpack_require__(76292);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/request.js









/* eslint-disable max-lines */ var DEFAULT_TRACE_PROPAGATION_TARGETS = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ var defaultRequestInstrumentationOptions = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
    tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS
};
/** Registers span creators for xhr and fetch requests  */ function instrumentOutgoingRequests(_options) {
    var ref = (0,_object_spread/* default */.Z)({
        traceFetch: defaultRequestInstrumentationOptions.traceFetch,
        traceXHR: defaultRequestInstrumentationOptions.traceXHR
    }, _options), traceFetch = ref.traceFetch, traceXHR = ref.traceXHR, // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets = ref.tracePropagationTargets, // eslint-disable-next-line deprecation/deprecation
    tracingOrigins = ref.tracingOrigins, shouldCreateSpanForRequest = ref.shouldCreateSpanForRequest, enableHTTPTimings = ref.enableHTTPTimings;
    var shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : function(_) {
        return true;
    };
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    var shouldAttachHeadersWithTargets = function(url) {
        return shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);
    };
    var spans = {};
    if (traceFetch) {
        (0,fetch/* addFetchInstrumentationHandler */.U)(function(handlerData) {
            var createdSpan = instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                var fullUrl = request_getFullURL(handlerData.fetchData.url);
                var host = fullUrl ? (0,esm_url/* parseUrl */.en)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    "http.url": fullUrl,
                    "server.address": host
                });
            }
            if (enableHTTPTimings && createdSpan) {
                addHTTPTimings(createdSpan);
            }
        });
    }
    if (traceXHR) {
        (0,instrument_xhr/* addXhrInstrumentationHandler */.UK)(function(handlerData) {
            var createdSpan = xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
            if (enableHTTPTimings && createdSpan) {
                addHTTPTimings(createdSpan);
            }
        });
    }
}
function isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function addHTTPTimings(span) {
    var url = ((0,spanUtils/* spanToJSON */.XU)(span).data || {}).url;
    if (!url || typeof url !== "string") {
        return;
    }
    var cleanup = (0,instrument/* addPerformanceInstrumentationHandler */._j)("resource", function(param) {
        var entries = param.entries;
        entries.forEach(function(entry) {
            if (isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                var _span;
                var spanData = resourceTimingEntryToSpanData(entry);
                spanData.forEach(function(data) {
                    return (_span = span).setAttribute.apply(_span, (0,_to_consumable_array/* default */.Z)(data));
                });
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function extractNetworkProtocol(nextHopProtocol) {
    var name = "unknown";
    var version = "unknown";
    var _name = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = nextHopProtocol[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var char = _step.value;
            // http/1.1 etc.
            if (char === "/") {
                var ref;
                ref = (0,_sliced_to_array/* default */.Z)(nextHopProtocol.split("/"), 2), name = ref[0], version = ref[1], ref;
                break;
            }
            // h2, h3 etc.
            if (!isNaN(Number(char))) {
                name = _name === "h" ? "http" : _name;
                version = nextHopProtocol.split(_name)[1];
                break;
            }
            _name += char;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (_name === nextHopProtocol) {
        // webrtc, ftp, etc.
        name = _name;
    }
    return {
        name: name,
        version: version
    };
}
function getAbsoluteTime() {
    var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return ((esm_time/* browserPerformanceTimeOrigin */.Z1 || performance.timeOrigin) + time) / 1000;
}
function resourceTimingEntryToSpanData(resourceTiming) {
    var ref = extractNetworkProtocol(resourceTiming.nextHopProtocol), name = ref.name, version = ref.version;
    var timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!esm_time/* browserPerformanceTimeOrigin */.Z1) {
        return timingSpanData;
    }
    return (0,_to_consumable_array/* default */.Z)(timingSpanData).concat([
        [
            "http.request.redirect_start",
            getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            getAbsoluteTime(resourceTiming.responseEnd)
        ], 
    ]);
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function shouldAttachHeaders(url, tracePropagationTargets) {
    return (0,string/* stringMatchesSomePattern */.U0)(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    var xhr = handlerData.xhr;
    var sentryXhrData = xhr && xhr[instrument_xhr/* SENTRY_XHR_DATA_KEY */.xU];
    if (!(0,hasTracingEnabled/* hasTracingEnabled */.z)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) {
        return undefined;
    }
    var shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        var spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        var span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0,spanstatus/* setHttpStatus */.Q0)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    var scope = (0,esm_exports/* getCurrentScope */.nZ)();
    var isolationScope = (0,hub/* getIsolationScope */.aF)();
    var fullUrl = request_getFullURL(sentryXhrData.url);
    var host = fullUrl ? (0,esm_url/* parseUrl */.en)(fullUrl).host : undefined;
    var span1 = shouldCreateSpanResult ? (0,trace/* startInactiveSpan */.qp)({
        name: "".concat(sentryXhrData.method, " ").concat(sentryXhrData.url),
        onlyIfParent: true,
        attributes: (0,_define_property/* default */.Z)({
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host
        }, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3, "auto.http.browser"),
        op: "http.client"
    }) : undefined;
    if (span1) {
        xhr.__sentry_xhr_span_id__ = span1.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span1;
    }
    var client = (0,esm_exports/* getClient */.s3)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        var ref = (0,_object_spread/* default */.Z)({}, isolationScope.getPropagationContext(), scope.getPropagationContext()), traceId = ref.traceId, spanId1 = ref.spanId, sampled = ref.sampled, dsc = ref.dsc;
        var sentryTraceHeader = span1 ? (0,spanUtils/* spanToTraceHeader */.Hb)(span1) : (0,tracing/* generateSentryTraceHeader */.$p)(traceId, spanId1, sampled);
        var sentryBaggageHeader = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(dsc || (span1 ? (0,dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(span1) : (0,dynamicSamplingContext/* getDynamicSamplingContextFromClient */._)(traceId, client, scope)));
        setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span1;
}
function setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) {
            // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
            // We can therefore simply set a baggage header without checking what was there before
            // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            xhr.setRequestHeader(baggage/* BAGGAGE_HEADER_NAME */.bU, sentryBaggageHeader);
        }
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function request_getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        var parsed = new URL(url, types/* WINDOW.location.origin */.m.location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
 //# sourceMappingURL=request.js.map


/***/ }),

/***/ 76292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ WINDOW; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74672);

var WINDOW = _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2;
 //# sourceMappingURL=types.js.map


/***/ }),

/***/ 64687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getNavigationEntry; }
/* harmony export */ });
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76292);

/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var getNavigationEntryFromPerformanceTiming = function() {
    // eslint-disable-next-line deprecation/deprecation
    var timing = _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.performance.timing */ .m.performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    var type = _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.performance.navigation.type */ .m.performance.navigation.type;
    var navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(var key in timing){
        if (key !== "navigationStart" && key !== "toJSON") {
            // eslint-disable-next-line deprecation/deprecation
            navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
        }
    }
    return navigationEntry;
};
var getNavigationEntry = function() {
    if (_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.__WEB_VITALS_POLYFILL__ */ .m.__WEB_VITALS_POLYFILL__) {
        return _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.performance */ .m.performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || getNavigationEntryFromPerformanceTiming());
    } else {
        return _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.performance */ .m.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
    }
};
 //# sourceMappingURL=getNavigationEntry.js.map


/***/ }),

/***/ 33191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ getVisibilityWatcher; }
/* harmony export */ });
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76292);
/* harmony import */ var _onHidden_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96626);


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var firstHiddenTime = -1;
var initHiddenTime = function() {
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if (_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document */ .m.document && _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document.visibilityState */ .m.document.visibilityState) {
        firstHiddenTime = _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document.visibilityState */ .m.document.visibilityState === "hidden" && !_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document.prerendering */ .m.document.prerendering ? 0 : Infinity;
    }
};
var trackChanges = function() {
    // Update the time if/when the document becomes hidden.
    (0,_onHidden_js__WEBPACK_IMPORTED_MODULE_1__/* .onHidden */ .u)(function(param) {
        var timeStamp = param.timeStamp;
        firstHiddenTime = timeStamp;
    }, true);
};
var getVisibilityWatcher = function() {
    if (firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        initHiddenTime();
        trackChanges();
    }
    return {
        get firstHiddenTime () {
            return firstHiddenTime;
        }
    };
};
 //# sourceMappingURL=getVisibilityWatcher.js.map


/***/ }),

/***/ 96626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ onHidden; }
/* harmony export */ });
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76292);

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var onHidden = function(cb, once) {
    var onHiddenOrPageHide = function(event) {
        if (event.type === "pagehide" || _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document.visibilityState */ .m.document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    if (_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document */ .m.document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};
 //# sourceMappingURL=onHidden.js.map


/***/ }),

/***/ 4395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var DEBUG_BUILD =  false || false;
 //# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 4973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ BrowserClient; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get.mjs + 1 modules
var _get = __webpack_require__(45785);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/sdkMetadata.js
var sdkMetadata = __webpack_require__(88633);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/baseclient.js + 1 modules
var baseclient = __webpack_require__(99892);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/env.js
var env = __webpack_require__(87840);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(92957);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/envelope.js
var envelope = __webpack_require__(62486);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(96233);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/clientreport.js


/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function createClientReportEnvelope(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
            discarded_events: discarded_events
        }, 
    ];
    return (0,envelope/* createEnvelope */.Jd)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
 //# sourceMappingURL=clientreport.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/dsn.js
var dsn = __webpack_require__(74094);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/debug-build.js
var debug_build = __webpack_require__(53289);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js
var eventbuilder = __webpack_require__(50376);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(50203);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/userfeedback.js
var userfeedback = __webpack_require__(51339);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/client.js












/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var BrowserClient = /*#__PURE__*/ function(BaseClient) {
    "use strict";
    (0,_inherits/* default */.Z)(BrowserClient, BaseClient);
    var _super = (0,_create_super/* default */.Z)(BrowserClient);
    function BrowserClient(options) {
        (0,_class_call_check/* default */.Z)(this, BrowserClient);
        var _this;
        var sdkSource = helpers/* WINDOW.SENTRY_SDK_SOURCE */.m9.SENTRY_SDK_SOURCE || (0,env/* getSDKSource */.S)();
        (0,sdkMetadata/* applySdkMetadata */.V)(options, "browser", [
            "browser"
        ], sdkSource);
        _this = _super.call(this, options);
        if (options.sendClientReports && helpers/* WINDOW.document */.m9.document) {
            helpers/* WINDOW.document.addEventListener */.m9.document.addEventListener("visibilitychange", function() {
                if (helpers/* WINDOW.document.visibilityState */.m9.document.visibilityState === "hidden") {
                    _this._flushOutcomes();
                }
            });
        }
        return _this;
    }
    (0,_create_class/* default */.Z)(BrowserClient, [
        {
            /**
   * @inheritDoc
   */ key: "eventFromException",
            value: function eventFromException1(exception, hint) {
                return (0,eventbuilder/* eventFromException */.dr)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "eventFromMessage",
            value: function eventFromMessage1(message) {
                var // eslint-disable-next-line deprecation/deprecation
                level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "info", hint = arguments.length > 2 ? arguments[2] : void 0;
                return (0,eventbuilder/* eventFromMessage */.aB)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
            }
        },
        {
            /**
   * Sends user feedback to Sentry.
   */ key: "captureUserFeedback",
            value: function captureUserFeedback(feedback) {
                if (!this._isEnabled()) {
                    debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("SDK not enabled, will not capture user feedback.");
                    return;
                }
                var envelope = (0,userfeedback/* createUserFeedbackEnvelope */.r)(feedback, {
                    metadata: this.getSdkMetadata(),
                    dsn: this.getDsn(),
                    tunnel: this.getOptions().tunnel
                });
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(envelope);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "_prepareEvent",
            value: function _prepareEvent(event, hint, scope) {
                event.platform = event.platform || "javascript";
                return (0,_get/* default */.Z)((0,_get_prototype_of/* default */.Z)(BrowserClient.prototype), "_prepareEvent", this).call(this, event, hint, scope);
            }
        },
        {
            /**
   * Sends client reports as an envelope.
   */ key: "_flushOutcomes",
            value: function _flushOutcomes() {
                var outcomes = this._clearOutcomes();
                if (outcomes.length === 0) {
                    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("No outcomes to send");
                    return;
                }
                // This is really the only place where we want to check for a DSN and only send outcomes then
                if (!this._dsn) {
                    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("No dsn provided, will not send outcomes");
                    return;
                }
                debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("Sending outcomes:", outcomes);
                var envelope = createClientReportEnvelope(outcomes, this._options.tunnel && (0,dsn/* dsnToString */.RA)(this._dsn));
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(envelope);
            }
        }
    ]);
    return BrowserClient;
}(baseclient/* BaseClient */.W);
 //# sourceMappingURL=client.js.map


/***/ }),

/***/ 53289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var DEBUG_BUILD =  false || false;
 //# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 50376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GJ": function() { return /* binding */ exceptionFromError; },
/* harmony export */   "ME": function() { return /* binding */ eventFromUnknownInput; },
/* harmony export */   "aB": function() { return /* binding */ eventFromMessage; },
/* harmony export */   "dr": function() { return /* binding */ eventFromException; }
/* harmony export */ });
/* unused harmony exports eventFromError, eventFromPlainObject, eventFromString, parseStackFrames */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77668);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74020);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92276);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11591);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21200);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27389);




/**
 * This function creates an exception from a JavaScript Error
 */ function exceptionFromError(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = parseStackFrames(stackParser, ex);
    var exception = {
        type: ex && ex.name,
        value: extractMessage(ex)
    };
    if (frames.length) {
        exception.stacktrace = {
            frames: frames
        };
    }
    if (exception.type === undefined && exception.value === "") {
        exception.value = "Unrecoverable error caught";
    }
    return exception;
}
/**
 * @hidden
 */ function eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    var client = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .s3)();
    var normalizeDepth = client && client.getOptions().normalizeDepth;
    var event = {
        exception: {
            values: [
                {
                    type: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isEvent */ .cO)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }, 
            ]
        },
        extra: {
            __serialized__: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .normalizeToSize */ .Qy)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        var frames = parseStackFrames(stackParser, syntheticException);
        if (frames.length) {
            // event.exception.values[0] has been set above
            event.exception.values[0].stacktrace = {
                frames: frames
            };
        }
    }
    return event;
}
/**
 * @hidden
 */ function eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                exceptionFromError(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || "";
    var popSize = getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
function getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") {
            return ex.framesToPop;
        }
        if (reactMinifiedRegexp.test(ex.message)) {
            return 1;
        }
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return "No error message";
    }
    if (message.error && typeof message.error.message === "string") {
        return message.error.message;
    }
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function eventFromException(stackParser, exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .resolvedSyncPromise */ .WD)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function eventFromMessage(stackParser, message) {
    var // eslint-disable-next-line deprecation/deprecation
    level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "info", hint = arguments.length > 3 ? arguments[3] : void 0, attachStacktrace = arguments.length > 4 ? arguments[4] : void 0;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .resolvedSyncPromise */ .WD)(event);
}
/**
 * @hidden
 */ function eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isErrorEvent */ .VW)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isDOMError */ .TX)(exception) || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isDOMException */ .fm)(exception)) {
        var domException = exception;
        if ("stack" in exception) {
            event = eventFromError(stackParser, exception);
        } else {
            var name = domException.name || ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isDOMError */ .TX)(domException) ? "DOMError" : "DOMException");
            var message = domException.message ? "".concat(name, ": ").concat(domException.message) : name;
            event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionTypeValue */ .Db)(event, message);
        }
        if ("code" in domException) {
            // eslint-disable-next-line deprecation/deprecation
            event.tags = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, event.tags), {
                "DOMException.code": "".concat(domException.code)
            });
        }
        return event;
    }
    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isError */ .VZ)(exception)) {
        // we have a real Error object, do nothing
        return eventFromError(stackParser, exception);
    }
    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(exception) || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isEvent */ .cO)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionTypeValue */ .Db)(event, "".concat(exception), undefined);
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    var event = {};
    if (attachStacktrace && syntheticException) {
        var frames = parseStackFrames(stackParser, syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
        }
    }
    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isParameterizedString */ .Le)(message)) {
        var __sentry_template_string__ = message.__sentry_template_string__, __sentry_template_values__ = message.__sentry_template_values__;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function getNonErrorObjectExceptionValue(exception, param) {
    var isUnhandledRejection = param.isUnhandledRejection;
    var keys = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .extractExceptionKeysForMessage */ .zf)(exception);
    var captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isErrorEvent */ .VW)(exception)) {
        return "Event `ErrorEvent` captured as ".concat(captureType, " with message `").concat(exception.message, "`");
    }
    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isEvent */ .cO)(exception)) {
        var className = getObjectClassName(exception);
        return "Event `".concat(className, "` (type=").concat(exception.type, ") captured as ").concat(captureType);
    }
    return "Object captured as ".concat(captureType, " with keys: ").concat(keys);
}
function getObjectClassName(obj) {
    try {
        var prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
 //# sourceMappingURL=eventbuilder.js.map


/***/ }),

/***/ 50203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wz": function() { return /* binding */ shouldIgnoreOnError; },
/* harmony export */   "m9": function() { return /* binding */ WINDOW; },
/* harmony export */   "re": function() { return /* binding */ wrap; }
/* harmony export */ });
/* unused harmony export ignoreNextOnError */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77668);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74672);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27389);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11591);





var WINDOW = _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2;
var ignoreOnError = 0;
/**
 * @hidden
 */ function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */ function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError++;
    setTimeout(function() {
        ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function wrap(fn) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, before = arguments.length > 2 ? arguments[2] : void 0;
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") {
        return fn;
    }
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") {
                return wrapper;
            } else {
                // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
                // that something messed with it. In that case we want to return the originally passed function.
                return fn;
            }
        }
        // We don't wanna wrap it twice
        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getOriginalFunction */ .HK)(fn)) {
            return fn;
        }
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    var sentryWrapped = function sentryWrapped() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") {
                before.apply(this, arguments);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return wrap(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            ignoreNextOnError();
            (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .withScope */ .$e)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionTypeValue */ .Db)(event, undefined, undefined);
                        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .EG)(event, options.mechanism);
                    }
                    event.extra = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn){
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .markFunctionWrapped */ .$Q)(sentryWrapped, fn);
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, "name", {
                get: function get() {
                    return fn.name;
                }
            });
        }
    // eslint-disable-next-line no-empty
    } catch (_oO1) {}
    return sentryWrapped;
}
 //# sourceMappingURL=helpers.js.map


/***/ }),

/***/ 21986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Breadcrumbs": function() { return /* reexport */ breadcrumbs/* Breadcrumbs */.O; },
  "BrowserClient": function() { return /* reexport */ client/* BrowserClient */.R; },
  "BrowserProfilingIntegration": function() { return /* reexport */ BrowserProfilingIntegration; },
  "BrowserTracing": function() { return /* reexport */ browsertracing/* BrowserTracing */.gE; },
  "Dedupe": function() { return /* reexport */ dedupe/* Dedupe */.I; },
  "Feedback": function() { return /* reexport */ Feedback; },
  "FunctionToString": function() { return /* reexport */ functiontostring/* FunctionToString */.c; },
  "GlobalHandlers": function() { return /* reexport */ globalhandlers/* GlobalHandlers */.d; },
  "HttpContext": function() { return /* reexport */ httpcontext/* HttpContext */.q; },
  "Hub": function() { return /* reexport */ hub/* Hub */.Xb; },
  "InboundFilters": function() { return /* reexport */ inboundfilters/* InboundFilters */.Q; },
  "Integrations": function() { return /* binding */ INTEGRATIONS; },
  "LinkedErrors": function() { return /* reexport */ linkederrors/* LinkedErrors */.i; },
  "ModuleMetadata": function() { return /* reexport */ ModuleMetadata; },
  "Replay": function() { return /* reexport */ esm/* InternalReplay */.Le; },
  "ReplayCanvas": function() { return /* reexport */ ReplayCanvas; },
  "SDK_VERSION": function() { return /* reexport */ version/* SDK_VERSION */.J; },
  "SEMANTIC_ATTRIBUTE_SENTRY_OP": function() { return /* reexport */ semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J; },
  "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN": function() { return /* reexport */ semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3; },
  "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE": function() { return /* reexport */ semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */.TE; },
  "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE": function() { return /* reexport */ semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj; },
  "Scope": function() { return /* reexport */ scope/* Scope */.sX; },
  "TryCatch": function() { return /* reexport */ trycatch/* TryCatch */.p; },
  "WINDOW": function() { return /* reexport */ helpers/* WINDOW */.m9; },
  "addBreadcrumb": function() { return /* reexport */ esm_exports/* addBreadcrumb */.n_; },
  "addEventProcessor": function() { return /* reexport */ baseclient/* addEventProcessor */.Q; },
  "addGlobalEventProcessor": function() { return /* reexport */ eventProcessors/* addGlobalEventProcessor */.cc; },
  "addIntegration": function() { return /* reexport */ integration/* addIntegration */.M5; },
  "addTracingExtensions": function() { return /* reexport */ hubextensions/* addTracingExtensions */.T; },
  "breadcrumbsIntegration": function() { return /* reexport */ breadcrumbs/* breadcrumbsIntegration */.f; },
  "browserApiErrorsIntegration": function() { return /* reexport */ trycatch/* browserApiErrorsIntegration */.t; },
  "browserProfilingIntegration": function() { return /* reexport */ browserProfilingIntegration; },
  "browserTracingIntegration": function() { return /* reexport */ browserTracingIntegration/* browserTracingIntegration */.E8; },
  "captureConsoleIntegration": function() { return /* reexport */ captureConsoleIntegration; },
  "captureEvent": function() { return /* reexport */ esm_exports/* captureEvent */.eN; },
  "captureException": function() { return /* reexport */ esm_exports/* captureException */.Tb; },
  "captureMessage": function() { return /* reexport */ esm_exports/* captureMessage */.uT; },
  "captureSession": function() { return /* reexport */ esm_exports/* captureSession */.cg; },
  "captureUserFeedback": function() { return /* reexport */ esm_sdk/* captureUserFeedback */.Jd; },
  "chromeStackLineParser": function() { return /* reexport */ stack_parsers/* chromeStackLineParser */.$3; },
  "close": function() { return /* reexport */ esm_exports/* close */.xv; },
  "configureScope": function() { return /* reexport */ esm_exports/* configureScope */.e; },
  "contextLinesIntegration": function() { return /* reexport */ contextLinesIntegration; },
  "continueTrace": function() { return /* reexport */ trace/* continueTrace */.yn; },
  "createTransport": function() { return /* reexport */ base/* createTransport */.q; },
  "createUserFeedbackEnvelope": function() { return /* reexport */ userfeedback/* createUserFeedbackEnvelope */.r; },
  "debugIntegration": function() { return /* reexport */ debugIntegration; },
  "dedupeIntegration": function() { return /* reexport */ dedupeIntegration; },
  "defaultIntegrations": function() { return /* reexport */ esm_sdk/* defaultIntegrations */.SS; },
  "defaultRequestInstrumentationOptions": function() { return /* reexport */ request/* defaultRequestInstrumentationOptions */.k3; },
  "defaultStackLineParsers": function() { return /* reexport */ stack_parsers/* defaultStackLineParsers */.d8; },
  "defaultStackParser": function() { return /* reexport */ stack_parsers/* defaultStackParser */.Dt; },
  "endSession": function() { return /* reexport */ esm_exports/* endSession */.TM; },
  "eventFromException": function() { return /* reexport */ eventbuilder/* eventFromException */.dr; },
  "eventFromMessage": function() { return /* reexport */ eventbuilder/* eventFromMessage */.aB; },
  "exceptionFromError": function() { return /* reexport */ eventbuilder/* exceptionFromError */.GJ; },
  "extraErrorDataIntegration": function() { return /* reexport */ extraErrorDataIntegration; },
  "extractTraceparentData": function() { return /* reexport */ tracing_utils/* extractTraceparentData */.qG; },
  "feedbackIntegration": function() { return /* reexport */ feedbackIntegration; },
  "flush": function() { return /* reexport */ esm_exports/* flush */.yl; },
  "forceLoad": function() { return /* reexport */ esm_sdk/* forceLoad */.Eg; },
  "functionToStringIntegration": function() { return /* reexport */ functiontostring/* functionToStringIntegration */.C; },
  "geckoStackLineParser": function() { return /* reexport */ stack_parsers/* geckoStackLineParser */.$Q; },
  "getActiveSpan": function() { return /* reexport */ trace/* getActiveSpan */.HN; },
  "getActiveTransaction": function() { return /* reexport */ tracing_utils/* getActiveTransaction */.x1; },
  "getClient": function() { return /* reexport */ esm_exports/* getClient */.s3; },
  "getCurrentHub": function() { return /* reexport */ hub/* getCurrentHub */.Gd; },
  "getCurrentScope": function() { return /* reexport */ esm_exports/* getCurrentScope */.nZ; },
  "getDefaultIntegrations": function() { return /* reexport */ esm_sdk/* getDefaultIntegrations */.nV; },
  "getHubFromCarrier": function() { return /* reexport */ hub/* getHubFromCarrier */.vi; },
  "getReplay": function() { return /* reexport */ esm/* internalGetReplay */.Bl; },
  "getSpanStatusFromHttpCode": function() { return /* reexport */ spanstatus/* getSpanStatusFromHttpCode */.ix; },
  "globalHandlersIntegration": function() { return /* reexport */ globalhandlers/* globalHandlersIntegration */.k; },
  "httpClientIntegration": function() { return /* reexport */ httpClientIntegration; },
  "httpContextIntegration": function() { return /* reexport */ httpcontext/* httpContextIntegration */.s; },
  "inboundFiltersIntegration": function() { return /* reexport */ inboundfilters/* inboundFiltersIntegration */.S; },
  "init": function() { return /* reexport */ esm_sdk/* init */.S1; },
  "instrumentOutgoingRequests": function() { return /* reexport */ request/* instrumentOutgoingRequests */.L7; },
  "isInitialized": function() { return /* reexport */ esm_exports/* isInitialized */.dk; },
  "lastEventId": function() { return /* reexport */ esm_exports/* lastEventId */.eW; },
  "linkedErrorsIntegration": function() { return /* reexport */ linkederrors/* linkedErrorsIntegration */.O; },
  "makeBrowserOfflineTransport": function() { return /* reexport */ makeBrowserOfflineTransport; },
  "makeFetchTransport": function() { return /* reexport */ fetch/* makeFetchTransport */.f; },
  "makeMain": function() { return /* reexport */ hub/* makeMain */.pj; },
  "makeMultiplexedTransport": function() { return /* reexport */ makeMultiplexedTransport; },
  "makeXHRTransport": function() { return /* reexport */ xhr/* makeXHRTransport */.K; },
  "metrics": function() { return /* reexport */ metrics; },
  "moduleMetadataIntegration": function() { return /* reexport */ moduleMetadataIntegration; },
  "onLoad": function() { return /* reexport */ esm_sdk/* onLoad */.lA; },
  "onProfilingStartRouteTransaction": function() { return /* reexport */ onProfilingStartRouteTransaction; },
  "opera10StackLineParser": function() { return /* reexport */ stack_parsers/* opera10StackLineParser */.NP; },
  "opera11StackLineParser": function() { return /* reexport */ stack_parsers/* opera11StackLineParser */.HH; },
  "parameterize": function() { return /* reexport */ parameterize; },
  "replayCanvasIntegration": function() { return /* reexport */ replayCanvasIntegration; },
  "replayIntegration": function() { return /* reexport */ esm/* internalReplayIntegration */.Li; },
  "reportingObserverIntegration": function() { return /* reexport */ reportingObserverIntegration; },
  "rewriteFramesIntegration": function() { return /* reexport */ rewriteframes/* rewriteFramesIntegration */.v; },
  "sendFeedback": function() { return /* reexport */ sendFeedback; },
  "sessionTimingIntegration": function() { return /* reexport */ sessionTimingIntegration; },
  "setContext": function() { return /* reexport */ esm_exports/* setContext */.v; },
  "setCurrentClient": function() { return /* reexport */ sdk/* setCurrentClient */.K; },
  "setExtra": function() { return /* reexport */ esm_exports/* setExtra */.sU; },
  "setExtras": function() { return /* reexport */ esm_exports/* setExtras */.rJ; },
  "setHttpStatus": function() { return /* reexport */ spanstatus/* setHttpStatus */.Q0; },
  "setMeasurement": function() { return /* reexport */ measurement/* setMeasurement */.o; },
  "setTag": function() { return /* reexport */ esm_exports/* setTag */.YA; },
  "setTags": function() { return /* reexport */ esm_exports/* setTags */.mG; },
  "setUser": function() { return /* reexport */ esm_exports/* setUser */.av; },
  "showReportDialog": function() { return /* reexport */ esm_sdk/* showReportDialog */.jp; },
  "spanStatusfromHttpCode": function() { return /* reexport */ spanstatus/* spanStatusfromHttpCode */.Zd; },
  "startBrowserTracingNavigationSpan": function() { return /* reexport */ browserTracingIntegration/* startBrowserTracingNavigationSpan */.og; },
  "startBrowserTracingPageLoadSpan": function() { return /* reexport */ browserTracingIntegration/* startBrowserTracingPageLoadSpan */.Wo; },
  "startInactiveSpan": function() { return /* reexport */ trace/* startInactiveSpan */.qp; },
  "startSession": function() { return /* reexport */ esm_exports/* startSession */.yj; },
  "startSpan": function() { return /* reexport */ trace/* startSpan */.GK; },
  "startSpanManual": function() { return /* reexport */ trace/* startSpanManual */.V0; },
  "startTransaction": function() { return /* reexport */ esm_exports/* startTransaction */.Yr; },
  "trace": function() { return /* reexport */ trace/* trace */.g4; },
  "winjsStackLineParser": function() { return /* reexport */ stack_parsers/* winjsStackLineParser */.R2; },
  "withActiveSpan": function() { return /* reexport */ esm_exports/* withActiveSpan */._d; },
  "withIsolationScope": function() { return /* reexport */ esm_exports/* withIsolationScope */.wi; },
  "withScope": function() { return /* reexport */ esm_exports/* withScope */.$e; },
  "wrap": function() { return /* reexport */ esm_sdk/* wrap */.re; }
});

// NAMESPACE OBJECT: ./node_modules/@sentry/core/esm/integrations/index.js
var integrations_namespaceObject = {};
__webpack_require__.r(integrations_namespaceObject);
__webpack_require__.d(integrations_namespaceObject, {
  "FunctionToString": function() { return functiontostring/* FunctionToString */.c; },
  "InboundFilters": function() { return inboundfilters/* InboundFilters */.Q; },
  "LinkedErrors": function() { return LinkedErrors; }
});

// NAMESPACE OBJECT: ./node_modules/@sentry/browser/esm/integrations/index.js
var esm_integrations_namespaceObject = {};
__webpack_require__.r(esm_integrations_namespaceObject);
__webpack_require__.d(esm_integrations_namespaceObject, {
  "Breadcrumbs": function() { return breadcrumbs/* Breadcrumbs */.O; },
  "Dedupe": function() { return dedupe/* Dedupe */.I; },
  "GlobalHandlers": function() { return globalhandlers/* GlobalHandlers */.d; },
  "HttpContext": function() { return httpcontext/* HttpContext */.q; },
  "LinkedErrors": function() { return linkederrors/* LinkedErrors */.i; },
  "TryCatch": function() { return trycatch/* TryCatch */.p; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/integrations/functiontostring.js
var functiontostring = __webpack_require__(97936);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/integrations/inboundfilters.js
var inboundfilters = __webpack_require__(22283);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/aggregate-errors.js
var aggregate_errors = __webpack_require__(6837);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/eventbuilder.js







/**
 * Extracts stack frames from the error.stack string
 */ function parseStackFrames(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function exceptionFromError(stackParser, error) {
    var exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    var frames = parseStackFrames(stackParser, error);
    if (frames.length) {
        exception.stacktrace = {
            frames: frames
        };
    }
    return exception;
}
function getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        var message = "'".concat(exception.name, "' captured as exception");
        if ("message" in exception && typeof exception.message === "string") {
            message += " with message '".concat(exception.message, "'");
        }
        return message;
    } else if ("message" in exception && typeof exception.message === "string") {
        return exception.message;
    } else {
        // This will allow us to group events based on top-level keys
        // which is much better than creating new group when any key/value change
        return "Object captured as exception with keys: ".concat(extractExceptionKeysForMessage(exception));
    }
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function eventFromUnknownInput(// eslint-disable-next-line deprecation/deprecation
getHubOrClient, stackParser, exception, hint) {
    var client = typeof getHubOrClient === "function" ? getHubOrClient().getClient() : getHubOrClient;
    var ex = exception;
    var providedMechanism = hint && hint.data && hint.data.mechanism;
    var mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    var extras;
    if (!isError(exception)) {
        if (isPlainObject(exception)) {
            var normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = _define_property({}, "__serialized__", normalizeToSize(exception, normalizeDepth));
            var message = getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    var event = {
        exception: {
            values: [
                exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) {
        event.extra = extras;
    }
    addExceptionTypeValue(event, undefined, undefined);
    addExceptionMechanism(event, mechanism);
    return _object_spread_props(_object_spread({}, event), {
        event_id: hint && hint.event_id
    });
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function eventFromMessage(stackParser, message) {
    var // eslint-disable-next-line deprecation/deprecation
    level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "info", hint = arguments.length > 3 ? arguments[3] : void 0, attachStacktrace = arguments.length > 4 ? arguments[4] : void 0;
    var event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        var frames = parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }, 
                ]
            };
        }
    }
    if (isParameterizedString(message)) {
        var __sentry_template_string__ = message.__sentry_template_string__, __sentry_template_values__ = message.__sentry_template_values__;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
 //# sourceMappingURL=eventbuilder.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/integration.js
var integration = __webpack_require__(62909);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/linkederrors.js


var DEFAULT_KEY = "cause";
var DEFAULT_LIMIT = 5;
var INTEGRATION_NAME = "LinkedErrors";
var _linkedErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var limit = options.limit || DEFAULT_LIMIT;
    var key = options.key || DEFAULT_KEY;
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        preprocessEvent: function preprocessEvent(event, hint, client) {
            var options = client.getOptions();
            (0,aggregate_errors/* applyAggregateErrorsToEvent */.Z)(exceptionFromError, options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
var linkedErrorsIntegration = (0,integration/* defineIntegration */._I)(_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var LinkedErrors = (0,integration/* convertIntegrationFnToClass */.RN)(INTEGRATION_NAME, linkedErrorsIntegration);
 //# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/index.js


 /* eslint-disable deprecation/deprecation */  //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/index.js














































/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ var Integrations = integrations_namespaceObject;
 //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/envelope.js
var esm_envelope = __webpack_require__(62486);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(74672);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/metadata.js

/** Keys are source filename/url, values are metadata objects. */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var filenameMetadataMap = new Map();
/** Set of stack strings that have already been parsed. */ var parsedStacks = new Set();
function ensureMetadataStacksAreParsed(parser) {
    if (!worldwide/* GLOBAL_OBJ._sentryModuleMetadata */.n2._sentryModuleMetadata) {
        return;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(worldwide/* GLOBAL_OBJ._sentryModuleMetadata */.n2._sentryModuleMetadata)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var stack = _step.value;
            var metadata = worldwide/* GLOBAL_OBJ._sentryModuleMetadata */.n2._sentryModuleMetadata[stack];
            if (parsedStacks.has(stack)) {
                continue;
            }
            // Ensure this stack doesn't get parsed again
            parsedStacks.add(stack);
            var frames = parser(stack);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                // Go through the frames starting from the top of the stack and find the first one with a filename
                for(var _iterator1 = frames.reverse()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var frame = _step1.value;
                    if (frame.filename) {
                        // Save the metadata for this filename
                        filenameMetadataMap.set(frame.filename, metadata);
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * Retrieve metadata for a specific JavaScript file URL.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function getMetadataForUrl(parser, filename) {
    ensureMetadataStacksAreParsed(parser);
    return filenameMetadataMap.get(filename);
}
/**
 * Adds metadata to stack frames.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ function addMetadataToStackFrames(parser, event) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach(function(exception) {
            if (!exception.stacktrace) {
                return;
            }
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = (exception.stacktrace.frames || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var frame = _step.value;
                    if (!frame.filename) {
                        continue;
                    }
                    var metadata = getMetadataForUrl(parser, frame.filename);
                    if (metadata) {
                        frame.module_metadata = metadata;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Strips metadata from stack frames.
 */ function stripMetadataFromStackFrames(event) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach(function(exception) {
            if (!exception.stacktrace) {
                return;
            }
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = (exception.stacktrace.frames || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var frame = _step.value;
                    delete frame.module_metadata;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
 //# sourceMappingURL=metadata.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/metadata.js



var metadata_INTEGRATION_NAME = "ModuleMetadata";
var _moduleMetadataIntegration = function() {
    return {
        name: metadata_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        setup: function setup(client) {
            if (typeof client.on !== "function") {
                return;
            }
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on("beforeEnvelope", function(envelope) {
                (0,esm_envelope/* forEachEnvelopeItem */.gv)(envelope, function(item, type) {
                    if (type === "event") {
                        var event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
        },
        processEvent: function processEvent(event, _hint, client) {
            var stackParser = client.getOptions().stackParser;
            addMetadataToStackFrames(stackParser, event);
            return event;
        }
    };
};
var moduleMetadataIntegration = (0,integration/* defineIntegration */._I)(_moduleMetadataIntegration);
/**
 * Adds module metadata to stack frames.
 *
 * Metadata can be injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 *
 * When this integration is added, the metadata passed to the bundler plugin is added to the stack frames of all events
 * under the `module_metadata` property. This can be used to help in tagging or routing of events from different teams
 * our sources
 *
 * @deprecated Use `moduleMetadataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var ModuleMetadata = (0,integration/* convertIntegrationFnToClass */.RN)(metadata_INTEGRATION_NAME, moduleMetadataIntegration);
 //# sourceMappingURL=metadata.js.map

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/dsn.js
var esm_dsn = __webpack_require__(74094);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/api.js
var api = __webpack_require__(89342);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/multiplexed.js







/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */ function eventFromEnvelope(env, types) {
    var event;
    (0,esm_envelope/* forEachEnvelopeItem */.gv)(env, function(item, type) {
        if (types.includes(type)) {
            event = Array.isArray(item) ? item[1] : undefined;
        }
        // bail out if we found an event
        return !!event;
    });
    return event;
}
/**
 * Creates a transport that overrides the release on all events.
 */ function makeOverrideReleaseTransport(createTransport, release) {
    return function(options) {
        var transport = createTransport(options);
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, transport), {
            send: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(envelope) {
                    var event;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        event = eventFromEnvelope(envelope, [
                            "event",
                            "transaction",
                            "profile",
                            "replay_event"
                        ]);
                        if (event) {
                            event.release = release;
                        }
                        return [
                            2,
                            transport.send(envelope)
                        ];
                    });
                });
                return function(envelope) {
                    return _ref.apply(this, arguments);
                };
            }()
        });
    };
}
/** Overrides the DSN in the envelope header  */ function overrideDsn(envelope, dsn) {
    return (0,esm_envelope/* createEnvelope */.Jd)(dsn ? (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, envelope[0]), {
        dsn: dsn
    }) : envelope[0], envelope[1]);
}
/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 */ function makeMultiplexedTransport(createTransport, matcher) {
    return function(options) {
        var getTransport = function getTransport(dsn, release) {
            // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
            // use at the same time
            var key = release ? "".concat(dsn, ":").concat(release) : dsn;
            var transport = otherTransports.get(key);
            if (!transport) {
                var validatedDsn = (0,esm_dsn/* dsnFromString */.U4)(dsn);
                if (!validatedDsn) {
                    return undefined;
                }
                var url = (0,api/* getEnvelopeEndpointWithUrlEncodedAuth */.U)(validatedDsn, options.tunnel);
                transport = release ? makeOverrideReleaseTransport(createTransport, release)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
                    url: url
                })) : createTransport((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
                    url: url
                }));
                otherTransports.set(key, transport);
            }
            return [
                dsn,
                transport
            ];
        };
        var fallbackTransport = createTransport(options);
        var otherTransports = new Map();
        function send(envelope) {
            return _send.apply(this, arguments);
        }
        function _send() {
            _send = (0,_async_to_generator/* default */.Z)(function(envelope) {
                var transports, results;
                function getEvent(types) {
                    var eventTypes = types && types.length ? types : [
                        "event"
                    ];
                    return eventFromEnvelope(envelope, eventTypes);
                }
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            transports = matcher({
                                envelope: envelope,
                                getEvent: getEvent
                            }).map(function(result) {
                                if (typeof result === "string") {
                                    return getTransport(result, undefined);
                                } else {
                                    return getTransport(result.dsn, result.release);
                                }
                            }).filter(function(t) {
                                return !!t;
                            });
                            // If we have no transports to send to, use the fallback transport
                            if (transports.length === 0) {
                                // Don't override the DSN in the header for the fallback transport. '' is falsy
                                transports.push([
                                    "",
                                    fallbackTransport
                                ]);
                            }
                            return [
                                4,
                                Promise.all(transports.map(function(param) {
                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), dsn = _param[0], transport = _param[1];
                                    return transport.send(overrideDsn(envelope, dsn));
                                }))
                            ];
                        case 1:
                            results = _state.sent();
                            return [
                                2,
                                results[0]
                            ];
                    }
                });
            });
            return _send.apply(this, arguments);
        }
        function flush(timeout) {
            return _flush.apply(this, arguments);
        }
        function _flush() {
            _flush = (0,_async_to_generator/* default */.Z)(function(timeout) {
                var promises, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, transport, _, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fallbackTransport.flush(timeout)
                            ];
                        case 1:
                            promises = [
                                _state.sent()
                            ];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                7,
                                8,
                                9
                            ]);
                            _iterator = otherTransports[Symbol.iterator]();
                            _state.label = 3;
                        case 3:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                6
                            ];
                            _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), transport = _value[1];
                            _ = promises.push;
                            return [
                                4,
                                transport.flush(timeout)
                            ];
                        case 4:
                            _.apply(promises, [
                                _state.sent()
                            ]);
                            _state.label = 5;
                        case 5:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                3
                            ];
                        case 6:
                            return [
                                3,
                                9
                            ];
                        case 7:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                9
                            ];
                        case 8:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 9:
                            return [
                                2,
                                promises.every(function(r) {
                                    return r;
                                })
                            ];
                    }
                });
            });
            return _flush.apply(this, arguments);
        }
        return {
            send: send,
            flush: flush
        };
    };
}
 //# sourceMappingURL=multiplexed.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(92957);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/debug-build.js
var debug_build = __webpack_require__(80107);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(77668);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(76190);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/metrics/constants.js
var COUNTER_METRIC_TYPE = "c";
var GAUGE_METRIC_TYPE = "g";
var SET_METRIC_TYPE = "s";
var DISTRIBUTION_METRIC_TYPE = "d";
/**
 * This does not match spec in https://develop.sentry.dev/sdk/metrics
 * but was chosen to optimize for the most common case in browser environments.
 */ var DEFAULT_BROWSER_FLUSH_INTERVAL = 5000;
/**
 * SDKs are required to bucket into 10 second intervals (rollup in seconds)
 * which is the current lower bound of metric accuracy.
 */ var DEFAULT_FLUSH_INTERVAL = 10000;
/**
 * The maximum number of metrics that should be stored in memory.
 */ var MAX_WEIGHT = 10000;
 //# sourceMappingURL=constants.js.map

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(96233);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/metrics/utils.js
var utils = __webpack_require__(8168);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/metrics/instance.js





/**
 * A metric instance representing a counter.
 */ var CounterMetric = /*#__PURE__*/ function() {
    "use strict";
    function CounterMetric(_value) {
        (0,_class_call_check/* default */.Z)(this, CounterMetric);
        this._value = _value;
    }
    (0,_create_class/* default */.Z)(CounterMetric, [
        {
            key: "weight",
            get: /** @inheritDoc */ function get() {
                return 1;
            }
        },
        {
            /** @inheritdoc */ key: "add",
            value: function add(value) {
                this._value += value;
            }
        },
        {
            /** @inheritdoc */ key: "toString",
            value: function toString() {
                return "".concat(this._value);
            }
        }
    ]);
    return CounterMetric;
}();
/**
 * A metric instance representing a gauge.
 */ var GaugeMetric = /*#__PURE__*/ function() {
    "use strict";
    function GaugeMetric(value) {
        (0,_class_call_check/* default */.Z)(this, GaugeMetric);
        this._last = value;
        this._min = value;
        this._max = value;
        this._sum = value;
        this._count = 1;
    }
    (0,_create_class/* default */.Z)(GaugeMetric, [
        {
            key: "weight",
            get: /** @inheritDoc */ function get() {
                return 5;
            }
        },
        {
            /** @inheritdoc */ key: "add",
            value: function add(value) {
                this._last = value;
                if (value < this._min) {
                    this._min = value;
                }
                if (value > this._max) {
                    this._max = value;
                }
                this._sum += value;
                this._count++;
            }
        },
        {
            /** @inheritdoc */ key: "toString",
            value: function toString() {
                return "".concat(this._last, ":").concat(this._min, ":").concat(this._max, ":").concat(this._sum, ":").concat(this._count);
            }
        }
    ]);
    return GaugeMetric;
}();
/**
 * A metric instance representing a distribution.
 */ var DistributionMetric = /*#__PURE__*/ function() {
    "use strict";
    function DistributionMetric(first) {
        (0,_class_call_check/* default */.Z)(this, DistributionMetric);
        this._value = [
            first
        ];
    }
    (0,_create_class/* default */.Z)(DistributionMetric, [
        {
            key: "weight",
            get: /** @inheritDoc */ function get() {
                return this._value.length;
            }
        },
        {
            /** @inheritdoc */ key: "add",
            value: function add(value) {
                this._value.push(value);
            }
        },
        {
            /** @inheritdoc */ key: "toString",
            value: function toString() {
                return this._value.join(":");
            }
        }
    ]);
    return DistributionMetric;
}();
/**
 * A metric instance representing a set.
 */ var SetMetric = /*#__PURE__*/ function() {
    "use strict";
    function SetMetric(first) {
        (0,_class_call_check/* default */.Z)(this, SetMetric);
        this.first = first;
        this._value = new Set([
            first
        ]);
    }
    (0,_create_class/* default */.Z)(SetMetric, [
        {
            key: "weight",
            get: /** @inheritDoc */ function get() {
                return this._value.size;
            }
        },
        {
            /** @inheritdoc */ key: "add",
            value: function add(value) {
                this._value.add(value);
            }
        },
        {
            /** @inheritdoc */ key: "toString",
            value: function toString() {
                return Array.from(this._value).map(function(val) {
                    return typeof val === "string" ? (0,utils/* simpleHash */.M)(val) : val;
                }).join(":");
            }
        }
    ]);
    return SetMetric;
}();
var _obj;
var METRIC_MAP = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, COUNTER_METRIC_TYPE, CounterMetric), (0,src_define_property/* default */.Z)(_obj, GAUGE_METRIC_TYPE, GaugeMetric), (0,src_define_property/* default */.Z)(_obj, DISTRIBUTION_METRIC_TYPE, DistributionMetric), (0,src_define_property/* default */.Z)(_obj, SET_METRIC_TYPE, SetMetric), _obj);
 //# sourceMappingURL=instance.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/metrics/metric-summary.js
var metric_summary = __webpack_require__(30268);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/metrics/browser-aggregator.js








/**
 * A simple metrics aggregator that aggregates metrics in memory and flushes them periodically.
 * Default flush interval is 5 seconds.
 *
 * @experimental This API is experimental and might change in the future.
 */ var BrowserMetricsAggregator = /*#__PURE__*/ function() {
    "use strict";
    function BrowserMetricsAggregator(_client) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, BrowserMetricsAggregator);
        this._client = _client;
        this._buckets = new Map();
        this._interval = setInterval(function() {
            return _this.flush();
        }, DEFAULT_BROWSER_FLUSH_INTERVAL);
    }
    (0,_create_class/* default */.Z)(BrowserMetricsAggregator, [
        {
            /**
   * @inheritDoc
   */ key: "add",
            value: function add(metricType, unsanitizedName, value) {
                var unsanitizedUnit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "none", unsanitizedTags = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, maybeFloatTimestamp = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : (0,time/* timestampInSeconds */.ph)();
                var timestamp = Math.floor(maybeFloatTimestamp);
                var name = (0,utils/* sanitizeMetricKey */.s3)(unsanitizedName);
                var tags = (0,utils/* sanitizeTags */.Bg)(unsanitizedTags);
                var unit = (0,utils/* sanitizeUnit */.OC)(unsanitizedUnit);
                var bucketKey = (0,utils/* getBucketKey */.Ic)(metricType, name, unit, tags);
                var bucketItem = this._buckets.get(bucketKey);
                // If this is a set metric, we need to calculate the delta from the previous weight.
                var previousWeight = bucketItem && metricType === SET_METRIC_TYPE ? bucketItem.metric.weight : 0;
                if (bucketItem) {
                    bucketItem.metric.add(value);
                    // TODO(abhi): Do we need this check?
                    if (bucketItem.timestamp < timestamp) {
                        bucketItem.timestamp = timestamp;
                    }
                } else {
                    bucketItem = {
                        // @ts-expect-error we don't need to narrow down the type of value here, saves bundle size.
                        metric: new METRIC_MAP[metricType](value),
                        timestamp: timestamp,
                        metricType: metricType,
                        name: name,
                        unit: unit,
                        tags: tags
                    };
                    this._buckets.set(bucketKey, bucketItem);
                }
                // If value is a string, it's a set metric so calculate the delta from the previous weight.
                var val = typeof value === "string" ? bucketItem.metric.weight - previousWeight : value;
                (0,metric_summary/* updateMetricSummaryOnActiveSpan */.v)(metricType, name, val, unit, unsanitizedTags, bucketKey);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "flush",
            value: function flush() {
                // short circuit if buckets are empty.
                if (this._buckets.size === 0) {
                    return;
                }
                if (this._client.captureAggregateMetrics) {
                    // TODO(@anonrig): Use Object.values() when we support ES6+
                    var metricBuckets = Array.from(this._buckets).map(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), bucketItem = _param[1];
                        return bucketItem;
                    });
                    this._client.captureAggregateMetrics(metricBuckets);
                }
                this._buckets.clear();
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "close",
            value: function close() {
                clearInterval(this._interval);
                this.flush();
            }
        }
    ]);
    return BrowserMetricsAggregator;
}();
 //# sourceMappingURL=browser-aggregator.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/metrics/integration.js


var integration_INTEGRATION_NAME = "MetricsAggregator";
var _metricsAggregatorIntegration = function() {
    return {
        name: integration_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        setup: function setup(client) {
            client.metricsAggregator = new BrowserMetricsAggregator(client);
        }
    };
};
var metricsAggregatorIntegration = (0,integration/* defineIntegration */._I)(_metricsAggregatorIntegration);
/**
 * Enables Sentry metrics monitoring.
 *
 * @experimental This API is experimental and might having breaking changes in the future.
 * @deprecated Use `metricsAggegratorIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var MetricsAggregator = (0,integration/* convertIntegrationFnToClass */.RN)(integration_INTEGRATION_NAME, metricsAggregatorIntegration);
 //# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/metrics/exports.js







function addToMetricsAggregator(metricType, name, value) {
    var data = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var client = (0,esm_exports/* getClient */.s3)();
    var scope = (0,esm_exports/* getCurrentScope */.nZ)();
    if (client) {
        if (!client.metricsAggregator) {
            debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("No metrics aggregator enabled. Please add the MetricsAggregator integration to use metrics APIs");
            return;
        }
        var unit = data.unit, tags = data.tags, timestamp = data.timestamp;
        var ref = client.getOptions(), release = ref.release, environment = ref.environment;
        // eslint-disable-next-line deprecation/deprecation
        var transaction = scope.getTransaction();
        var metricTags = {};
        if (release) {
            metricTags.release = release;
        }
        if (environment) {
            metricTags.environment = environment;
        }
        if (transaction) {
            metricTags.transaction = (0,spanUtils/* spanToJSON */.XU)(transaction).description || "";
        }
        debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("Adding value of ".concat(value, " to ").concat(metricType, " metric ").concat(name));
        client.metricsAggregator.add(metricType, name, value, unit, (0,src_object_spread/* default */.Z)({}, metricTags, tags), timestamp);
    }
}
/**
 * Adds a value to a counter metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function increment(name) {
    var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, data = arguments.length > 2 ? arguments[2] : void 0;
    addToMetricsAggregator(COUNTER_METRIC_TYPE, name, value, data);
}
/**
 * Adds a value to a distribution metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function distribution(name, value, data) {
    addToMetricsAggregator(DISTRIBUTION_METRIC_TYPE, name, value, data);
}
/**
 * Adds a value to a set metric. Value must be a string or integer.
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function set(name, value, data) {
    addToMetricsAggregator(SET_METRIC_TYPE, name, value, data);
}
/**
 * Adds a value to a gauge metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function gauge(name, value, data) {
    addToMetricsAggregator(GAUGE_METRIC_TYPE, name, value, data);
}
var metrics = {
    increment: increment,
    distribution: distribution,
    set: set,
    gauge: gauge,
    /** @deprecated Use `metrics.metricsAggregratorIntegration()` instead. */ // eslint-disable-next-line deprecation/deprecation
    MetricsAggregator: MetricsAggregator,
    metricsAggregatorIntegration: metricsAggregatorIntegration
};
 //# sourceMappingURL=exports.js.map

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/utils/parameterize.js
/**
 * Tagged template function which returns paramaterized representation of the message
 * For example: parameterize`This is a log statement with ${x} and ${y} params`, would return:
 * "__sentry_template_string__": 'This is a log statement with %s and %s params',
 * "__sentry_template_values__": ['first', 'second']
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 * @returns String with template information in __sentry_template_string__ and __sentry_template_values__ properties
 */ 
function parameterize(strings) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        values[_key - 1] = arguments[_key];
    }
    var _String;
    var formatted = new String((_String = String).raw.apply(_String, [
        strings
    ].concat((0,_to_consumable_array/* default */.Z)(values))));
    formatted.__sentry_template_string__ = strings.join("\0").replace(/%/g, "%%").replace(/\0/g, "%s");
    formatted.__sentry_template_values__ = values;
    return formatted;
}
 //# sourceMappingURL=parameterize.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(19217);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(63935);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(91292);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/scope.js
var scope = __webpack_require__(29791);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/baseclient.js + 1 modules
var baseclient = __webpack_require__(99892);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/eventProcessors.js
var eventProcessors = __webpack_require__(38126);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(97576);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/trace.js
var trace = __webpack_require__(19381);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/transports/base.js + 1 modules
var base = __webpack_require__(25576);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/utils.js
var tracing_utils = __webpack_require__(4124);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/spanstatus.js
var spanstatus = __webpack_require__(86912);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/sdk.js
var sdk = __webpack_require__(83283);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/measurement.js
var measurement = __webpack_require__(99770);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(50203);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/client.js + 1 modules
var client = __webpack_require__(4973);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js + 1 modules
var fetch = __webpack_require__(92409);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/transports/xhr.js
var xhr = __webpack_require__(81738);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/stack-parsers.js
var stack_parsers = __webpack_require__(37789);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js
var eventbuilder = __webpack_require__(50376);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/userfeedback.js
var userfeedback = __webpack_require__(51339);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/sdk.js
var esm_sdk = __webpack_require__(26279);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js
var breadcrumbs = __webpack_require__(47394);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/dedupe.js
var dedupe = __webpack_require__(78849);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/globalhandlers.js
var globalhandlers = __webpack_require__(33950);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/httpcontext.js
var httpcontext = __webpack_require__(99027);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js
var linkederrors = __webpack_require__(64980);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/integrations/trycatch.js
var trycatch = __webpack_require__(66155);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/index.js





 /* eslint-disable deprecation/deprecation */  //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/replay/esm/index.js
var esm = __webpack_require__(49634);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
var _optionalChain = __webpack_require__(57374);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/replay-canvas/esm/index.js












var NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType || (NodeType = {}));
function elementClassMatchesRegex(el, regex) {
    for(var eIndex = el.classList.length; eIndex--;){
        var className = el.classList[eIndex];
        if (regex.test(className)) {
            return true;
        }
    }
    return false;
}
function distanceToMatch(node, matchPredicate) {
    var limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity, distance = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function createMatchPredicate(className, selector) {
    return function(node) {
        var el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(".".concat(className))) return true;
                } else if (elementClassMatchesRegex(el, className)) {
                    return true;
                }
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
var DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that," + "\r\n" + "now you can use replayer.getMirror() to access the mirror instance of a replayer," + "\r\n" + "or you can use record.mirror to access the mirror instance during recording.";
var _mirror = {
    map: {},
    getId: function getId() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode: function getNode() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap: function removeNodeFromMap() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has: function has() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset: function reset() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if ( true && window.Proxy && window.Reflect) {
    _mirror = new Proxy(_mirror, {
        get: function get(target, prop, receiver) {
            if (prop === "map") {
                console.error(DEPARTED_MIRROR_ACCESS_WARNING);
            }
            return Reflect.get(target, prop, receiver);
        }
    });
}
function hookSetter(target, key, d, isRevoked) {
    var win = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : window;
    var original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set: function set(value) {
            var _this = this;
            esm_setTimeout(function() {
                d.set.call(_this, value);
            }, 0);
            if (original && original.set) {
                original.set.call(this, value);
            }
        }
    });
    return function() {
        return hookSetter(target, key, original || {}, true);
    };
}
function patch(source, name, replacement) {
    try {
        if (!(name in source)) {
            return function() {};
        }
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return function() {
            source[name] = original;
        };
    } catch (e2) {
        return function() {};
    }
}
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) ;
function closestElementOfNode(node) {
    if (!node) {
        return null;
    }
    var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) {
        return false;
    }
    var el = closestElementOfNode(node);
    if (!el) {
        return false;
    }
    var blockedPredicate = createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        var isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    var blockDistance = distanceToMatch(el, blockedPredicate);
    var unblockDistance = -1;
    if (blockDistance < 0) {
        return false;
    }
    if (unblockSelector) {
        unblockDistance = distanceToMatch(el, createMatchPredicate(null, unblockSelector));
    }
    if (blockDistance > -1 && unblockDistance < 0) {
        return true;
    }
    return blockDistance < unblockDistance;
}
var cachedImplementations = {};
function getImplementation(name) {
    var cached = cachedImplementations[name];
    if (cached) {
        return cached;
    }
    var document = window.document;
    var impl = window[name];
    if (document && typeof document.createElement === "function") {
        try {
            var sandbox = document.createElement("iframe");
            sandbox.hidden = true;
            document.head.appendChild(sandbox);
            var contentWindow = sandbox.contentWindow;
            if (contentWindow && contentWindow[name]) {
                impl = contentWindow[name];
            }
            document.head.removeChild(sandbox);
        } catch (e) {}
    }
    return cachedImplementations[name] = impl.bind(window);
}
function onRequestAnimationFrame() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return getImplementation("requestAnimationFrame").apply(this, (0,_to_consumable_array/* default */.Z)(rest));
}
function esm_setTimeout() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return getImplementation("setTimeout").apply(this, (0,_to_consumable_array/* default */.Z)(rest));
}
var CanvasContext = /* @__PURE__ */ function(CanvasContext2) {
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
}(CanvasContext || {});
var errorHandler;
function registerErrorHandler(handler) {
    errorHandler = handler;
}
var callbackWrapper = function(cb) {
    if (!errorHandler) {
        return cb;
    }
    var rrwebWrapped = function() {
        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
            rest[_key] = arguments[_key];
        }
        try {
            return cb.apply(void 0, (0,_to_consumable_array/* default */.Z)(rest));
        } catch (error) {
            if (errorHandler && errorHandler(error) === true) {
                return function() {};
            }
            throw error;
        }
    };
    return rrwebWrapped;
};
/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var i = 0; i < chars.length; i++){
    lookup[chars.charCodeAt(i)] = i;
}
var encode = function encode(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += chars[bytes[i] >> 2];
        base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) {
        base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
        base64 = base64.substring(0, base64.length - 2) + "==";
    }
    return base64;
};
var canvasVarMap = new Map();
function variableListFor(ctx, ctor) {
    var contextMap = canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) {
        contextMap.set(ctor, []);
    }
    return contextMap.get(ctor);
}
var saveWebGLVar = function(value, win, ctx) {
    if (!value || !(isInstanceOfWebGLObject(value, win) || typeof value === "object")) return;
    var name = value.constructor.name;
    var list = variableListFor(ctx, name);
    var index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function serializeArg(value, win, ctx) {
    if ((0,_instanceof/* default */.Z)(value, Array)) {
        return value.map(function(arg) {
            return serializeArg(arg, win, ctx);
        });
    } else if (value === null) {
        return value;
    } else if ((0,_instanceof/* default */.Z)(value, Float32Array) || (0,_instanceof/* default */.Z)(value, Float64Array) || (0,_instanceof/* default */.Z)(value, Int32Array) || (0,_instanceof/* default */.Z)(value, Uint32Array) || (0,_instanceof/* default */.Z)(value, Uint8Array) || (0,_instanceof/* default */.Z)(value, Uint16Array) || (0,_instanceof/* default */.Z)(value, Int16Array) || (0,_instanceof/* default */.Z)(value, Int8Array) || (0,_instanceof/* default */.Z)(value, Uint8ClampedArray)) {
        var name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if ((0,_instanceof/* default */.Z)(value, ArrayBuffer)) {
        var name1 = value.constructor.name;
        var base64 = encode(value);
        return {
            rr_type: name1,
            base64: base64
        };
    } else if ((0,_instanceof/* default */.Z)(value, DataView)) {
        var name2 = value.constructor.name;
        return {
            rr_type: name2,
            args: [
                serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength, 
            ]
        };
    } else if ((0,_instanceof/* default */.Z)(value, HTMLImageElement)) {
        var name3 = value.constructor.name;
        var src = value.src;
        return {
            rr_type: name3,
            src: src
        };
    } else if ((0,_instanceof/* default */.Z)(value, HTMLCanvasElement)) {
        var name4 = "HTMLImageElement";
        var src1 = value.toDataURL();
        return {
            rr_type: name4,
            src: src1
        };
    } else if ((0,_instanceof/* default */.Z)(value, ImageData)) {
        var name5 = value.constructor.name;
        return {
            rr_type: name5,
            args: [
                serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if (isInstanceOfWebGLObject(value, win) || typeof value === "object") {
        var name6 = value.constructor.name;
        var index = saveWebGLVar(value, win, ctx);
        return {
            rr_type: name6,
            index: index
        };
    }
    return value;
}
var serializeArgs = function(args, win, ctx) {
    return args.map(function(arg) {
        return serializeArg(arg, win, ctx);
    });
};
var isInstanceOfWebGLObject = function(value, win) {
    var webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        "WebGLVertexArrayObjectOES", 
    ];
    var supportedWebGLConstructorNames = webGLConstructorNames.filter(function(name) {
        return typeof win[name] === "function";
    });
    return Boolean(supportedWebGLConstructorNames.find(function(name) {
        return (0,_instanceof/* default */.Z)(value, win[name]);
    }));
};
function initCanvas2DMutationObserver(cb, win, blockClass, blockSelector, unblockSelector) {
    var handlers = [];
    var props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var prop = _step.value;
            try {
                if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") {
                    return "continue";
                }
                var restoreHandler = patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
                    return function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var _this = this;
                        if (!isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) {
                            esm_setTimeout(function() {
                                var recordArgs = serializeArgs(args, win, _this);
                                cb(_this.canvas, {
                                    type: CanvasContext["2D"],
                                    property: prop,
                                    args: recordArgs
                                });
                            }, 0);
                        }
                        return original.apply(this, args);
                    };
                });
                handlers.push(restoreHandler);
            } catch (e) {
                var hookHandler = hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
                    set: function set(v) {
                        cb(this.canvas, {
                            type: CanvasContext["2D"],
                            property: prop,
                            args: [
                                v
                            ],
                            setter: true
                        });
                    }
                });
                handlers.push(hookHandler);
            }
        };
        for(var _iterator = props2D[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function getNormalizedContextName(contextType) {
    return contextType === "experimental-webgl" ? "webgl" : contextType;
}
function initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, setPreserveDrawingBufferToTrue) {
    var handlers = [];
    try {
        var restoreHandler = patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (!isBlocked(this, blockClass, blockSelector, unblockSelector, true)) {
                    var ctxName = getNormalizedContextName(contextType);
                    if (!("__context" in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        "webgl",
                        "webgl2"
                    ].includes(ctxName)) {
                        if (args[0] && typeof args[0] === "object") {
                            var contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) {
                                contextAttributes.preserveDrawingBuffer = true;
                            }
                        } else {
                            args.splice(0, 1, {
                                preserveDrawingBuffer: true
                            });
                        }
                    }
                }
                return original.apply(this, [
                    contextType
                ].concat((0,_to_consumable_array/* default */.Z)(args)));
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function patchGLPrototype(prototype, type, cb, blockClass, blockSelector, unblockSelector, mirror, win) {
    var handlers = [];
    var props = Object.getOwnPropertyNames(prototype);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var prop = _step.value;
            if ([
                "isContextLost",
                "canvas",
                "drawingBufferWidth",
                "drawingBufferHeight", 
            ].includes(prop)) {
                return "continue";
            }
            try {
                if (typeof prototype[prop] !== "function") {
                    return "continue";
                }
                var restoreHandler = patch(prototype, prop, function(original) {
                    return function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var result = original.apply(this, args);
                        saveWebGLVar(result, win, this);
                        if ("tagName" in this.canvas && !isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) {
                            var recordArgs = serializeArgs(args, win, this);
                            var mutation = {
                                type: type,
                                property: prop,
                                args: recordArgs
                            };
                            cb(this.canvas, mutation);
                        }
                        return result;
                    };
                });
                handlers.push(restoreHandler);
            } catch (e) {
                var hookHandler = hookSetter(prototype, prop, {
                    set: function set(v) {
                        cb(this.canvas, {
                            type: type,
                            property: prop,
                            args: [
                                v
                            ],
                            setter: true
                        });
                    }
                });
                handlers.push(hookHandler);
            }
        };
        for(var _iterator = props[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return handlers;
}
function initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, unblockSelector, mirror) {
    var _handlers;
    var handlers = [];
    (_handlers = handlers).push.apply(_handlers, (0,_to_consumable_array/* default */.Z)(patchGLPrototype(win.WebGLRenderingContext.prototype, CanvasContext.WebGL, cb, blockClass, blockSelector, unblockSelector, mirror, win)));
    if (typeof win.WebGL2RenderingContext !== "undefined") {
        var _handlers1;
        (_handlers1 = handlers).push.apply(_handlers1, (0,_to_consumable_array/* default */.Z)(patchGLPrototype(win.WebGL2RenderingContext.prototype, CanvasContext.WebGL2, cb, blockClass, blockSelector, unblockSelector, mirror, win)));
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
var r = 'for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t="undefined"==typeof Uint8Array?[]:new Uint8Array(256),a=0;a<64;a++)t[e.charCodeAt(a)]=a;var n=function(t){var a,n=new Uint8Array(t),r=n.length,s="";for(a=0;a<r;a+=3)s+=e[n[a]>>2],s+=e[(3&n[a])<<4|n[a+1]>>4],s+=e[(15&n[a+1])<<2|n[a+2]>>6],s+=e[63&n[a+2]];return r%3==2?s=s.substring(0,s.length-1)+"=":r%3==1&&(s=s.substring(0,s.length-2)+"=="),s};const r=new Map,s=new Map;const i=self;i.onmessage=async function(e){if(!("OffscreenCanvas"in globalThis))return i.postMessage({id:e.data.id});{const{id:t,bitmap:a,width:o,height:f,maxCanvasSize:c,dataURLOptions:g}=e.data,u=async function(e,t,a){const r=e+"-"+t;if("OffscreenCanvas"in globalThis){if(s.has(r))return s.get(r);const i=new OffscreenCanvas(e,t);i.getContext("2d");const o=await i.convertToBlob(a),f=await o.arrayBuffer(),c=n(f);return s.set(r,c),c}return""}(o,f,g),[h,d]=function(e,t,a){if(!a)return[e,t];const[n,r]=a;if(e<=n&&t<=r)return[e,t];let s=e,i=t;return s>n&&(i=Math.floor(n*t/e),s=n),i>r&&(s=Math.floor(r*e/t),i=r),[s,i]}(o,f,c),l=new OffscreenCanvas(h,d),w=l.getContext("bitmaprenderer"),p=h===o&&d===f?a:await createImageBitmap(a,{resizeWidth:h,resizeHeight:d,resizeQuality:"low"});w.transferFromImageBitmap(p),a.close();const y=await l.convertToBlob(g),v=y.type,b=await y.arrayBuffer(),m=n(b);if(p.close(),!r.has(t)&&await u===m)return r.set(t,m),i.postMessage({id:t});if(r.get(t)===m)return i.postMessage({id:t});i.postMessage({id:t,type:v,base64:m,width:o,height:f}),r.set(t,m)}};';
function t() {
    var t = new Blob([
        r
    ]);
    return URL.createObjectURL(t);
}
var CanvasManager = /*#__PURE__*/ function() {
    "use strict";
    function CanvasManager(options) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, CanvasManager);
        this.pendingCanvasMutations = new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.frozen = false;
        this.locked = false;
        this.processMutation = function(target, mutation) {
            var newFrame = _this.rafStamps.invokeId && _this.rafStamps.latestId !== _this.rafStamps.invokeId;
            if (newFrame || !_this.rafStamps.invokeId) _this.rafStamps.invokeId = _this.rafStamps.latestId;
            if (!_this.pendingCanvasMutations.has(target)) {
                _this.pendingCanvasMutations.set(target, []);
            }
            _this.pendingCanvasMutations.get(target).push(mutation);
        };
        var _sampling = options.sampling, sampling = _sampling === void 0 ? "all" : _sampling, win = options.win, blockClass = options.blockClass, blockSelector = options.blockSelector, unblockSelector = options.unblockSelector, maxCanvasSize = options.maxCanvasSize, recordCanvas = options.recordCanvas, dataURLOptions = options.dataURLOptions, errorHandler = options.errorHandler;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        this.options = options;
        if (errorHandler) {
            registerErrorHandler(errorHandler);
        }
        if (options.enableManualSnapshot) {
            return;
        }
        callbackWrapper(function() {
            if (recordCanvas && sampling === "all") _this.initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector);
            if (recordCanvas && typeof sampling === "number") _this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, {
                dataURLOptions: dataURLOptions
            });
        })();
    }
    (0,_create_class/* default */.Z)(CanvasManager, [
        {
            key: "reset",
            value: function reset() {
                this.pendingCanvasMutations.clear();
                this.resetObservers && this.resetObservers();
            }
        },
        {
            key: "freeze",
            value: function freeze() {
                this.frozen = true;
            }
        },
        {
            key: "unfreeze",
            value: function unfreeze() {
                this.frozen = false;
            }
        },
        {
            key: "lock",
            value: function lock() {
                this.locked = true;
            }
        },
        {
            key: "unlock",
            value: function unlock() {
                this.locked = false;
            }
        },
        {
            key: "initCanvasFPSObserver",
            value: function initCanvasFPSObserver(fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, options) {
                var canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, true);
                var rafId = this.takeSnapshot(false, fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, options.dataURLOptions);
                this.resetObservers = function() {
                    canvasContextReset();
                    cancelAnimationFrame(rafId);
                };
            }
        },
        {
            key: "initCanvasMutationObserver",
            value: function initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector) {
                this.startRAFTimestamping();
                this.startPendingCanvasMutationFlusher();
                var canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, false);
                var canvas2DReset = initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector);
                var canvasWebGL1and2Reset = initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
                this.resetObservers = function() {
                    canvasContextReset();
                    canvas2DReset();
                    canvasWebGL1and2Reset();
                };
            }
        },
        {
            key: "snapshot",
            value: function snapshot(canvasElement) {
                var options = this.options;
                var rafId = this.takeSnapshot(true, options.sampling === "all" ? 2 : options.sampling || 2, options.win, options.blockClass, options.blockSelector, options.unblockSelector, options.maxCanvasSize, options.dataURLOptions, canvasElement);
                this.resetObservers = function() {
                    cancelAnimationFrame(rafId);
                };
            }
        },
        {
            key: "takeSnapshot",
            value: function takeSnapshot(isManualSnapshot, fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, dataURLOptions, canvasElement) {
                var _this = this;
                var snapshotInProgressMap = new Map();
                var worker = new Worker(t());
                worker.onmessage = function(e) {
                    var data = e.data;
                    var id = data.id;
                    snapshotInProgressMap.set(id, false);
                    if (!("base64" in data)) return;
                    var base64 = data.base64, type = data.type, width = data.width, height = data.height;
                    _this.mutationCb({
                        id: id,
                        type: CanvasContext["2D"],
                        commands: [
                            {
                                property: "clearRect",
                                args: [
                                    0,
                                    0,
                                    width,
                                    height
                                ]
                            },
                            {
                                property: "drawImage",
                                args: [
                                    {
                                        rr_type: "ImageBitmap",
                                        args: [
                                            {
                                                rr_type: "Blob",
                                                data: [
                                                    {
                                                        rr_type: "ArrayBuffer",
                                                        base64: base64
                                                    }
                                                ],
                                                type: type
                                            }, 
                                        ]
                                    },
                                    0,
                                    0,
                                    width,
                                    height, 
                                ]
                            }, 
                        ]
                    });
                };
                var timeBetweenSnapshots = 1000 / fps;
                var lastSnapshotTime = 0;
                var rafId;
                var getCanvas = function(canvasElement) {
                    if (canvasElement) {
                        return [
                            canvasElement
                        ];
                    }
                    var matchedCanvas = [];
                    win.document.querySelectorAll("canvas").forEach(function(canvas) {
                        if (!isBlocked(canvas, blockClass, blockSelector, unblockSelector, true)) {
                            matchedCanvas.push(canvas);
                        }
                    });
                    return matchedCanvas;
                };
                var takeCanvasSnapshots = function(timestamp) {
                    if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                        rafId = onRequestAnimationFrame(takeCanvasSnapshots);
                        return;
                    }
                    lastSnapshotTime = timestamp;
                    getCanvas(canvasElement).forEach(function(canvas) {
                        var id = _this.mirror.getId(canvas);
                        if (snapshotInProgressMap.get(id)) return;
                        if (!canvas.width || !canvas.height) return;
                        snapshotInProgressMap.set(id, true);
                        if (!isManualSnapshot && [
                            "webgl",
                            "webgl2"
                        ].includes(canvas.__context)) {
                            var context = canvas.getContext(canvas.__context);
                            if ((0,_optionalChain/* _optionalChain */.x)([
                                context,
                                "optionalAccess",
                                function(_) {
                                    return _.getContextAttributes;
                                },
                                "call",
                                function(_2) {
                                    return _2();
                                },
                                "optionalAccess",
                                function(_3) {
                                    return _3.preserveDrawingBuffer;
                                }
                            ]) === false) {
                                context.clear(context.COLOR_BUFFER_BIT);
                            }
                        }
                        createImageBitmap(canvas).then(function(bitmap) {
                            worker.postMessage({
                                id: id,
                                bitmap: bitmap,
                                width: canvas.width,
                                height: canvas.height,
                                dataURLOptions: dataURLOptions,
                                maxCanvasSize: maxCanvasSize
                            }, [
                                bitmap
                            ]);
                        }).catch(function(error) {
                            callbackWrapper(function() {
                                throw error;
                            })();
                        });
                    });
                    rafId = onRequestAnimationFrame(takeCanvasSnapshots);
                };
                rafId = onRequestAnimationFrame(takeCanvasSnapshots);
                return rafId;
            }
        },
        {
            key: "startPendingCanvasMutationFlusher",
            value: function startPendingCanvasMutationFlusher() {
                var _this = this;
                onRequestAnimationFrame(function() {
                    return _this.flushPendingCanvasMutations();
                });
            }
        },
        {
            key: "startRAFTimestamping",
            value: function startRAFTimestamping() {
                var _this = this;
                var setLatestRAFTimestamp = function(timestamp) {
                    _this.rafStamps.latestId = timestamp;
                    onRequestAnimationFrame(setLatestRAFTimestamp);
                };
                onRequestAnimationFrame(setLatestRAFTimestamp);
            }
        },
        {
            key: "flushPendingCanvasMutations",
            value: function flushPendingCanvasMutations() {
                var _this = this;
                this.pendingCanvasMutations.forEach(function(values, canvas) {
                    var id = _this.mirror.getId(canvas);
                    _this.flushPendingCanvasMutationFor(canvas, id);
                });
                onRequestAnimationFrame(function() {
                    return _this.flushPendingCanvasMutations();
                });
            }
        },
        {
            key: "flushPendingCanvasMutationFor",
            value: function flushPendingCanvasMutationFor(canvas, id) {
                if (this.frozen || this.locked) {
                    return;
                }
                var valuesWithType = this.pendingCanvasMutations.get(canvas);
                if (!valuesWithType || id === -1) return;
                var values = valuesWithType.map(function(value) {
                    var type = value.type, rest = (0,_object_without_properties/* default */.Z)(value, [
                        "type"
                    ]);
                    return rest;
                });
                var type = valuesWithType[0].type;
                this.mutationCb({
                    id: id,
                    type: type,
                    commands: values
                });
                this.pendingCanvasMutations.delete(canvas);
            }
        }
    ]);
    return CanvasManager;
}();
var CANVAS_QUALITY = {
    low: {
        sampling: {
            canvas: 1
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.25
        }
    },
    medium: {
        sampling: {
            canvas: 2
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.4
        }
    },
    high: {
        sampling: {
            canvas: 4
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.5
        }
    }
};
var esm_INTEGRATION_NAME = "ReplayCanvas";
var DEFAULT_MAX_CANVAS_SIZE = 1280;
/** Exported only for type safe tests. */ var _replayCanvasIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref = (0,_sliced_to_array/* default */.Z)(options.maxCanvasSize || [], 2), maxCanvasWidth = ref[0], maxCanvasHeight = ref[1];
    var _canvasOptions = {
        quality: options.quality || "medium",
        enableManualSnapshot: options.enableManualSnapshot,
        maxCanvasSize: [
            maxCanvasWidth ? Math.min(maxCanvasWidth, DEFAULT_MAX_CANVAS_SIZE) : DEFAULT_MAX_CANVAS_SIZE,
            maxCanvasHeight ? Math.min(maxCanvasHeight, DEFAULT_MAX_CANVAS_SIZE) : DEFAULT_MAX_CANVAS_SIZE, 
        ]
    };
    var canvasManagerResolve;
    var _canvasManager = new Promise(function(resolve) {
        return canvasManagerResolve = resolve;
    });
    return {
        name: esm_INTEGRATION_NAME,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: function setupOnce() {},
        getOptions: function getOptions() {
            var quality = _canvasOptions.quality, enableManualSnapshot = _canvasOptions.enableManualSnapshot, maxCanvasSize = _canvasOptions.maxCanvasSize;
            return (0,src_object_spread/* default */.Z)({
                enableManualSnapshot: enableManualSnapshot,
                recordCanvas: true,
                getCanvasManager: function(getCanvasManagerOptions) {
                    var manager = new CanvasManager((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, getCanvasManagerOptions), {
                        enableManualSnapshot: enableManualSnapshot,
                        maxCanvasSize: maxCanvasSize,
                        errorHandler: function(err) {
                            try {
                                if (typeof err === "object") {
                                    err.__rrweb__ = true;
                                }
                            } catch (error) {
                            // ignore errors here
                            // this can happen if the error is frozen or does not allow mutation for other reasons
                            }
                        }
                    }));
                    canvasManagerResolve(manager);
                    return manager;
                }
            }, CANVAS_QUALITY[quality || "medium"] || CANVAS_QUALITY.medium);
        },
        snapshot: function snapshot(canvasElement) {
            return (0,_async_to_generator/* default */.Z)(function() {
                var canvasManager;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _canvasManager
                            ];
                        case 1:
                            canvasManager = _state.sent();
                            canvasManager.snapshot(canvasElement);
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Add this in addition to `replayIntegration()` to enable canvas recording.
 */ var replayCanvasIntegration = (0,integration/* defineIntegration */._I)(_replayCanvasIntegration);
/**
 * @deprecated Use `replayCanvasIntegration()` instead
 */ // eslint-disable-next-line deprecation/deprecation
var ReplayCanvas = (0,integration/* convertIntegrationFnToClass */.RN)(esm_INTEGRATION_NAME, replayCanvasIntegration);
 //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(41413);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/isBrowser.js
var isBrowser = __webpack_require__(99506);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/prepareEvent.js
var prepareEvent = __webpack_require__(70271);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/envelope.js
var core_esm_envelope = __webpack_require__(15193);
;// CONCATENATED MODULE: ./node_modules/@sentry-internal/feedback/esm/index.js












// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and feedback packages
var WINDOW = worldwide/* GLOBAL_OBJ */.n2;
var LIGHT_BACKGROUND = "#ffffff";
var INHERIT = "inherit";
var SUBMIT_COLOR = "rgba(108, 95, 199, 1)";
var LIGHT_THEME = {
    fontFamily: "system-ui, 'Helvetica Neue', Arial, sans-serif",
    fontSize: "14px",
    background: LIGHT_BACKGROUND,
    backgroundHover: "#f6f6f7",
    foreground: "#2b2233",
    border: "1.5px solid rgba(41, 35, 47, 0.13)",
    borderRadius: "25px",
    boxShadow: "0px 4px 24px 0px rgba(43, 34, 51, 0.12)",
    success: "#268d75",
    error: "#df3338",
    submitBackground: "rgba(88, 74, 192, 1)",
    submitBackgroundHover: SUBMIT_COLOR,
    submitBorder: SUBMIT_COLOR,
    submitOutlineFocus: "#29232f",
    submitForeground: LIGHT_BACKGROUND,
    submitForegroundHover: LIGHT_BACKGROUND,
    cancelBackground: "transparent",
    cancelBackgroundHover: "var(--background-hover)",
    cancelBorder: "var(--border)",
    cancelOutlineFocus: "var(--input-outline-focus)",
    cancelForeground: "var(--foreground)",
    cancelForegroundHover: "var(--foreground)",
    inputBackground: INHERIT,
    inputForeground: INHERIT,
    inputBorder: "var(--border)",
    inputOutlineFocus: SUBMIT_COLOR,
    formBorderRadius: "20px",
    formContentBorderRadius: "6px"
};
var DEFAULT_THEME = {
    light: LIGHT_THEME,
    dark: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, LIGHT_THEME), {
        background: "#29232f",
        backgroundHover: "#352f3b",
        foreground: "#ebe6ef",
        border: "1.5px solid rgba(235, 230, 239, 0.15)",
        success: "#2da98c",
        error: "#f55459"
    })
};
var ACTOR_LABEL = "Report a Bug";
var CANCEL_BUTTON_LABEL = "Cancel";
var SUBMIT_BUTTON_LABEL = "Send Bug Report";
var FORM_TITLE = "Report a Bug";
var EMAIL_PLACEHOLDER = "your.email@example.org";
var EMAIL_LABEL = "Email";
var MESSAGE_PLACEHOLDER = "What's the bug? What did you expect?";
var MESSAGE_LABEL = "Description";
var NAME_PLACEHOLDER = "Your Name";
var NAME_LABEL = "Name";
var IS_REQUIRED_LABEL = "(required)";
var SUCCESS_MESSAGE_TEXT = "Thank you for your report!";
var FEEDBACK_WIDGET_SOURCE = "widget";
var FEEDBACK_API_SOURCE = "api";
function prepareFeedbackEvent(_) {
    return _prepareFeedbackEvent.apply(this, arguments);
}
function _prepareFeedbackEvent() {
    _prepareFeedbackEvent = /**
 * Prepare a feedback event & enrich it with the SDK metadata.
 */ (0,_async_to_generator/* default */.Z)(function(param) {
        var client, scope, event, eventHint, preparedEvent;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client = param.client, scope = param.scope, event = param.event;
                    eventHint = {};
                    if (client.emit) {
                        client.emit("preprocessEvent", event, eventHint);
                    }
                    return [
                        4,
                        (0,prepareEvent/* prepareEvent */.R)(client.getOptions(), event, eventHint, scope, client, (0,hub/* getIsolationScope */.aF)())
                    ];
                case 1:
                    preparedEvent = _state.sent();
                    if (preparedEvent === null) {
                        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
                        client.recordDroppedEvent("event_processor", "feedback", event);
                        return [
                            2,
                            null
                        ];
                    }
                    // This normally happens in browser client "_prepareEvent"
                    // but since we do not use this private method from the client, but rather the plain import
                    // we need to do this manually.
                    preparedEvent.platform = preparedEvent.platform || "javascript";
                    return [
                        2,
                        preparedEvent
                    ];
            }
        });
    });
    return _prepareFeedbackEvent.apply(this, arguments);
}
function sendFeedbackRequest(_) {
    return _sendFeedbackRequest.apply(this, arguments);
}
function _sendFeedbackRequest() {
    _sendFeedbackRequest = /**
 * Send feedback using transport
 */ (0,_async_to_generator/* default */.Z)(function(param) {
        var _feedback, message, email, name, source, url, ref, _includeReplay, includeReplay, client, transport, dsn, baseEvent;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            _feedback = param.feedback, message = _feedback.message, email = _feedback.email, name = _feedback.name, source = _feedback.source, url = _feedback.url, ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, _includeReplay = ref.includeReplay, includeReplay = _includeReplay === void 0 ? true : _includeReplay;
            client = (0,esm_exports/* getClient */.s3)();
            transport = client && client.getTransport();
            dsn = client && client.getDsn();
            if (!client || !transport || !dsn) {
                return [
                    2
                ];
            }
            baseEvent = {
                contexts: {
                    feedback: {
                        contact_email: email,
                        name: name,
                        message: message,
                        url: url,
                        source: source
                    }
                },
                type: "feedback"
            };
            return [
                2,
                (0,esm_exports/* withScope */.$e)(function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(scope) {
                        var feedbackEvent, envelope, response, err, error;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    // No use for breadcrumbs in feedback
                                    scope.clearBreadcrumbs();
                                    if ([
                                        FEEDBACK_API_SOURCE,
                                        FEEDBACK_WIDGET_SOURCE
                                    ].includes(String(source))) {
                                        scope.setLevel("info");
                                    }
                                    return [
                                        4,
                                        prepareFeedbackEvent({
                                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                            scope: scope,
                                            client: client,
                                            event: baseEvent
                                        })
                                    ];
                                case 1:
                                    feedbackEvent = _state.sent();
                                    if (!feedbackEvent) {
                                        return [
                                            2
                                        ];
                                    }
                                    if (client.emit) {
                                        client.emit("beforeSendFeedback", feedbackEvent, {
                                            includeReplay: Boolean(includeReplay)
                                        });
                                    }
                                    envelope = (0,core_esm_envelope/* createEventEnvelope */.M)(feedbackEvent, dsn, client.getOptions()._metadata, client.getOptions().tunnel);
                                    _state.label = 2;
                                case 2:
                                    _state.trys.push([
                                        2,
                                        4,
                                        ,
                                        5
                                    ]);
                                    return [
                                        4,
                                        transport.send(envelope)
                                    ];
                                case 3:
                                    response = _state.sent();
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    err = _state.sent();
                                    error = new Error("Unable to send Feedback");
                                    try {
                                        // In case browsers don't allow this property to be writable
                                        // @ts-expect-error This needs lib es2022 and newer
                                        error.cause = err;
                                    } catch (e) {
                                    // nothing to do
                                    }
                                    throw error;
                                case 5:
                                    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
                                    if (!response) {
                                        return [
                                            2
                                        ];
                                    }
                                    // Require valid status codes, otherwise can assume feedback was not sent successfully
                                    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) {
                                        throw new Error("Unable to send Feedback");
                                    }
                                    return [
                                        2,
                                        response
                                    ];
                            }
                        });
                    });
                    return function(scope) {
                        return _ref.apply(this, arguments);
                    };
                }())
            ];
        });
    });
    return _sendFeedbackRequest.apply(this, arguments);
}
/*
 * For reference, the fully built event looks something like this:
 * {
 *     "type": "feedback",
 *     "event_id": "d2132d31b39445f1938d7e21b6bf0ec4",
 *     "timestamp": 1597977777.6189718,
 *     "dist": "1.12",
 *     "platform": "javascript",
 *     "environment": "production",
 *     "release": 42,
 *     "tags": {"transaction": "/organizations/:orgId/performance/:eventSlug/"},
 *     "sdk": {"name": "name", "version": "version"},
 *     "user": {
 *         "id": "123",
 *         "username": "user",
 *         "email": "user@site.com",
 *         "ip_address": "192.168.11.12",
 *     },
 *     "request": {
 *         "url": None,
 *         "headers": {
 *             "user-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.5 Safari/605.1.15"
 *         },
 *     },
 *     "contexts": {
 *         "feedback": {
 *             "message": "test message",
 *             "contact_email": "test@example.com",
 *             "type": "feedback",
 *         },
 *         "trace": {
 *             "trace_id": "4C79F60C11214EB38604F4AE0781BFB2",
 *             "span_id": "FA90FDEAD5F74052",
 *             "type": "trace",
 *         },
 *         "replay": {
 *             "replay_id": "e2d42047b1c5431c8cba85ee2a8ab25d",
 *         },
 *     },
 *   }
 */ /**
 * Public API to send a Feedback item to Sentry
 */ function sendFeedback(param) {
    var name = param.name, email = param.email, message = param.message, _source = param.source, source = _source === void 0 ? FEEDBACK_API_SOURCE : _source, _url = param.url, url = _url === void 0 ? (0,browser/* getLocationHref */.l4)() : _url, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!message) {
        throw new Error("Unable to submit feedback with empty message");
    }
    return sendFeedbackRequest({
        feedback: {
            name: name,
            email: email,
            message: message,
            url: url,
            source: source
        }
    }, options);
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var DEBUG_BUILD =  false || false;
/**
 * Quick and dirty deep merge for the Feedback integration options
 */ function mergeOptions(defaultOptions, optionOverrides) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, defaultOptions, optionOverrides), {
        themeDark: (0,src_object_spread/* default */.Z)({}, defaultOptions.themeDark, optionOverrides.themeDark),
        themeLight: (0,src_object_spread/* default */.Z)({}, defaultOptions.themeLight, optionOverrides.themeLight)
    });
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */ function createActorStyles(d) {
    var style = d.createElement("style");
    style.textContent = "\n.widget__actor {\n  position: fixed;\n  left: var(--left);\n  right: var(--right);\n  bottom: var(--bottom);\n  top: var(--top);\n  z-index: var(--z-index);\n\n  line-height: 16px;\n\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  border-radius: var(--border-radius);\n  cursor: pointer;\n  font-family: inherit;\n  font-size: var(--font-size);\n  font-weight: 600;\n  padding: 16px;\n  text-decoration: none;\n  z-index: 9000;\n\n  color: var(--foreground);\n  background-color: var(--background);\n  border: var(--border);\n  box-shadow: var(--box-shadow);\n  opacity: 1;\n  transition: opacity 0.1s ease-in-out;\n}\n\n.widget__actor:hover {\n  background-color: var(--background-hover);\n}\n\n.widget__actor svg {\n  width: 16px;\n  height: 16px;\n}\n\n.widget__actor--hidden {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n}\n\n.widget__actor__text {\n}\n\n@media (max-width: 600px) {\n  .widget__actor__text {\n    display: none;\n  }\n}\n\n.feedback-icon path {\n  fill: var(--foreground);\n}\n";
    return style;
}
/**
 * Creates <style> element for widget dialog
 */ function createDialogStyles(d) {
    var style = d.createElement("style");
    style.textContent = "\n.dialog {\n  line-height: 25px;\n  background-color: rgba(0, 0, 0, 0.05);\n  border: none;\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 1;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.dialog:not([open]) {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n}\n.dialog:not([open]) .dialog__content {\n  transform: translate(0, -16px) scale(0.98);\n}\n\n.dialog__content {\n  position: fixed;\n  left: var(--left);\n  right: var(--right);\n  bottom: var(--bottom);\n  top: var(--top);\n\n  border: var(--border);\n  border-radius: var(--form-border-radius);\n  background-color: var(--background);\n  color: var(--foreground);\n\n  width: 320px;\n  max-width: 100%;\n  max-height: calc(100% - 2rem);\n  display: flex;\n  flex-direction: column;\n  box-shadow: var(--box-shadow);\n  transition: transform 0.2s ease-in-out;\n  transform: translate(0, 0) scale(1);\n}\n\n.dialog__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 20px;\n  font-weight: 600;\n  padding: 24px 24px 0 24px;\n  margin: 0;\n  margin-bottom: 16px;\n}\n\n.brand-link {\n  display: inline-flex;\n}\n\n.error {\n  color: var(--error);\n  margin-bottom: 16px;\n}\n\n.form {\n  display: grid;\n  overflow: auto;\n  flex-direction: column;\n  gap: 16px;\n  padding: 0 24px 24px;\n}\n\n.form__error-container {\n  color: var(--error);\n}\n\n.form__error-container--hidden {\n  display: none;\n}\n\n.form__label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 0px;\n}\n\n.form__label__text {\n  display: grid;\n  gap: 4px;\n  align-items: center;\n  grid-auto-flow: column;\n  grid-auto-columns: max-content;\n}\n\n.form__label__text--required {\n  font-size: 0.85em;\n}\n\n.form__input {\n  line-height: inherit;\n  background-color: var(--input-background);\n  box-sizing: border-box;\n  border: var(--input-border);\n  border-radius: var(--form-content-border-radius);\n  color: var(--input-foreground);\n  font-family: inherit;\n  font-size: var(--font-size);\n  font-weight: 500;\n  padding: 6px 12px;\n}\n\n.form__input::placeholder {\n  color: var(--input-foreground);\n  opacity: 0.65;\n}\n\n.form__input:focus-visible {\n  outline: 1px auto var(--input-outline-focus);\n}\n\n.form__input--textarea {\n  font-family: inherit;\n  resize: vertical;\n}\n\n.btn-group {\n  display: grid;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.btn {\n  line-height: inherit;\n  border: var(--cancel-border);\n  border-radius: var(--form-content-border-radius);\n  cursor: pointer;\n  font-family: inherit;\n  font-size: var(--font-size);\n  font-weight: 600;\n  padding: 6px 16px;\n}\n.btn[disabled] {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.btn--primary {\n  background-color: var(--submit-background);\n  border-color: var(--submit-border);\n  color: var(--submit-foreground);\n}\n.btn--primary:hover {\n  background-color: var(--submit-background-hover);\n  color: var(--submit-foreground-hover);\n}\n.btn--primary:focus-visible {\n  outline: 1px auto var(--submit-outline-focus);\n}\n\n.btn--default {\n  background-color: var(--cancel-background);\n  color: var(--cancel-foreground);\n  font-weight: 500;\n}\n.btn--default:hover {\n  background-color: var(--cancel-background-hover);\n  color: var(--cancel-foreground-hover);\n}\n.btn--default:focus-visible {\n  outline: 1px auto var(--cancel-outline-focus);\n}\n\n.success-message {\n  background-color: var(--background);\n  border: var(--border);\n  border-radius: var(--border-radius);\n  box-shadow: var(--box-shadow);\n  font-weight: 600;\n  color: var(--success);\n  padding: 12px 24px;\n  line-height: 25px;\n  display: grid;\n  align-items: center;\n  grid-auto-flow: column;\n  gap: 6px;\n  cursor: default;\n}\n\n.success-icon path {\n  fill: var(--success);\n}\n";
    return style;
}
function getThemedCssVariables(theme) {
    return "\n  --background: ".concat(theme.background, ";\n  --background-hover: ").concat(theme.backgroundHover, ";\n  --foreground: ").concat(theme.foreground, ";\n  --error: ").concat(theme.error, ";\n  --success: ").concat(theme.success, ";\n  --border: ").concat(theme.border, ";\n  --border-radius: ").concat(theme.borderRadius, ";\n  --box-shadow: ").concat(theme.boxShadow, ";\n\n  --submit-background: ").concat(theme.submitBackground, ";\n  --submit-background-hover: ").concat(theme.submitBackgroundHover, ";\n  --submit-border: ").concat(theme.submitBorder, ";\n  --submit-outline-focus: ").concat(theme.submitOutlineFocus, ";\n  --submit-foreground: ").concat(theme.submitForeground, ";\n  --submit-foreground-hover: ").concat(theme.submitForegroundHover, ";\n\n  --cancel-background: ").concat(theme.cancelBackground, ";\n  --cancel-background-hover: ").concat(theme.cancelBackgroundHover, ";\n  --cancel-border: ").concat(theme.cancelBorder, ";\n  --cancel-outline-focus: ").concat(theme.cancelOutlineFocus, ";\n  --cancel-foreground: ").concat(theme.cancelForeground, ";\n  --cancel-foreground-hover: ").concat(theme.cancelForegroundHover, ";\n\n  --input-background: ").concat(theme.inputBackground, ";\n  --input-foreground: ").concat(theme.inputForeground, ";\n  --input-border: ").concat(theme.inputBorder, ";\n  --input-outline-focus: ").concat(theme.inputOutlineFocus, ";\n\n  --form-border-radius: ").concat(theme.formBorderRadius, ";\n  --form-content-border-radius: ").concat(theme.formContentBorderRadius, ";\n  ");
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */ function createMainStyles(d, colorScheme, themes) {
    var style = d.createElement("style");
    style.textContent = "\n:host {\n  --bottom: 1rem;\n  --right: 1rem;\n  --top: auto;\n  --left: auto;\n  --z-index: 100000;\n  --font-family: ".concat(themes.light.fontFamily, ";\n  --font-size: ").concat(themes.light.fontSize, ";\n\n  position: fixed;\n  left: var(--left);\n  right: var(--right);\n  bottom: var(--bottom);\n  top: var(--top);\n  z-index: var(--z-index);\n\n  font-family: var(--font-family);\n  font-size: var(--font-size);\n\n  ").concat(getThemedCssVariables(colorScheme === "dark" ? themes.dark : themes.light), "\n}\n\n").concat(colorScheme === "system" ? "\n@media (prefers-color-scheme: dark) {\n  :host {\n    ".concat(getThemedCssVariables(themes.dark), "\n  }\n}") : "", "\n}");
    return style;
}
/**
 * Creates shadow host
 */ function createShadowHost(param) {
    var id = param.id, colorScheme = param.colorScheme, themeDark = param.themeDark, themeLight = param.themeLight;
    try {
        var doc = WINDOW.document;
        // Create the host
        var host = doc.createElement("div");
        host.id = id;
        // Create the shadow root
        var shadow = host.attachShadow({
            mode: "open"
        });
        shadow.appendChild(createMainStyles(doc, colorScheme, {
            dark: themeDark,
            light: themeLight
        }));
        shadow.appendChild(createDialogStyles(doc));
        return {
            shadow: shadow,
            host: host
        };
    } catch (e) {
        // Shadow DOM probably not supported
        logger/* logger.warn */.kg.warn("[Feedback] Browser does not support shadow DOM API");
        throw new Error("Browser does not support shadow DOM API.");
    }
}
function handleFeedbackSubmit(dialog, feedback, options) {
    return _handleFeedbackSubmit.apply(this, arguments);
}
function _handleFeedbackSubmit() {
    _handleFeedbackSubmit = /**
 * Handles UI behavior of dialog when feedback is submitted, calls
 * `sendFeedback` to send feedback.
 */ (0,_async_to_generator/* default */.Z)(function(dialog, feedback, options) {
        var showFetchError, resp, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!dialog) {
                        // Not sure when this would happen
                        return [
                            2
                        ];
                    }
                    showFetchError = function() {
                        if (!dialog) {
                            return;
                        }
                        dialog.showError("There was a problem submitting feedback, please wait and try again.");
                    };
                    dialog.hideError();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        sendFeedback((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, feedback), {
                            source: FEEDBACK_WIDGET_SOURCE
                        }), options)
                    ];
                case 2:
                    resp = _state.sent();
                    // Success!
                    return [
                        2,
                        resp
                    ];
                case 3:
                    err = _state.sent();
                    DEBUG_BUILD && logger/* logger.error */.kg.error(err);
                    showFetchError();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _handleFeedbackSubmit.apply(this, arguments);
}
/**
 * Helper function to set a dict of attributes on element (w/ specified namespace)
 */ function setAttributesNS(el, attributes) {
    Object.entries(attributes).forEach(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], val = _param[1];
        el.setAttributeNS(null, key, val);
    });
    return el;
}
var SIZE = 20;
var XMLNS$2 = "http://www.w3.org/2000/svg";
/**
 * Feedback Icon
 */ function Icon() {
    var createElementNS = function(tagName) {
        return WINDOW.document.createElementNS(XMLNS$2, tagName);
    };
    var svg = setAttributesNS(createElementNS("svg"), {
        class: "feedback-icon",
        width: "".concat(SIZE),
        height: "".concat(SIZE),
        viewBox: "0 0 ".concat(SIZE, " ").concat(SIZE),
        fill: "none"
    });
    var g = setAttributesNS(createElementNS("g"), {
        clipPath: "url(#clip0_57_80)"
    });
    var _obj;
    var path = setAttributesNS(createElementNS("path"), (_obj = {}, (0,src_define_property/* default */.Z)(_obj, "fill-rule", "evenodd"), (0,src_define_property/* default */.Z)(_obj, "clip-rule", "evenodd"), (0,src_define_property/* default */.Z)(_obj, "d", "M15.6622 15H12.3997C12.2129 14.9959 12.031 14.9396 11.8747 14.8375L8.04965 12.2H7.49956V19.1C7.4875 19.3348 7.3888 19.5568 7.22256 19.723C7.05632 19.8892 6.83435 19.9879 6.59956 20H2.04956C1.80193 19.9968 1.56535 19.8969 1.39023 19.7218C1.21511 19.5467 1.1153 19.3101 1.11206 19.0625V12.2H0.949652C0.824431 12.2017 0.700142 12.1783 0.584123 12.1311C0.468104 12.084 0.362708 12.014 0.274155 11.9255C0.185602 11.8369 0.115689 11.7315 0.0685419 11.6155C0.0213952 11.4995 -0.00202913 11.3752 -0.00034808 11.25V3.75C-0.00900498 3.62067 0.0092504 3.49095 0.0532651 3.36904C0.0972798 3.24712 0.166097 3.13566 0.255372 3.04168C0.344646 2.94771 0.452437 2.87327 0.571937 2.82307C0.691437 2.77286 0.82005 2.74798 0.949652 2.75H8.04965L11.8747 0.1625C12.031 0.0603649 12.2129 0.00407221 12.3997 0H15.6622C15.9098 0.00323746 16.1464 0.103049 16.3215 0.278167C16.4966 0.453286 16.5964 0.689866 16.5997 0.9375V3.25269C17.3969 3.42959 18.1345 3.83026 18.7211 4.41679C19.5322 5.22788 19.9878 6.32796 19.9878 7.47502C19.9878 8.62209 19.5322 9.72217 18.7211 10.5333C18.1345 11.1198 17.3969 11.5205 16.5997 11.6974V14.0125C16.6047 14.1393 16.5842 14.2659 16.5395 14.3847C16.4948 14.5035 16.4268 14.6121 16.3394 14.7042C16.252 14.7962 16.147 14.8698 16.0307 14.9206C15.9144 14.9714 15.7891 14.9984 15.6622 15ZM1.89695 10.325H1.88715V4.625H8.33715C8.52423 4.62301 8.70666 4.56654 8.86215 4.4625L12.6872 1.875H14.7247V13.125H12.6872L8.86215 10.4875C8.70666 10.3835 8.52423 10.327 8.33715 10.325H2.20217C2.15205 10.3167 2.10102 10.3125 2.04956 10.3125C1.9981 10.3125 1.94708 10.3167 1.89695 10.325ZM2.98706 12.2V18.1625H5.66206V12.2H2.98706ZM16.5997 9.93612V5.01393C16.6536 5.02355 16.7072 5.03495 16.7605 5.04814C17.1202 5.13709 17.4556 5.30487 17.7425 5.53934C18.0293 5.77381 18.2605 6.06912 18.4192 6.40389C18.578 6.73866 18.6603 7.10452 18.6603 7.47502C18.6603 7.84552 18.578 8.21139 18.4192 8.54616C18.2605 8.88093 18.0293 9.17624 17.7425 9.41071C17.4556 9.64518 17.1202 9.81296 16.7605 9.90191C16.7072 9.91509 16.6536 9.9265 16.5997 9.93612Z"), _obj));
    svg.appendChild(g).appendChild(path);
    var speakerDefs = createElementNS("defs");
    var speakerClipPathDef = setAttributesNS(createElementNS("clipPath"), {
        id: "clip0_57_80"
    });
    var speakerRect = setAttributesNS(createElementNS("rect"), {
        width: "".concat(SIZE),
        height: "".concat(SIZE),
        fill: "white"
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return {
        get el () {
            return svg;
        }
    };
}
/**
 * Helper function to create an element. Could be used as a JSX factory
 * (i.e. React-like syntax).
 */ function createElement(tagName, attributes) {
    for(var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        children[_key - 2] = arguments[_key];
    }
    var doc = WINDOW.document;
    var element = doc.createElement(tagName);
    if (attributes) {
        Object.entries(attributes).forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), attribute = _param[0], attributeValue = _param[1];
            if (attribute === "className" && typeof attributeValue === "string") {
                // JSX does not allow class as a valid name
                element.setAttribute("class", attributeValue);
            } else if (typeof attributeValue === "boolean" && attributeValue) {
                element.setAttribute(attribute, "");
            } else if (typeof attributeValue === "string") {
                element.setAttribute(attribute, attributeValue);
            } else if (attribute.startsWith("on") && typeof attributeValue === "function") {
                element.addEventListener(attribute.substring(2).toLowerCase(), attributeValue);
            }
        });
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var child = _step.value;
            appendChild(element, child);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return element;
}
function appendChild(parent, child) {
    var doc = WINDOW.document;
    if (typeof child === "undefined" || child === null) {
        return;
    }
    if (Array.isArray(child)) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = child[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                appendChild(parent, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else if (child === false) ;
    else if (typeof child === "string") {
        parent.appendChild(doc.createTextNode(child));
    } else if ((0,_instanceof/* default */.Z)(child, Node)) {
        parent.appendChild(child);
    } else {
        parent.appendChild(doc.createTextNode(String(child)));
    }
}
/**
 *
 */ function Actor(param) {
    var buttonLabel = param.buttonLabel, onClick = param.onClick;
    var _handleClick = function _handleClick(e) {
        onClick && onClick(e);
    };
    var _obj;
    var el = createElement("button", (_obj = {
        type: "button",
        className: "widget__actor"
    }, (0,src_define_property/* default */.Z)(_obj, "aria-label", buttonLabel), (0,src_define_property/* default */.Z)(_obj, "aria-hidden", "false"), _obj), Icon().el, buttonLabel ? createElement("span", {
        className: "widget__actor__text"
    }, buttonLabel) : null);
    el.addEventListener("click", _handleClick);
    return {
        get el () {
            return el;
        },
        show: function() {
            el.classList.remove("widget__actor--hidden");
            el.setAttribute("aria-hidden", "false");
        },
        hide: function() {
            el.classList.add("widget__actor--hidden");
            el.setAttribute("aria-hidden", "true");
        }
    };
}
/**
 *
 */ function SubmitButton(param) {
    var label = param.label;
    var el = createElement("button", (0,src_define_property/* default */.Z)({
        type: "submit",
        className: "btn btn--primary"
    }, "aria-label", label), label);
    return {
        el: el
    };
}
function retrieveStringValue(formData, key) {
    var value = formData.get(key);
    if (typeof value === "string") {
        return value.trim();
    }
    return "";
}
/**
 * Creates the form element
 */ function Form(param) {
    var nameLabel = param.nameLabel, namePlaceholder = param.namePlaceholder, emailLabel = param.emailLabel, emailPlaceholder = param.emailPlaceholder, messageLabel = param.messageLabel, messagePlaceholder = param.messagePlaceholder, isRequiredLabel = param.isRequiredLabel, cancelButtonLabel = param.cancelButtonLabel, submitButtonLabel = param.submitButtonLabel, showName = param.showName, showEmail = param.showEmail, isNameRequired = param.isNameRequired, isEmailRequired = param.isEmailRequired, defaultName = param.defaultName, defaultEmail = param.defaultEmail, onCancel = param.onCancel, onSubmit = param.onSubmit;
    var handleSubmit = function handleSubmit(e) {
        e.preventDefault();
        if (!(0,_instanceof/* default */.Z)(e.target, HTMLFormElement)) {
            return;
        }
        try {
            if (onSubmit) {
                var formData = new FormData(e.target);
                var feedback = {
                    name: retrieveStringValue(formData, "name"),
                    email: retrieveStringValue(formData, "email"),
                    message: retrieveStringValue(formData, "message")
                };
                onSubmit(feedback);
            }
        } catch (e2) {
        // pass
        }
    };
    var showError = function showError(message) {
        errorEl.textContent = message;
        errorEl.classList.remove("form__error-container--hidden");
        errorEl.setAttribute("aria-hidden", "false");
    };
    var hideError = function hideError() {
        errorEl.textContent = "";
        errorEl.classList.add("form__error-container--hidden");
        errorEl.setAttribute("aria-hidden", "true");
    };
    var ref = SubmitButton({
        label: submitButtonLabel
    }), submitEl = ref.el;
    var errorEl = createElement("div", (0,src_define_property/* default */.Z)({
        className: "form__error-container form__error-container--hidden"
    }, "aria-hidden", "true"));
    var _obj;
    var nameEl = createElement("input", (_obj = {
        id: "name",
        type: showName ? "text" : "hidden"
    }, (0,src_define_property/* default */.Z)(_obj, "aria-hidden", showName ? "false" : "true"), (0,src_define_property/* default */.Z)(_obj, "name", "name"), (0,src_define_property/* default */.Z)(_obj, "required", isNameRequired), (0,src_define_property/* default */.Z)(_obj, "className", "form__input"), (0,src_define_property/* default */.Z)(_obj, "placeholder", namePlaceholder), (0,src_define_property/* default */.Z)(_obj, "value", defaultName), _obj));
    var _obj1;
    var emailEl = createElement("input", (_obj1 = {
        id: "email",
        type: showEmail ? "text" : "hidden"
    }, (0,src_define_property/* default */.Z)(_obj1, "aria-hidden", showEmail ? "false" : "true"), (0,src_define_property/* default */.Z)(_obj1, "name", "email"), (0,src_define_property/* default */.Z)(_obj1, "required", isEmailRequired), (0,src_define_property/* default */.Z)(_obj1, "className", "form__input"), (0,src_define_property/* default */.Z)(_obj1, "placeholder", emailPlaceholder), (0,src_define_property/* default */.Z)(_obj1, "value", defaultEmail), _obj1));
    var messageEl = createElement("textarea", {
        id: "message",
        autoFocus: "true",
        rows: "5",
        name: "message",
        required: true,
        className: "form__input form__input--textarea",
        placeholder: messagePlaceholder
    });
    var _obj2;
    var cancelEl = createElement("button", (_obj2 = {
        type: "button",
        className: "btn btn--default"
    }, (0,src_define_property/* default */.Z)(_obj2, "aria-label", cancelButtonLabel), (0,src_define_property/* default */.Z)(_obj2, "onClick", function(e) {
        onCancel && onCancel(e);
    }), _obj2), cancelButtonLabel);
    var formEl = createElement("form", {
        className: "form",
        onSubmit: handleSubmit
    }, [
        errorEl,
        showName && createElement("label", {
            htmlFor: "name",
            className: "form__label"
        }, [
            createElement("span", {
                className: "form__label__text"
            }, nameLabel, isNameRequired && createElement("span", {
                className: "form__label__text--required"
            }, " ".concat(isRequiredLabel))),
            nameEl, 
        ]),
        !showName && nameEl,
        showEmail && createElement("label", {
            htmlFor: "email",
            className: "form__label"
        }, [
            createElement("span", {
                className: "form__label__text"
            }, emailLabel, isEmailRequired && createElement("span", {
                className: "form__label__text--required"
            }, " ".concat(isRequiredLabel))),
            emailEl, 
        ]),
        !showEmail && emailEl,
        createElement("label", {
            htmlFor: "message",
            className: "form__label"
        }, [
            createElement("span", {
                className: "form__label__text"
            }, messageLabel, createElement("span", {
                className: "form__label__text--required"
            }, " ".concat(isRequiredLabel))),
            messageEl, 
        ]),
        createElement("div", {
            className: "btn-group"
        }, [
            submitEl,
            cancelEl
        ]), 
    ]);
    return {
        get el () {
            return formEl;
        },
        showError: showError,
        hideError: hideError
    };
}
var XMLNS$1 = "http://www.w3.org/2000/svg";
/**
 * Sentry Logo
 */ function Logo(param) {
    var colorScheme = param.colorScheme;
    var createElementNS = function(tagName) {
        return WINDOW.document.createElementNS(XMLNS$1, tagName);
    };
    var svg = setAttributesNS(createElementNS("svg"), {
        class: "sentry-logo",
        width: "32",
        height: "30",
        viewBox: "0 0 72 66",
        fill: "none"
    });
    var path = setAttributesNS(createElementNS("path"), {
        transform: "translate(11, 11)",
        d: "M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z"
    });
    svg.append(path);
    var defs = createElementNS("defs");
    var style = createElementNS("style");
    style.textContent = "\n    path {\n      fill: ".concat(colorScheme === "dark" ? "#fff" : "#362d59", ";\n    }");
    if (colorScheme === "system") {
        style.textContent += "\n    @media (prefers-color-scheme: dark) {\n      path: {\n        fill: '#fff';\n      }\n    }\n    ";
    }
    defs.append(style);
    svg.append(defs);
    return {
        get el () {
            return svg;
        }
    };
}
/**
 * Feedback dialog component that has the form
 */ function Dialog(_param) {
    var handleDialogClick = /**
   * Handles when the dialog is clicked. In our case, the dialog is the
   * semi-transparent bg behind the form. We want clicks outside of the form to
   * hide the form.
   */ function handleDialogClick() {
        close();
        // Only this should trigger `onClose`, we don't want the `close()` method to
        // trigger it, otherwise it can cause cycles.
        onClosed && onClosed();
    };
    var close = /**
   * Close the dialog
   */ function close() {
        if (el) {
            el.open = false;
        }
    };
    var open = /**
   * Opens the dialog
   */ function open() {
        if (el) {
            el.open = true;
        }
    };
    var checkIsOpen = /**
   * Check if dialog is currently opened
   */ function checkIsOpen() {
        return el && el.open === true || false;
    };
    var formTitle = _param.formTitle, showBranding = _param.showBranding, showName = _param.showName, showEmail = _param.showEmail, isNameRequired = _param.isNameRequired, isEmailRequired = _param.isEmailRequired, colorScheme = _param.colorScheme, defaultName = _param.defaultName, defaultEmail = _param.defaultEmail, onClosed = _param.onClosed, onCancel = _param.onCancel, onSubmit = _param.onSubmit, textLabels = (0,_object_without_properties/* default */.Z)(_param, [
        "formTitle",
        "showBranding",
        "showName",
        "showEmail",
        "isNameRequired",
        "isEmailRequired",
        "colorScheme",
        "defaultName",
        "defaultEmail",
        "onClosed",
        "onCancel",
        "onSubmit"
    ]);
    var el = null;
    var ref = Form((0,src_object_spread/* default */.Z)({
        showEmail: showEmail,
        showName: showName,
        isEmailRequired: isEmailRequired,
        isNameRequired: isNameRequired,
        defaultName: defaultName,
        defaultEmail: defaultEmail,
        onSubmit: onSubmit,
        onCancel: onCancel
    }, textLabels)), formEl = ref.el, showError = ref.showError, hideError = ref.hideError;
    el = createElement("dialog", {
        className: "dialog",
        open: true,
        onClick: handleDialogClick
    }, createElement("div", {
        className: "dialog__content",
        onClick: function(e) {
            // Stop event propagation so clicks on content modal do not propagate to dialog (which will close dialog)
            e.stopPropagation();
        }
    }, createElement("h2", {
        className: "dialog__header"
    }, formTitle, showBranding && createElement("a", {
        className: "brand-link",
        target: "_blank",
        href: "https://sentry.io/welcome/",
        title: "Powered by Sentry",
        rel: "noopener noreferrer"
    }, Logo({
        colorScheme: colorScheme
    }).el)), formEl));
    return {
        get el () {
            return el;
        },
        showError: showError,
        hideError: hideError,
        open: open,
        close: close,
        checkIsOpen: checkIsOpen
    };
}
var WIDTH = 16;
var HEIGHT = 17;
var XMLNS = "http://www.w3.org/2000/svg";
/**
 * Success Icon (checkmark)
 */ function SuccessIcon() {
    var createElementNS = function(tagName) {
        return WINDOW.document.createElementNS(XMLNS, tagName);
    };
    var svg = setAttributesNS(createElementNS("svg"), {
        class: "success-icon",
        width: "".concat(WIDTH),
        height: "".concat(HEIGHT),
        viewBox: "0 0 ".concat(WIDTH, " ").concat(HEIGHT),
        fill: "none"
    });
    var g = setAttributesNS(createElementNS("g"), {
        clipPath: "url(#clip0_57_156)"
    });
    var _obj;
    var path2 = setAttributesNS(createElementNS("path"), (_obj = {}, (0,src_define_property/* default */.Z)(_obj, "fill-rule", "evenodd"), (0,src_define_property/* default */.Z)(_obj, "clip-rule", "evenodd"), (0,src_define_property/* default */.Z)(_obj, "d", "M3.55544 15.1518C4.87103 16.0308 6.41775 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.91775 15.5308 5.37103 14.6518 4.05544C13.7727 2.73985 12.5233 1.71447 11.0615 1.10897C9.59966 0.503466 7.99113 0.34504 6.43928 0.653721C4.88743 0.962403 3.46197 1.72433 2.34315 2.84315C1.22433 3.96197 0.462403 5.38743 0.153721 6.93928C-0.15496 8.49113 0.00346625 10.0997 0.608967 11.5615C1.21447 13.0233 2.23985 14.2727 3.55544 15.1518ZM4.40546 3.1204C5.46945 2.40946 6.72036 2.03 8 2.03C9.71595 2.03 11.3616 2.71166 12.575 3.92502C13.7883 5.13838 14.47 6.78405 14.47 8.5C14.47 9.77965 14.0905 11.0306 13.3796 12.0945C12.6687 13.1585 11.6582 13.9878 10.476 14.4775C9.29373 14.9672 7.99283 15.0953 6.73777 14.8457C5.48271 14.596 4.32987 13.9798 3.42502 13.075C2.52018 12.1701 1.90397 11.0173 1.65432 9.76224C1.40468 8.50718 1.5328 7.20628 2.0225 6.02404C2.5122 4.8418 3.34148 3.83133 4.40546 3.1204Z"), _obj));
    var path = setAttributesNS(createElementNS("path"), {
        d: "M6.68775 12.4297C6.78586 12.4745 6.89218 12.4984 7 12.5C7.11275 12.4955 7.22315 12.4664 7.32337 12.4145C7.4236 12.3627 7.51121 12.2894 7.58 12.2L12 5.63999C12.0848 5.47724 12.1071 5.28902 12.0625 5.11098C12.0178 4.93294 11.9095 4.77744 11.7579 4.67392C11.6064 4.57041 11.4221 4.52608 11.24 4.54931C11.0579 4.57254 10.8907 4.66173 10.77 4.79999L6.88 10.57L5.13 8.56999C5.06508 8.49566 4.98613 8.43488 4.89768 8.39111C4.80922 8.34735 4.713 8.32148 4.61453 8.31498C4.51605 8.30847 4.41727 8.32147 4.32382 8.35322C4.23038 8.38497 4.14413 8.43484 4.07 8.49999C3.92511 8.63217 3.83692 8.81523 3.82387 9.01092C3.81083 9.2066 3.87393 9.39976 4 9.54999L6.43 12.24C6.50187 12.3204 6.58964 12.385 6.68775 12.4297Z"
    });
    svg.appendChild(g).append(path, path2);
    var speakerDefs = createElementNS("defs");
    var speakerClipPathDef = setAttributesNS(createElementNS("clipPath"), {
        id: "clip0_57_156"
    });
    var speakerRect = setAttributesNS(createElementNS("rect"), {
        width: "".concat(WIDTH),
        height: "".concat(WIDTH),
        fill: "white",
        transform: "translate(0 0.5)"
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return {
        get el () {
            return svg;
        }
    };
}
/**
 * Feedback dialog component that has the form
 */ function SuccessMessage(param) {
    var message = param.message, onRemove = param.onRemove;
    var remove = function remove() {
        if (!el) {
            return;
        }
        el.remove();
        onRemove && onRemove();
    };
    var el = createElement("div", {
        className: "success-message",
        onClick: remove
    }, SuccessIcon().el, message);
    return {
        el: el,
        remove: remove
    };
}
/**
 * Creates a new widget. Returns public methods that control widget behavior.
 */ function createWidget(_param) {
    var showSuccessMessage = /**
   * Show the success message for 5 seconds
   */ function showSuccessMessage() {
        if (!shadow) {
            return;
        }
        try {
            var success = SuccessMessage({
                message: options.successMessageText,
                onRemove: function() {
                    if (timeoutId) {
                        clearTimeout(timeoutId);
                    }
                    showActor();
                }
            });
            if (!success.el) {
                throw new Error("Unable to show success message");
            }
            shadow.appendChild(success.el);
            var timeoutId = setTimeout(function() {
                if (success) {
                    success.remove();
                }
            }, 5000);
        } catch (err) {
            // TODO: error handling
            logger/* logger.error */.kg.error(err);
        }
    };
    var handleOpenDialog = /**
   * Internal handler when dialog is opened
   */ function handleOpenDialog() {
        // Flush replay if integration exists
        var client = (0,esm_exports/* getClient */.s3)();
        var replay = client && client.getIntegrationByName && client.getIntegrationByName("Replay");
        if (!replay) {
            return;
        }
        replay.flush().catch(function(err) {
            DEBUG_BUILD && logger/* logger.error */.kg.error(err);
        });
    };
    var showActor = /**
   * Displays the default actor
   */ function showActor() {
        actor && actor.show();
    };
    var hideActor = /**
   * Hides the default actor
   */ function hideActor() {
        actor && actor.hide();
    };
    var removeActor = /**
   * Removes the default actor element
   */ function removeActor() {
        actor && actor.el && actor.el.remove();
    };
    var openDialog = /**
   *
   */ function openDialog() {
        try {
            if (dialog) {
                dialog.open();
                isDialogOpen = true;
                if (options.onFormOpen) {
                    options.onFormOpen();
                }
                handleOpenDialog();
                return;
            }
            var userKey = options.useSentryUser;
            var scope = (0,esm_exports/* getCurrentScope */.nZ)();
            var user = scope && scope.getUser();
            dialog = Dialog({
                colorScheme: options.colorScheme,
                showBranding: options.showBranding,
                showName: options.showName || options.isNameRequired,
                showEmail: options.showEmail || options.isEmailRequired,
                isNameRequired: options.isNameRequired,
                isEmailRequired: options.isEmailRequired,
                formTitle: options.formTitle,
                cancelButtonLabel: options.cancelButtonLabel,
                submitButtonLabel: options.submitButtonLabel,
                emailLabel: options.emailLabel,
                emailPlaceholder: options.emailPlaceholder,
                messageLabel: options.messageLabel,
                messagePlaceholder: options.messagePlaceholder,
                nameLabel: options.nameLabel,
                namePlaceholder: options.namePlaceholder,
                isRequiredLabel: options.isRequiredLabel,
                defaultName: userKey && user && user[userKey.name] || "",
                defaultEmail: userKey && user && user[userKey.email] || "",
                onClosed: function() {
                    showActor();
                    isDialogOpen = false;
                    if (options.onFormClose) {
                        options.onFormClose();
                    }
                },
                onCancel: function() {
                    closeDialog();
                    showActor();
                },
                onSubmit: _handleFeedbackSubmit
            });
            if (!dialog.el) {
                throw new Error("Unable to open Feedback dialog");
            }
            shadow.appendChild(dialog.el);
            // Hides the default actor whenever dialog is opened
            hideActor();
            if (options.onFormOpen) {
                options.onFormOpen();
            }
            handleOpenDialog();
        } catch (err) {
            // TODO: Error handling?
            logger/* logger.error */.kg.error(err);
        }
    };
    var closeDialog = /**
   * Closes the dialog
   */ function closeDialog() {
        if (dialog) {
            dialog.close();
            isDialogOpen = false;
            if (options.onFormClose) {
                options.onFormClose();
            }
        }
    };
    var removeDialog = /**
   * Removes the dialog element from DOM
   */ function removeDialog() {
        if (dialog) {
            closeDialog();
            var dialogEl = dialog.el;
            dialogEl && dialogEl.remove();
            dialog = undefined;
        }
    };
    var handleActorClick = /**
   *
   */ function handleActorClick() {
        // Open dialog
        if (!isDialogOpen) {
            openDialog();
        }
        // Hide actor button
        hideActor();
    };
    var shadow = _param.shadow, _options = _param.options, _shouldCreateActor = _options.shouldCreateActor, shouldCreateActor = _shouldCreateActor === void 0 ? true : _shouldCreateActor, attachTo = _param.attachTo, options = (0,_object_without_properties/* default */.Z)(_param.options, [
        "shouldCreateActor"
    ]);
    var actor;
    var dialog;
    var isDialogOpen = false;
    function _handleFeedbackSubmit(feedback) {
        return __handleFeedbackSubmit.apply(this, arguments);
    }
    function __handleFeedbackSubmit() {
        __handleFeedbackSubmit = /**
   * Handler for when the feedback form is completed by the user. This will
   * create and send the feedback message as an event.
   */ (0,_async_to_generator/* default */.Z)(function(feedback) {
            var emptyField, result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!dialog) {
                            return [
                                2
                            ];
                        }
                        emptyField = [];
                        if (options.isNameRequired && !feedback.name) {
                            emptyField.push(options.nameLabel);
                        }
                        if (options.isEmailRequired && !feedback.email) {
                            emptyField.push(options.emailLabel);
                        }
                        if (!feedback.message) {
                            emptyField.push(options.messageLabel);
                        }
                        if (emptyField.length > 0) {
                            dialog.showError("Please enter in the following required fields: ".concat(emptyField.join(", ")));
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            handleFeedbackSubmit(dialog, feedback)
                        ];
                    case 1:
                        result = _state.sent();
                        // Error submitting feedback
                        if (!result) {
                            if (options.onSubmitError) {
                                options.onSubmitError();
                            }
                            return [
                                2
                            ];
                        }
                        // Success
                        removeDialog();
                        showSuccessMessage();
                        if (options.onSubmitSuccess) {
                            options.onSubmitSuccess();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return __handleFeedbackSubmit.apply(this, arguments);
    }
    if (attachTo) {
        attachTo.addEventListener("click", handleActorClick);
    } else if (shouldCreateActor) {
        actor = Actor({
            buttonLabel: options.buttonLabel,
            onClick: handleActorClick
        });
        actor.el && shadow.appendChild(actor.el);
    }
    return {
        get actor () {
            return actor;
        },
        get dialog () {
            return dialog;
        },
        showActor: showActor,
        hideActor: hideActor,
        removeActor: removeActor,
        openDialog: openDialog,
        closeDialog: closeDialog,
        removeDialog: removeDialog
    };
}
var doc = WINDOW.document;
var feedbackIntegration = function(options) {
    // eslint-disable-next-line deprecation/deprecation
    return new Feedback(options);
};
/**
 * Feedback integration. When added as an integration to the SDK, it will
 * inject a button in the bottom-right corner of the window that opens a
 * feedback modal when clicked.
 *
 * @deprecated Use `feedbackIntegration()` instead.
 */ var Feedback = /*#__PURE__*/ function() {
    "use strict";
    function Feedback() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _autoInject = ref.autoInject, autoInject = _autoInject === void 0 ? true : _autoInject, _id = ref.id, id = _id === void 0 ? "sentry-feedback" : _id, _isEmailRequired = ref.isEmailRequired, isEmailRequired = _isEmailRequired === void 0 ? false : _isEmailRequired, _isNameRequired = ref.isNameRequired, isNameRequired = _isNameRequired === void 0 ? false : _isNameRequired, _showBranding = ref.showBranding, showBranding = _showBranding === void 0 ? true : _showBranding, _showEmail = ref.showEmail, showEmail = _showEmail === void 0 ? true : _showEmail, _showName = ref.showName, showName = _showName === void 0 ? true : _showName, _useSentryUser = ref.useSentryUser, useSentryUser = _useSentryUser === void 0 ? {
            email: "email",
            name: "username"
        } : _useSentryUser, themeDark = ref.themeDark, themeLight = ref.themeLight, _colorScheme = ref.colorScheme, colorScheme = _colorScheme === void 0 ? "system" : _colorScheme, _buttonLabel = ref.buttonLabel, buttonLabel = _buttonLabel === void 0 ? ACTOR_LABEL : _buttonLabel, _cancelButtonLabel = ref.cancelButtonLabel, cancelButtonLabel = _cancelButtonLabel === void 0 ? CANCEL_BUTTON_LABEL : _cancelButtonLabel, _submitButtonLabel = ref.submitButtonLabel, submitButtonLabel = _submitButtonLabel === void 0 ? SUBMIT_BUTTON_LABEL : _submitButtonLabel, _formTitle = ref.formTitle, formTitle = _formTitle === void 0 ? FORM_TITLE : _formTitle, _emailPlaceholder = ref.emailPlaceholder, emailPlaceholder = _emailPlaceholder === void 0 ? EMAIL_PLACEHOLDER : _emailPlaceholder, _emailLabel = ref.emailLabel, emailLabel = _emailLabel === void 0 ? EMAIL_LABEL : _emailLabel, _messagePlaceholder = ref.messagePlaceholder, messagePlaceholder = _messagePlaceholder === void 0 ? MESSAGE_PLACEHOLDER : _messagePlaceholder, _messageLabel = ref.messageLabel, messageLabel = _messageLabel === void 0 ? MESSAGE_LABEL : _messageLabel, _namePlaceholder = ref.namePlaceholder, namePlaceholder = _namePlaceholder === void 0 ? NAME_PLACEHOLDER : _namePlaceholder, _nameLabel = ref.nameLabel, nameLabel = _nameLabel === void 0 ? NAME_LABEL : _nameLabel, _isRequiredLabel = ref.isRequiredLabel, isRequiredLabel = _isRequiredLabel === void 0 ? IS_REQUIRED_LABEL : _isRequiredLabel, _successMessageText = ref.successMessageText, successMessageText = _successMessageText === void 0 ? SUCCESS_MESSAGE_TEXT : _successMessageText, onFormClose = ref.onFormClose, onFormOpen = ref.onFormOpen, onSubmitError = ref.onSubmitError, onSubmitSuccess = ref.onSubmitSuccess;
        (0,_class_call_check/* default */.Z)(this, Feedback);
        // eslint-disable-next-line deprecation/deprecation
        this.name = Feedback.id;
        // tsc fails if these are not initialized explicitly constructor, e.g. can't call `_initialize()`
        this._host = null;
        this._shadow = null;
        this._widget = null;
        this._widgets = new Set();
        this._hasInsertedActorStyles = false;
        this.options = {
            autoInject: autoInject,
            showBranding: showBranding,
            id: id,
            isEmailRequired: isEmailRequired,
            isNameRequired: isNameRequired,
            showEmail: showEmail,
            showName: showName,
            useSentryUser: useSentryUser,
            colorScheme: colorScheme,
            themeDark: (0,src_object_spread/* default */.Z)({}, DEFAULT_THEME.dark, themeDark),
            themeLight: (0,src_object_spread/* default */.Z)({}, DEFAULT_THEME.light, themeLight),
            buttonLabel: buttonLabel,
            cancelButtonLabel: cancelButtonLabel,
            submitButtonLabel: submitButtonLabel,
            formTitle: formTitle,
            emailLabel: emailLabel,
            emailPlaceholder: emailPlaceholder,
            messageLabel: messageLabel,
            messagePlaceholder: messagePlaceholder,
            nameLabel: nameLabel,
            namePlaceholder: namePlaceholder,
            isRequiredLabel: isRequiredLabel,
            successMessageText: successMessageText,
            onFormClose: onFormClose,
            onFormOpen: onFormOpen,
            onSubmitError: onSubmitError,
            onSubmitSuccess: onSubmitSuccess
        };
    }
    (0,_create_class/* default */.Z)(Feedback, [
        {
            /**
   * Setup and initialize feedback container
   */ key: "setupOnce",
            value: function setupOnce() {
                if (!(0,isBrowser/* isBrowser */.j)()) {
                    return;
                }
                try {
                    this._cleanupWidgetIfExists();
                    var autoInject = this.options.autoInject;
                    if (!autoInject) {
                        // Nothing to do here
                        return;
                    }
                    this._createWidget(this.options);
                } catch (err) {
                    DEBUG_BUILD && logger/* logger.error */.kg.error(err);
                }
            }
        },
        {
            /**
   * Allows user to open the dialog box. Creates a new widget if
   * `autoInject` was false, otherwise re-uses the default widget that was
   * created during initialization of the integration.
   */ key: "openDialog",
            value: function openDialog() {
                if (!this._widget) {
                    this._createWidget((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.options), {
                        shouldCreateActor: false
                    }));
                }
                if (!this._widget) {
                    return;
                }
                this._widget.openDialog();
            }
        },
        {
            /**
   * Closes the dialog for the default widget, if it exists
   */ key: "closeDialog",
            value: function closeDialog() {
                if (!this._widget) {
                    // Nothing to do if widget does not exist
                    return;
                }
                this._widget.closeDialog();
            }
        },
        {
            /**
   * Adds click listener to attached element to open a feedback dialog
   */ key: "attachTo",
            value: function attachTo(el, optionOverrides) {
                var _this = this;
                try {
                    var options = mergeOptions(this.options, optionOverrides || {});
                    return this._ensureShadowHost(options, function(param) {
                        var shadow = param.shadow;
                        var targetEl = typeof el === "string" ? doc.querySelector(el) : typeof el.addEventListener === "function" ? el : null;
                        if (!targetEl) {
                            DEBUG_BUILD && logger/* logger.error */.kg.error("[Feedback] Unable to attach to target element");
                            return null;
                        }
                        var widget = createWidget({
                            shadow: shadow,
                            options: options,
                            attachTo: targetEl
                        });
                        _this._widgets.add(widget);
                        if (!_this._widget) {
                            _this._widget = widget;
                        }
                        return widget;
                    });
                } catch (err) {
                    DEBUG_BUILD && logger/* logger.error */.kg.error(err);
                    return null;
                }
            }
        },
        {
            /**
   * Creates a new widget. Accepts partial options to override any options passed to constructor.
   */ key: "createWidget",
            value: function createWidget(optionOverrides) {
                try {
                    return this._createWidget(mergeOptions(this.options, optionOverrides || {}));
                } catch (err) {
                    DEBUG_BUILD && logger/* logger.error */.kg.error(err);
                    return null;
                }
            }
        },
        {
            /**
   * Removes a single widget
   */ key: "removeWidget",
            value: function removeWidget(widget) {
                if (!widget) {
                    return false;
                }
                try {
                    if (this._widgets.has(widget)) {
                        widget.removeActor();
                        widget.removeDialog();
                        this._widgets.delete(widget);
                        if (this._widget === widget) {
                            // TODO: is more clean-up needed? e.g. call remove()
                            this._widget = null;
                        }
                        return true;
                    }
                } catch (err) {
                    DEBUG_BUILD && logger/* logger.error */.kg.error(err);
                }
                return false;
            }
        },
        {
            /**
   * Returns the default (first-created) widget
   */ key: "getWidget",
            value: function getWidget() {
                return this._widget;
            }
        },
        {
            /**
   * Removes the Feedback integration (including host, shadow DOM, and all widgets)
   */ key: "remove",
            value: function remove() {
                if (this._host) {
                    this._host.remove();
                }
                this._initialize();
            }
        },
        {
            /**
   * Initializes values of protected properties
   */ key: "_initialize",
            value: function _initialize() {
                this._host = null;
                this._shadow = null;
                this._widget = null;
                this._widgets = new Set();
                this._hasInsertedActorStyles = false;
            }
        },
        {
            /**
   * Clean-up the widget if it already exists in the DOM. This shouldn't happen
   * in prod, but can happen in development with hot module reloading.
   */ key: "_cleanupWidgetIfExists",
            value: function _cleanupWidgetIfExists() {
                if (this._host) {
                    this.remove();
                }
                var existingFeedback = doc.querySelector("#".concat(this.options.id));
                if (existingFeedback) {
                    existingFeedback.remove();
                }
            }
        },
        {
            /**
   * Creates a new widget, after ensuring shadow DOM exists
   */ key: "_createWidget",
            value: function _createWidget(options) {
                var _this = this;
                return this._ensureShadowHost(options, function(param) {
                    var shadow = param.shadow;
                    var widget = createWidget({
                        shadow: shadow,
                        options: options
                    });
                    if (!_this._hasInsertedActorStyles && widget.actor) {
                        shadow.appendChild(createActorStyles(doc));
                        _this._hasInsertedActorStyles = true;
                    }
                    _this._widgets.add(widget);
                    if (!_this._widget) {
                        _this._widget = widget;
                    }
                    return widget;
                });
            }
        },
        {
            /**
   * Ensures that shadow DOM exists and is added to the DOM
   */ key: "_ensureShadowHost",
            value: function _ensureShadowHost(options, cb) {
                var needsAppendHost = false;
                // Don't create if it already exists
                if (!this._shadow || !this._host) {
                    var id = options.id, colorScheme = options.colorScheme, themeLight = options.themeLight, themeDark = options.themeDark;
                    var ref = createShadowHost({
                        id: id,
                        colorScheme: colorScheme,
                        themeLight: themeLight,
                        themeDark: themeDark
                    }), shadow = ref.shadow, host = ref.host;
                    this._shadow = shadow;
                    this._host = host;
                    needsAppendHost = true;
                }
                // set data attribute on host for different themes
                this._host.dataset.sentryFeedbackColorscheme = options.colorScheme;
                var result = cb({
                    shadow: this._shadow,
                    host: this._host
                });
                if (needsAppendHost) {
                    doc.body.appendChild(this._host);
                }
                return result;
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = "Feedback";
            }
        }
    ]);
    return Feedback;
}();
Feedback.__initStatic();
 //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument/console.js
var instrument_console = __webpack_require__(43445);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/severity.js
var severity = __webpack_require__(41824);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(11591);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(68813);
;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/captureconsole.js



var captureconsole_INTEGRATION_NAME = "CaptureConsole";
var _captureConsoleIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var levels = options.levels || logger/* CONSOLE_LEVELS */.RU;
    return {
        name: captureconsole_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        setup: function setup(client) {
            if (!("console" in worldwide/* GLOBAL_OBJ */.n2)) {
                return;
            }
            (0,instrument_console/* addConsoleInstrumentationHandler */.e)(function(param) {
                var args = param.args, level = param.level;
                if ((0,esm_exports/* getClient */.s3)() !== client || !levels.includes(level)) {
                    return;
                }
                consoleHandler(args, level);
            });
        }
    };
};
var captureConsoleIntegration = (0,integration/* defineIntegration */._I)(_captureConsoleIntegration);
/**
 * Send Console API calls as Sentry Events.
 * @deprecated Use `captureConsoleIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var CaptureConsole = (0,integration/* convertIntegrationFnToClass */.RN)(captureconsole_INTEGRATION_NAME, captureConsoleIntegration);
function consoleHandler(args, level) {
    var captureContext = {
        level: (0,severity/* severityLevelFromString */.VT)(level),
        extra: {
            arguments: args
        }
    };
    (0,esm_exports/* withScope */.$e)(function(scope) {
        scope.addEventProcessor(function(event) {
            event.logger = "console";
            (0,misc/* addExceptionMechanism */.EG)(event, {
                handled: false,
                type: "console"
            });
            return event;
        });
        if (level === "assert" && args[0] === false) {
            var message = "Assertion failed: ".concat((0,string/* safeJoin */.nK)(args.slice(1), " ") || "console.assert");
            scope.setExtra("arguments", args.slice(1));
            (0,esm_exports/* captureMessage */.uT)(message, captureContext);
            return;
        }
        var error = args.find(function(arg) {
            return (0,_instanceof/* default */.Z)(arg, Error);
        });
        if (level === "error" && error) {
            (0,esm_exports/* captureException */.Tb)(error, captureContext);
            return;
        }
        var message1 = (0,string/* safeJoin */.nK)(args, " ");
        (0,esm_exports/* captureMessage */.uT)(message1, captureContext);
    });
}
 //# sourceMappingURL=captureconsole.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/url.js
var url = __webpack_require__(57323);
;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/contextlines.js



var contextlines_WINDOW = worldwide/* GLOBAL_OBJ */.n2;
var DEFAULT_LINES_OF_CONTEXT = 7;
var contextlines_INTEGRATION_NAME = "ContextLines";
var _contextLinesIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var contextLines = options.frameContextLines != null ? options.frameContextLines : DEFAULT_LINES_OF_CONTEXT;
    return {
        name: contextlines_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        processEvent: function processEvent(event) {
            return addSourceContext(event, contextLines);
        }
    };
};
var contextLinesIntegration = (0,integration/* defineIntegration */._I)(_contextLinesIntegration);
/**
 * Collects source context lines around the lines of stackframes pointing to JS embedded in
 * the current page's HTML.
 *
 * This integration DOES NOT work for stack frames pointing to JS files that are loaded by the browser.
 * For frames pointing to files, context lines are added during ingestion and symbolication
 * by attempting to download the JS files to the Sentry backend.
 *
 * Use this integration if you have inline JS code in HTML pages that can't be accessed
 * by our backend (e.g. due to a login-protected page).
 *
 * @deprecated Use `contextLinesIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var ContextLines = (0,integration/* convertIntegrationFnToClass */.RN)(contextlines_INTEGRATION_NAME, contextLinesIntegration);
/**
 * Processes an event and adds context lines.
 */ function addSourceContext(event, contextLines) {
    var doc = contextlines_WINDOW.document;
    var htmlFilename = contextlines_WINDOW.location && (0,url/* stripUrlQueryAndFragment */.rt)(contextlines_WINDOW.location.href);
    if (!doc || !htmlFilename) {
        return event;
    }
    var exceptions = event.exception && event.exception.values;
    if (!exceptions || !exceptions.length) {
        return event;
    }
    var html = doc.documentElement.innerHTML;
    if (!html) {
        return event;
    }
    var htmlLines = [
        "<!DOCTYPE html>",
        "<html>"
    ].concat((0,_to_consumable_array/* default */.Z)(html.split("\n")), [
        "</html>"
    ]);
    exceptions.forEach(function(exception) {
        var stacktrace = exception.stacktrace;
        if (stacktrace && stacktrace.frames) {
            stacktrace.frames = stacktrace.frames.map(function(frame) {
                return applySourceContextToFrame(frame, htmlLines, htmlFilename, contextLines);
            });
        }
    });
    return event;
}
/**
 * Only exported for testing
 */ function applySourceContextToFrame(frame, htmlLines, htmlFilename, linesOfContext) {
    if (frame.filename !== htmlFilename || !frame.lineno || !htmlLines.length) {
        return frame;
    }
    (0,misc/* addContextToFrame */.go)(htmlLines, frame, linesOfContext);
    return frame;
}
 //# sourceMappingURL=contextlines.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/debug.js



var debug_INTEGRATION_NAME = "Debug";
var _debugIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0,src_object_spread/* default */.Z)({
        debugger: false,
        stringify: false
    }, options);
    return {
        name: debug_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        setup: function setup(client) {
            if (!client.on) {
                return;
            }
            client.on("beforeSendEvent", function(event, hint) {
                if (_options.debugger) {
                    // eslint-disable-next-line no-debugger
                    debugger;
                }
                /* eslint-disable no-console */ (0,logger/* consoleSandbox */.Cf)(function() {
                    if (_options.stringify) {
                        console.log(JSON.stringify(event, null, 2));
                        if (hint && Object.keys(hint).length) {
                            console.log(JSON.stringify(hint, null, 2));
                        }
                    } else {
                        console.log(event);
                        if (hint && Object.keys(hint).length) {
                            console.log(hint);
                        }
                    }
                });
            /* eslint-enable no-console */ });
        }
    };
};
var debugIntegration = (0,integration/* defineIntegration */._I)(_debugIntegration);
/**
 * Integration to debug sent Sentry events.
 * This integration should not be used in production.
 *
 * @deprecated Use `debugIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var Debug = (0,integration/* convertIntegrationFnToClass */.RN)(debug_INTEGRATION_NAME, debugIntegration);
 //# sourceMappingURL=debug.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/debug-build.js
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var debug_build_DEBUG_BUILD =  false || false;
 //# sourceMappingURL=debug-build.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/dedupe.js



var dedupe_INTEGRATION_NAME = "Dedupe";
var _dedupeIntegration = function() {
    var previousEvent;
    return {
        name: dedupe_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        processEvent: function processEvent(currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) {
                return currentEvent;
            }
            // Juuust in case something goes wrong
            try {
                if (_shouldDropEvent(currentEvent, previousEvent)) {
                    debug_build_DEBUG_BUILD && logger/* logger.warn */.kg.warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
var dedupeIntegration = (0,integration/* defineIntegration */._I)(_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var Dedupe = (0,integration/* convertIntegrationFnToClass */.RN)(dedupe_INTEGRATION_NAME, dedupeIntegration);
/** only exported for tests. */ function _shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) {
        return false;
    }
    if (_isSameMessageEvent(currentEvent, previousEvent)) {
        return true;
    }
    if (_isSameExceptionEvent(currentEvent, previousEvent)) {
        return true;
    }
    return false;
}
function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) {
        return false;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) {
        return false;
    }
    if (currentMessage !== previousMessage) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) {
        return false;
    }
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = _getFramesFromEvent(currentEvent);
    var previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) {
        return true;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) {
        return false;
    }
    currentFrames = currentFrames;
    previousFrames = previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) {
        return false;
    }
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) {
            return false;
        }
    }
    return true;
}
function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) {
        return true;
    }
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) {
        return false;
    }
    currentFingerprint = currentFingerprint;
    previousFingerprint = previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function _getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) {
        try {
            // @ts-expect-error Object could be undefined
            return exception.values[0].stacktrace.frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}
 //# sourceMappingURL=dedupe.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(74020);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/normalize.js + 1 modules
var normalize = __webpack_require__(92276);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(27389);
;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/extraerrordata.js





var extraerrordata_INTEGRATION_NAME = "ExtraErrorData";
var _extraErrorDataIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var depth = options.depth || 3;
    // TODO(v8): Flip the default for this option to true
    var captureErrorCause = options.captureErrorCause || false;
    return {
        name: extraerrordata_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        processEvent: function processEvent(event, hint) {
            return _enhanceEventWithErrorData(event, hint, depth, captureErrorCause);
        }
    };
};
var extraErrorDataIntegration = (0,integration/* defineIntegration */._I)(_extraErrorDataIntegration);
/**
 * Extract additional data for from original exceptions.
 * @deprecated Use `extraErrorDataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var ExtraErrorData = (0,integration/* convertIntegrationFnToClass */.RN)(extraerrordata_INTEGRATION_NAME, extraErrorDataIntegration);
function _enhanceEventWithErrorData(event) {
    var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, depth = arguments.length > 2 ? arguments[2] : void 0, captureErrorCause = arguments.length > 3 ? arguments[3] : void 0;
    if (!hint.originalException || !(0,is/* isError */.VZ)(hint.originalException)) {
        return event;
    }
    var exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    var errorData = _extractErrorData(hint.originalException, captureErrorCause);
    if (errorData) {
        var contexts = (0,src_object_spread/* default */.Z)({}, event.contexts);
        var normalizedErrorData = (0,normalize/* normalize */.Fv)(errorData, depth);
        if ((0,is/* isPlainObject */.PO)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0,object/* addNonEnumerableProperty */.xp)(normalizedErrorData, "__sentry_skip_normalization__", true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, event), {
            contexts: contexts
        });
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function _extractErrorData(error, captureErrorCause) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        var nativeKeys = [
            "name",
            "message",
            "stack",
            "line",
            "column",
            "fileName",
            "lineNumber",
            "columnNumber",
            "toJSON", 
        ];
        var extraErrorInfo = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
            for(var _iterator = Object.keys(error)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (nativeKeys.indexOf(key) !== -1) {
                    continue;
                }
                var value = error[key];
                extraErrorInfo[key] = (0,is/* isError */.VZ)(value) ? value.toString() : value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) {
            extraErrorInfo.cause = (0,is/* isError */.VZ)(error.cause) ? error.cause.toString() : error.cause;
        }
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === "function") {
            var serializedError = error.toJSON();
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Object.keys(serializedError)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var key1 = _step1.value;
                    var value1 = serializedError[key1];
                    extraErrorInfo[key1] = (0,is/* isError */.VZ)(value1) ? value1.toString() : value1;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        debug_build_DEBUG_BUILD && logger/* logger.error */.kg.error("Unable to extract extra data from the Error object:", oO);
    }
    return null;
}
 //# sourceMappingURL=extraerrordata.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/isSentryRequestUrl.js
var isSentryRequestUrl = __webpack_require__(27115);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(59036);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument/fetch.js
var instrument_fetch = __webpack_require__(99096);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument/xhr.js
var instrument_xhr = __webpack_require__(33224);
;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/httpclient.js






var httpclient_INTEGRATION_NAME = "HttpClient";
var _httpClientIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0,src_object_spread/* default */.Z)({
        failedRequestStatusCodes: [
            [
                500,
                599
            ]
        ],
        failedRequestTargets: [
            /.*/
        ]
    }, options);
    return {
        name: httpclient_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        setup: function setup(client) {
            _wrapFetch(client, _options);
            _wrapXHR(client, _options);
        }
    };
};
var httpClientIntegration = (0,integration/* defineIntegration */._I)(_httpClientIntegration);
/**
 * Create events for failed client side HTTP requests.
 * @deprecated Use `httpClientIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var HttpClient = (0,integration/* convertIntegrationFnToClass */.RN)(httpclient_INTEGRATION_NAME, httpClientIntegration);
/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */ function _fetchResponseHandler(options, requestInfo, response, requestInit) {
    if (_shouldCaptureResponse(options, response.status, response.url)) {
        var request = _getRequest(requestInfo, requestInit);
        var requestHeaders, responseHeaders, requestCookies, responseCookies;
        if (_shouldSendDefaultPii()) {
            var ref, ref1, ref2;
            ref = (0,_sliced_to_array/* default */.Z)([
                {
                    cookieHeader: "Cookie",
                    obj: request
                },
                {
                    cookieHeader: "Set-Cookie",
                    obj: response
                }, 
            ].map(function(param) {
                var cookieHeader = param.cookieHeader, obj = param.obj;
                var headers = _extractFetchHeaders(obj.headers);
                var cookies;
                try {
                    var cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;
                    if (cookieString) {
                        cookies = _parseCookieString(cookieString);
                    }
                } catch (e) {
                    debug_build_DEBUG_BUILD && logger/* logger.log */.kg.log("Could not extract cookies from header ".concat(cookieHeader));
                }
                return {
                    headers: headers,
                    cookies: cookies
                };
            }), 2), ref1 = ref[0], requestHeaders = ref1.headers, requestCookies = ref1.cookies, ref1, ref2 = ref[1], responseHeaders = ref2.headers, responseCookies = ref2.cookies, ref2, ref;
        }
        var event = _createEvent({
            url: request.url,
            method: request.method,
            status: response.status,
            requestHeaders: requestHeaders,
            responseHeaders: responseHeaders,
            requestCookies: requestCookies,
            responseCookies: responseCookies
        });
        (0,esm_exports/* captureEvent */.eN)(event);
    }
}
/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */ function _xhrResponseHandler(options, xhr, method, headers) {
    if (_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
        var requestHeaders, responseCookies, responseHeaders;
        if (_shouldSendDefaultPii()) {
            try {
                var cookieString = xhr.getResponseHeader("Set-Cookie") || xhr.getResponseHeader("set-cookie") || undefined;
                if (cookieString) {
                    responseCookies = _parseCookieString(cookieString);
                }
            } catch (e) {
                debug_build_DEBUG_BUILD && logger/* logger.log */.kg.log("Could not extract cookies from response headers");
            }
            try {
                responseHeaders = _getXHRResponseHeaders(xhr);
            } catch (e1) {
                debug_build_DEBUG_BUILD && logger/* logger.log */.kg.log("Could not extract headers from response");
            }
            requestHeaders = headers;
        }
        var event = _createEvent({
            url: xhr.responseURL,
            method: method,
            status: xhr.status,
            requestHeaders: requestHeaders,
            // Can't access request cookies from XHR
            responseHeaders: responseHeaders,
            responseCookies: responseCookies
        });
        (0,esm_exports/* captureEvent */.eN)(event);
    }
}
/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */ function _getResponseSizeFromHeaders(headers) {
    if (headers) {
        var contentLength = headers["Content-Length"] || headers["content-length"];
        if (contentLength) {
            return parseInt(contentLength, 10);
        }
    }
    return undefined;
}
/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */ function _parseCookieString(cookieString) {
    return cookieString.split("; ").reduce(function(acc, cookie) {
        var ref = (0,_sliced_to_array/* default */.Z)(cookie.split("="), 2), key = ref[0], value = ref[1];
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */ function _extractFetchHeaders(headers) {
    var result = {};
    headers.forEach(function(value, key) {
        result[key] = value;
    });
    return result;
}
/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */ function _getXHRResponseHeaders(xhr) {
    var headers = xhr.getAllResponseHeaders();
    if (!headers) {
        return {};
    }
    return headers.split("\r\n").reduce(function(acc, line) {
        var ref = (0,_sliced_to_array/* default */.Z)(line.split(": "), 2), key = ref[0], value = ref[1];
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */ function _isInGivenRequestTargets(failedRequestTargets, target) {
    return failedRequestTargets.some(function(givenRequestTarget) {
        if (typeof givenRequestTarget === "string") {
            return target.includes(givenRequestTarget);
        }
        return givenRequestTarget.test(target);
    });
}
/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */ function _isInGivenStatusRanges(failedRequestStatusCodes, status) {
    return failedRequestStatusCodes.some(function(range) {
        if (typeof range === "number") {
            return range === status;
        }
        return status >= range[0] && status <= range[1];
    });
}
/**
 * Wraps `fetch` function to capture request and response data
 */ function _wrapFetch(client, options) {
    if (!(0,supports/* supportsNativeFetch */.t$)()) {
        return;
    }
    (0,instrument_fetch/* addFetchInstrumentationHandler */.U)(function(handlerData) {
        if ((0,esm_exports/* getClient */.s3)() !== client) {
            return;
        }
        var response = handlerData.response, args = handlerData.args;
        var _args = (0,_sliced_to_array/* default */.Z)(args, 2), requestInfo = _args[0], requestInit = _args[1];
        if (!response) {
            return;
        }
        _fetchResponseHandler(options, requestInfo, response, requestInit);
    });
}
/**
 * Wraps XMLHttpRequest to capture request and response data
 */ function _wrapXHR(client, options) {
    if (!("XMLHttpRequest" in worldwide/* GLOBAL_OBJ */.n2)) {
        return;
    }
    (0,instrument_xhr/* addXhrInstrumentationHandler */.UK)(function(handlerData) {
        if ((0,esm_exports/* getClient */.s3)() !== client) {
            return;
        }
        var xhr = handlerData.xhr;
        var sentryXhrData = xhr[instrument_xhr/* SENTRY_XHR_DATA_KEY */.xU];
        if (!sentryXhrData) {
            return;
        }
        var method = sentryXhrData.method, headers = sentryXhrData.request_headers;
        try {
            _xhrResponseHandler(options, xhr, method, headers);
        } catch (e) {
            debug_build_DEBUG_BUILD && logger/* logger.warn */.kg.warn("Error while extracting response event form XHR response", e);
        }
    });
}
/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */ function _shouldCaptureResponse(options, status, url) {
    return _isInGivenStatusRanges(options.failedRequestStatusCodes, status) && _isInGivenRequestTargets(options.failedRequestTargets, url) && !(0,isSentryRequestUrl/* isSentryRequestUrl */.W)(url, (0,esm_exports/* getClient */.s3)());
}
/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */ function _createEvent(data) {
    var message = "HTTP Client Error with status code: ".concat(data.status);
    var event = {
        message: message,
        exception: {
            values: [
                {
                    type: "Error",
                    value: message
                }, 
            ]
        },
        request: {
            url: data.url,
            method: data.method,
            headers: data.requestHeaders,
            cookies: data.requestCookies
        },
        contexts: {
            response: {
                status_code: data.status,
                headers: data.responseHeaders,
                cookies: data.responseCookies,
                body_size: _getResponseSizeFromHeaders(data.responseHeaders)
            }
        }
    };
    (0,misc/* addExceptionMechanism */.EG)(event, {
        type: "http.client",
        handled: false
    });
    return event;
}
function _getRequest(requestInfo, requestInit) {
    if (!requestInit && (0,_instanceof/* default */.Z)(requestInfo, Request)) {
        return requestInfo;
    }
    // If both are set, we try to construct a new Request with the given arguments
    // However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
    // In this case, as a fallback, we just use the original request - using both is rather an edge case
    if ((0,_instanceof/* default */.Z)(requestInfo, Request) && requestInfo.bodyUsed) {
        return requestInfo;
    }
    return new Request(requestInfo, requestInit);
}
function _shouldSendDefaultPii() {
    var client = (0,esm_exports/* getClient */.s3)();
    return client ? Boolean(client.getOptions().sendDefaultPii) : false;
}
 //# sourceMappingURL=httpclient.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/reportingobserver.js


var reportingobserver_WINDOW = worldwide/* GLOBAL_OBJ */.n2;
var reportingobserver_INTEGRATION_NAME = "ReportingObserver";
var SETUP_CLIENTS = new WeakMap();
var _reportingObserverIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var handler = /** Handler for the reporting observer. */ function handler(reports) {
        if (!SETUP_CLIENTS.has((0,esm_exports/* getClient */.s3)())) {
            return;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var report = _step.value;
                (0,esm_exports/* withScope */.$e)(function(scope) {
                    scope.setExtra("url", report.url);
                    var label = "ReportingObserver [".concat(report.type, "]");
                    var details = "No details available";
                    if (report.body) {
                        // Object.keys doesn't work on ReportBody, as all properties are inheirted
                        var plainBody = {};
                        // eslint-disable-next-line guard-for-in
                        for(var prop in report.body){
                            plainBody[prop] = report.body[prop];
                        }
                        scope.setExtra("body", plainBody);
                        if (report.type === "crash") {
                            var body = report.body;
                            // A fancy way to create a message out of crashId OR reason OR both OR fallback
                            details = [
                                body.crashId || "",
                                body.reason || ""
                            ].join(" ").trim() || details;
                        } else {
                            var body1 = report.body;
                            details = body1.message || details;
                        }
                    }
                    (0,esm_exports/* captureMessage */.uT)("".concat(label, ": ").concat(details));
                });
            };
            for(var _iterator = reports[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var types = options.types || [
        "crash",
        "deprecation",
        "intervention"
    ];
    return {
        name: reportingobserver_INTEGRATION_NAME,
        setupOnce: function setupOnce() {
            if (!(0,supports/* supportsReportingObserver */.zb)()) {
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            var observer = new reportingobserver_WINDOW.ReportingObserver(handler, {
                buffered: true,
                types: types
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            observer.observe();
        },
        setup: function setup(client) {
            SETUP_CLIENTS.set(client, true);
        }
    };
};
var reportingObserverIntegration = (0,integration/* defineIntegration */._I)(_reportingObserverIntegration);
/**
 * Reporting API integration - https://w3c.github.io/reporting/
 * @deprecated Use `reportingObserverIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var ReportingObserver = (0,integration/* convertIntegrationFnToClass */.RN)(reportingobserver_INTEGRATION_NAME, reportingObserverIntegration);
 //# sourceMappingURL=reportingobserver.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/sessiontiming.js




var sessiontiming_INTEGRATION_NAME = "SessionTiming";
var _sessionTimingIntegration = function() {
    var startTime = Date.now();
    return {
        name: sessiontiming_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        processEvent: function processEvent(event) {
            var now = Date.now();
            var _obj;
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, event), {
                extra: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, event.extra), (_obj = {}, (0,src_define_property/* default */.Z)(_obj, "session:start", startTime), (0,src_define_property/* default */.Z)(_obj, "session:duration", now - startTime), (0,src_define_property/* default */.Z)(_obj, "session:end", now), _obj))
            });
        }
    };
};
var sessionTimingIntegration = (0,integration/* defineIntegration */._I)(_sessionTimingIntegration);
/**
 * This function adds duration since Sentry was initialized till the time event was sent.
 * @deprecated Use `sessionTimingIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var SessionTiming = (0,integration/* convertIntegrationFnToClass */.RN)(sessiontiming_INTEGRATION_NAME, sessionTimingIntegration);
 //# sourceMappingURL=sessiontiming.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/integrations/esm/rewriteframes.js + 1 modules
var rewriteframes = __webpack_require__(6157);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/browsertracing.js + 1 modules
var browsertracing = __webpack_require__(87097);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/browserTracingIntegration.js
var browserTracingIntegration = __webpack_require__(81610);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/request.js + 1 modules
var request = __webpack_require__(24366);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/ratelimit.js
var ratelimit = __webpack_require__(95542);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/offline.js




var MIN_DELAY = 100; // 100 ms
var START_DELAY = 5000; // 5 seconds
var MAX_DELAY = 3.6e6; // 1 hour
function log(msg, error) {
    debug_build/* DEBUG_BUILD */.X && logger/* logger.info */.kg.info("[Offline]: ".concat(msg), error);
}
/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */ function makeOfflineTransport(createTransport) {
    return function(options) {
        var shouldQueue = function shouldQueue(env, error, retryDelay) {
            // We don't queue Session Replay envelopes because they are:
            // - Ordered and Replay relies on the response status to know when they're successfully sent.
            // - Likely to fill the queue quickly and block other events from being sent.
            // We also want to drop client reports because they can be generated when we retry sending events while offline.
            if ((0,esm_envelope/* envelopeContainsItemType */.R)(env, [
                "replay_event",
                "replay_recording",
                "client_report"
            ])) {
                return false;
            }
            if (options.shouldStore) {
                return options.shouldStore(env, error, retryDelay);
            }
            return true;
        };
        var flushIn = function flushIn(delay) {
            if (!store) {
                return;
            }
            if (flushTimer) {
                clearTimeout(flushTimer);
            }
            flushTimer = setTimeout(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                var found;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            flushTimer = undefined;
                            return [
                                4,
                                store.pop()
                            ];
                        case 1:
                            found = _state.sent();
                            if (found) {
                                log("Attempting to send previously queued event");
                                void send(found).catch(function(e) {
                                    log("Failed to retry sending", e);
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            }), delay);
            // We need to unref the timer in node.js, otherwise the node process never exit.
            if (typeof flushTimer !== "number" && flushTimer.unref) {
                flushTimer.unref();
            }
        };
        var flushWithBackOff = function flushWithBackOff() {
            if (flushTimer) {
                return;
            }
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, MAX_DELAY);
        };
        var transport = createTransport(options);
        var store = options.createStore ? options.createStore(options) : undefined;
        var retryDelay = START_DELAY;
        var flushTimer;
        function send(envelope) {
            return _send.apply(this, arguments);
        }
        function _send() {
            _send = (0,_async_to_generator/* default */.Z)(function(envelope) {
                var result, delay, e, _tmp;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                8
                            ]);
                            return [
                                4,
                                transport.send(envelope)
                            ];
                        case 1:
                            result = _state.sent();
                            delay = MIN_DELAY;
                            if (result) {
                                // If there's a retry-after header, use that as the next delay.
                                if (result.headers && result.headers["retry-after"]) {
                                    delay = (0,ratelimit/* parseRetryAfterHeader */.JY)(result.headers["retry-after"]);
                                } else if ((result.statusCode || 0) >= 400) {
                                    return [
                                        2,
                                        result
                                    ];
                                }
                            }
                            flushIn(delay);
                            retryDelay = START_DELAY;
                            return [
                                2,
                                result
                            ];
                        case 2:
                            e = _state.sent();
                            _tmp = store;
                            if (!_tmp) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                shouldQueue(envelope, e, retryDelay)
                            ];
                        case 3:
                            _tmp = _state.sent();
                            _state.label = 4;
                        case 4:
                            if (!_tmp) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                store.insert(envelope)
                            ];
                        case 5:
                            _state.sent();
                            flushWithBackOff();
                            log("Error sending. Event queued", e);
                            return [
                                2,
                                {}
                            ];
                        case 6:
                            throw e;
                        case 7:
                            return [
                                3,
                                8
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            });
            return _send.apply(this, arguments);
        }
        if (options.flushAtStartup) {
            flushWithBackOff();
        }
        return {
            send: send,
            flush: function(t) {
                return transport.flush(t);
            }
        };
    };
}
 //# sourceMappingURL=offline.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/offline.js







// 'Store', 'promisifyRequest' and 'createStore' were originally copied from the 'idb-keyval' package before being
// modified and simplified: https://github.com/jakearchibald/idb-keyval
//
// At commit: 0420a704fd6cbb4225429c536b1f61112d012fca
// Original licence:
// Copyright 2016, Jake Archibald
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function promisifyRequest(request) {
    return new Promise(function(resolve, reject) {
        // @ts-expect-error - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        };
        // @ts-expect-error - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
/** Create or open an IndexedDb store */ function createStore(dbName, storeName) {
    var request = indexedDB.open(dbName);
    request.onupgradeneeded = function() {
        return request.result.createObjectStore(storeName);
    };
    var dbp = promisifyRequest(request);
    return function(callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, "readwrite").objectStore(storeName));
        });
    };
}
function keys(store) {
    return promisifyRequest(store.getAllKeys());
}
/** Insert into the store */ function insert(store, value, maxQueueSize) {
    return store(function(store) {
        return keys(store).then(function(keys) {
            var _Math;
            if (keys.length >= maxQueueSize) {
                return;
            }
            // We insert with an incremented key so that the entries are popped in order
            store.put(value, (_Math = Math).max.apply(_Math, (0,_to_consumable_array/* default */.Z)(keys).concat([
                0
            ])) + 1);
            return promisifyRequest(store.transaction);
        });
    });
}
/** Pop the oldest value from the store */ function pop(store) {
    return store(function(store) {
        return keys(store).then(function(keys) {
            if (keys.length === 0) {
                return undefined;
            }
            return promisifyRequest(store.get(keys[0])).then(function(value) {
                store.delete(keys[0]);
                return promisifyRequest(store.transaction).then(function() {
                    return value;
                });
            });
        });
    });
}
function createIndexedDbStore(options) {
    var getStore = // Lazily create the store only when it's needed
    function getStore() {
        if (store == undefined) {
            store = createStore(options.dbName || "sentry-offline", options.storeName || "queue");
        }
        return store;
    };
    var store;
    return {
        insert: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(env) {
                var serialized, _;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0,esm_envelope/* serializeEnvelope */.V$)(env, options.textEncoder)
                            ];
                        case 1:
                            serialized = _state.sent();
                            return [
                                4,
                                insert(getStore(), serialized, options.maxQueueSize || 30)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            _ = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(env) {
                return _ref.apply(this, arguments);
            };
        }(),
        pop: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var deserialized, _;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            pop(getStore())
                        ];
                    case 1:
                        deserialized = _state.sent();
                        if (deserialized) {
                            return [
                                2,
                                (0,esm_envelope/* parseEnvelope */.f4)(deserialized, options.textEncoder || new TextEncoder(), options.textDecoder || new TextDecoder())
                            ];
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _ = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            undefined
                        ];
                }
            });
        })
    };
}
function makeIndexedDbOfflineTransport(createTransport) {
    return function(options) {
        return createTransport((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
            createStore: createIndexedDbStore
        }));
    };
}
/**
 * Creates a transport that uses IndexedDb to store events when offline.
 */ function makeBrowserOfflineTransport(createTransport) {
    return makeIndexedDbOfflineTransport(makeOfflineTransport(createTransport));
}
 //# sourceMappingURL=offline.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/debug-build.js
var esm_debug_build = __webpack_require__(53289);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/constants.js
var constants = __webpack_require__(96699);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/profiling/utils.js






/* eslint-disable max-lines */ var MS_TO_NS = 1e6;
// Use 0 as main thread id which is identical to threadId in node:worker_threads
// where main logs 0 and workers seem to log in increments of 1
var THREAD_ID_STRING = String(0);
var THREAD_NAME = "main";
// Machine properties (eval only once)
var OS_PLATFORM = "";
var OS_PLATFORM_VERSION = "";
var OS_ARCH = "";
var OS_BROWSER = helpers/* WINDOW.navigator */.m9.navigator && helpers/* WINDOW.navigator.userAgent */.m9.navigator.userAgent || "";
var OS_MODEL = "";
var OS_LOCALE = helpers/* WINDOW.navigator */.m9.navigator && helpers/* WINDOW.navigator.language */.m9.navigator.language || helpers/* WINDOW.navigator */.m9.navigator && helpers/* WINDOW.navigator.languages */.m9.navigator.languages && helpers/* WINDOW.navigator.languages.0 */.m9.navigator.languages[0] || "";
function isUserAgentData(data) {
    return typeof data === "object" && data !== null && "getHighEntropyValues" in data;
}
// @ts-expect-error userAgentData is not part of the navigator interface yet
var userAgentData = helpers/* WINDOW.navigator */.m9.navigator && helpers/* WINDOW.navigator.userAgentData */.m9.navigator.userAgentData;
if (isUserAgentData(userAgentData)) {
    userAgentData.getHighEntropyValues([
        "architecture",
        "model",
        "platform",
        "platformVersion",
        "fullVersionList"
    ]).then(function(ua) {
        OS_PLATFORM = ua.platform || "";
        OS_ARCH = ua.architecture || "";
        OS_MODEL = ua.model || "";
        OS_PLATFORM_VERSION = ua.platformVersion || "";
        if (ua.fullVersionList && ua.fullVersionList.length > 0) {
            var firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
            OS_BROWSER = "".concat(firstUa.brand, " ").concat(firstUa.version);
        }
    }).catch(function(e) {
        return void e;
    });
}
function isProcessedJSSelfProfile(profile) {
    return !("thread_metadata" in profile);
}
// Enriches the profile with threadId of the current thread.
// This is done in node as we seem to not be able to get the info from C native code.
/**
 *
 */ function enrichWithThreadInformation(profile) {
    if (!isProcessedJSSelfProfile(profile)) {
        return profile;
    }
    return convertJSSelfProfileToSampledFormat(profile);
}
// Profile is marked as optional because it is deleted from the metadata
// by the integration before the event is processed by other integrations.
function getTraceId(event) {
    var traceId = event && event.contexts && event.contexts["trace"] && event.contexts["trace"]["trace_id"];
    // Log a warning if the profile has an invalid traceId (should be uuidv4).
    // All profiles and transactions are rejected if this is the case and we want to
    // warn users that this is happening if they enable debug flag
    if (typeof traceId === "string" && traceId.length !== 32) {
        if (esm_debug_build/* DEBUG_BUILD */.X) {
            logger/* logger.log */.kg.log("[Profiling] Invalid traceId: ".concat(traceId, " on profiled event"));
        }
    }
    if (typeof traceId !== "string") {
        return "";
    }
    return traceId;
}
/**
 * Creates a profiling event envelope from a Sentry event. If profile does not pass
 * validation, returns null.
 * @param event
 * @param dsn
 * @param metadata
 * @param tunnel
 * @returns {EventEnvelope | null}
 */ /**
 * Creates a profiling event envelope from a Sentry event.
 */ function createProfilePayload(profile_id, start_timestamp, processed_profile, event) {
    if (event.type !== "transaction") {
        // createProfilingEventEnvelope should only be called for transactions,
        // we type guard this behavior with isProfiledTransactionEvent.
        throw new TypeError("Profiling events may only be attached to transactions, this should never occur.");
    }
    if (processed_profile === undefined || processed_profile === null) {
        throw new TypeError("Cannot construct profiling event envelope without a valid profile. Got ".concat(processed_profile, " instead."));
    }
    var traceId = getTraceId(event);
    var enrichedThreadProfile = enrichWithThreadInformation(processed_profile);
    var transactionStartMs = start_timestamp ? start_timestamp : typeof event.start_timestamp === "number" ? event.start_timestamp * 1000 : Date.now();
    var transactionEndMs = typeof event.timestamp === "number" ? event.timestamp * 1000 : Date.now();
    var profile = {
        event_id: profile_id,
        timestamp: new Date(transactionStartMs).toISOString(),
        platform: "javascript",
        version: "1",
        release: event.release || "",
        environment: event.environment || constants/* DEFAULT_ENVIRONMENT */.J,
        runtime: {
            name: "javascript",
            version: helpers/* WINDOW.navigator.userAgent */.m9.navigator.userAgent
        },
        os: {
            name: OS_PLATFORM,
            version: OS_PLATFORM_VERSION,
            build_number: OS_BROWSER
        },
        device: {
            locale: OS_LOCALE,
            model: OS_MODEL,
            manufacturer: OS_BROWSER,
            architecture: OS_ARCH,
            is_emulator: false
        },
        debug_meta: {
            images: applyDebugMetadata(processed_profile.resources)
        },
        profile: enrichedThreadProfile,
        transactions: [
            {
                name: event.transaction || "",
                id: event.event_id || (0,misc/* uuid4 */.DM)(),
                trace_id: traceId,
                active_thread_id: THREAD_ID_STRING,
                relative_start_ns: "0",
                relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0)
            }, 
        ]
    };
    return profile;
}
/*
  See packages/tracing-internal/src/browser/router.ts
*/ /**
 *
 */ function isAutomatedPageLoadTransaction(transaction) {
    return transaction.op === "pageload";
}
/**
 * Converts a JSSelfProfile to a our sampled format.
 * Does not currently perform stack indexing.
 */ function convertJSSelfProfileToSampledFormat(input) {
    var EMPTY_STACK_ID = undefined;
    var STACK_ID = 0;
    // Initialize the profile that we will fill with data
    var profile = {
        samples: [],
        stacks: [],
        frames: [],
        thread_metadata: (0,src_define_property/* default */.Z)({}, THREAD_ID_STRING, {
            name: THREAD_NAME
        })
    };
    if (!input.samples.length) {
        return profile;
    }
    // We assert samples.length > 0 above and timestamp should always be present
    var start = input.samples[0].timestamp;
    // The JS SDK might change it's time origin based on some heuristic (see See packages/utils/src/time.ts)
    // when that happens, we need to ensure we are correcting the profile timings so the two timelines stay in sync.
    // Since JS self profiling time origin is always initialized to performance.timeOrigin, we need to adjust for
    // the drift between the SDK selected value and our profile time origin.
    var origin = typeof performance.timeOrigin === "number" ? performance.timeOrigin : time/* browserPerformanceTimeOrigin */.Z1 || 0;
    var adjustForOriginChange = origin - (time/* browserPerformanceTimeOrigin */.Z1 || origin);
    for(var i = 0; i < input.samples.length; i++){
        var jsSample = input.samples[i];
        // If sample has no stack, add an empty sample
        if (jsSample.stackId === undefined) {
            if (EMPTY_STACK_ID === undefined) {
                EMPTY_STACK_ID = STACK_ID;
                profile.stacks[EMPTY_STACK_ID] = [];
                STACK_ID++;
            }
            profile["samples"][i] = {
                // convert ms timestamp to ns
                elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * MS_TO_NS).toFixed(0),
                stack_id: EMPTY_STACK_ID,
                thread_id: THREAD_ID_STRING
            };
            continue;
        }
        var stackTop = input.stacks[jsSample.stackId];
        // Functions in top->down order (root is last)
        // We follow the stackTop.parentId trail and collect each visited frameId
        var stack = [];
        while(stackTop){
            stack.push(stackTop.frameId);
            var frame = input.frames[stackTop.frameId];
            // If our frame has not been indexed yet, index it
            if (profile.frames[stackTop.frameId] === undefined) {
                profile.frames[stackTop.frameId] = {
                    function: frame.name,
                    abs_path: typeof frame.resourceId === "number" ? input.resources[frame.resourceId] : undefined,
                    lineno: frame.line,
                    colno: frame.column
                };
            }
            stackTop = stackTop.parentId === undefined ? undefined : input.stacks[stackTop.parentId];
        }
        var sample = {
            // convert ms timestamp to ns
            elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * MS_TO_NS).toFixed(0),
            stack_id: STACK_ID,
            thread_id: THREAD_ID_STRING
        };
        profile["stacks"][STACK_ID] = stack;
        profile["samples"][i] = sample;
        STACK_ID++;
    }
    return profile;
}
/**
 * Adds items to envelope if they are not already present - mutates the envelope.
 * @param envelope
 */ function addProfilesToEnvelope(envelope, profiles) {
    if (!profiles.length) {
        return envelope;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = profiles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var profile = _step.value;
            envelope[1].push([
                {
                    type: "profile"
                },
                profile
            ]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return envelope;
}
/**
 * Finds transactions with profile_id context in the envelope
 * @param envelope
 * @returns
 */ function findProfiledTransactionsFromEnvelope(envelope) {
    var events = [];
    (0,esm_envelope/* forEachEnvelopeItem */.gv)(envelope, function(item, type) {
        if (type !== "transaction") {
            return;
        }
        for(var j = 1; j < item.length; j++){
            var event = item[j];
            if (event && event.contexts && event.contexts["profile"] && event.contexts["profile"]["profile_id"]) {
                events.push(item[j]);
            }
        }
    });
    return events;
}
var debugIdStackParserCache = new WeakMap();
/**
 * Applies debug meta data to an event from a list of paths to resources (sourcemaps)
 */ function applyDebugMetadata(resource_paths) {
    var debugIdMap = worldwide/* GLOBAL_OBJ._sentryDebugIds */.n2._sentryDebugIds;
    if (!debugIdMap) {
        return [];
    }
    var client = (0,esm_exports/* getClient */.s3)();
    var options = client && client.getOptions();
    var stackParser = options && options.stackParser;
    if (!stackParser) {
        return [];
    }
    var debugIdStackFramesCache;
    var cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) {
        debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    } else {
        debugIdStackFramesCache = new Map();
        debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    var filenameDebugIdMap = Object.keys(debugIdMap).reduce(function(acc, debugIdStackTrace) {
        var parsedStack;
        var cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) {
            parsedStack = cachedParsedStack;
        } else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(var i = parsedStack.length - 1; i >= 0; i--){
            var stackFrame = parsedStack[i];
            var file = stackFrame && stackFrame.filename;
            if (stackFrame && file) {
                acc[file] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    var images = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = resource_paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var path = _step.value;
            if (path && filenameDebugIdMap[path]) {
                images.push({
                    type: "sourcemap",
                    code_file: path,
                    debug_id: filenameDebugIdMap[path]
                });
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return images;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    if (typeof rate !== "number" && typeof rate !== "boolean" || typeof rate === "number" && isNaN(rate)) {
        esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ".concat(JSON.stringify(rate), " of type ").concat(JSON.stringify(typeof rate === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(rate)), "."));
        return false;
    }
    // Boolean sample rates are always valid
    if (rate === true || rate === false) {
        return true;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ".concat(rate, "."));
        return false;
    }
    return true;
}
function isValidProfile(profile) {
    if (profile.samples.length < 2) {
        if (esm_debug_build/* DEBUG_BUILD */.X) {
            // Log a warning if the profile has less than 2 samples so users can know why
            // they are not seeing any profiling data and we cant avoid the back and forth
            // of asking them to provide us with a dump of the profile data.
            logger/* logger.log */.kg.log("[Profiling] Discarding profile because it contains less than 2 samples");
        }
        return false;
    }
    if (!profile.frames.length) {
        if (esm_debug_build/* DEBUG_BUILD */.X) {
            logger/* logger.log */.kg.log("[Profiling] Discarding profile because it contains no frames");
        }
        return false;
    }
    return true;
}
// Keep a flag value to avoid re-initializing the profiler constructor. If it fails
// once, it will always fail and this allows us to early return.
var PROFILING_CONSTRUCTOR_FAILED = false;
var MAX_PROFILE_DURATION_MS = 30000;
/**
 * Check if profiler constructor is available.
 * @param maybeProfiler
 */ function isJSProfilerSupported(maybeProfiler) {
    return typeof maybeProfiler === "function";
}
/**
 * Starts the profiler and returns the profiler instance.
 */ function startJSSelfProfile() {
    // Feature support check first
    var JSProfilerConstructor = helpers/* WINDOW.Profiler */.m9.Profiler;
    if (!isJSProfilerSupported(JSProfilerConstructor)) {
        if (esm_debug_build/* DEBUG_BUILD */.X) {
            logger/* logger.log */.kg.log("[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.");
        }
        return;
    }
    // From initial testing, it seems that the minimum value for sampleInterval is 10ms.
    var samplingIntervalMS = 10;
    // Start the profiler
    var maxSamples = Math.floor(MAX_PROFILE_DURATION_MS / samplingIntervalMS);
    // Attempt to initialize the profiler constructor, if it fails, we disable profiling for the current user session.
    // This is likely due to a missing 'Document-Policy': 'js-profiling' header. We do not want to throw an error if this happens
    // as we risk breaking the user's application, so just disable profiling and log an error.
    try {
        return new JSProfilerConstructor({
            sampleInterval: samplingIntervalMS,
            maxBufferSize: maxSamples
        });
    } catch (e) {
        if (esm_debug_build/* DEBUG_BUILD */.X) {
            logger/* logger.log */.kg.log("[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.");
            logger/* logger.log */.kg.log("[Profiling] Disabling profiling for current user session.");
        }
        PROFILING_CONSTRUCTOR_FAILED = true;
    }
    return;
}
/**
 * Determine if a profile should be profiled.
 */ function shouldProfileTransaction(transaction) {
    // If constructor failed once, it will always fail, so we can early return.
    if (PROFILING_CONSTRUCTOR_FAILED) {
        if (esm_debug_build/* DEBUG_BUILD */.X) {
            logger/* logger.log */.kg.log("[Profiling] Profiling has been disabled for the duration of the current user session.");
        }
        return false;
    }
    if (!transaction.isRecording()) {
        if (esm_debug_build/* DEBUG_BUILD */.X) {
            logger/* logger.log */.kg.log("[Profiling] Discarding profile because transaction was not sampled.");
        }
        return false;
    }
    var client = (0,esm_exports/* getClient */.s3)();
    var options = client && client.getOptions();
    if (!options) {
        esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Profiling] Profiling disabled, no options found.");
        return false;
    }
    // @ts-expect-error profilesSampleRate is not part of the browser options yet
    var profilesSampleRate = options.profilesSampleRate;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(profilesSampleRate)) {
        esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("[Profiling] Discarding profile because of invalid sample rate.");
        return false;
    }
    // if the function returned 0 (or false), or if `profileSampleRate` is 0, it's a sign the profile should be dropped
    if (!profilesSampleRate) {
        esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0");
        return false;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    var sampled = profilesSampleRate === true ? true : Math.random() < profilesSampleRate;
    // Check if we should sample this profile
    if (!sampled) {
        esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ".concat(Number(profilesSampleRate), ")"));
        return false;
    }
    return true;
}
/**
 * Creates a profiling envelope item, if the profile does not pass validation, returns null.
 * @param event
 * @returns {Profile | null}
 */ function createProfilingEvent(profile_id, start_timestamp, profile, event) {
    if (!isValidProfile(profile)) {
        return null;
    }
    return createProfilePayload(profile_id, start_timestamp, profile, event);
}
// TODO (v8): We need to obtain profile ids in @sentry-internal/tracing,
// but we don't have access to this map because importing this map would
// cause a circular dependancy. We need to resolve this in v8.
var PROFILE_MAP = new Map();
/**
 *
 */ function getActiveProfilesCount() {
    return PROFILE_MAP.size;
}
/**
 * Retrieves profile from global cache and removes it.
 */ function takeProfileFromGlobalCache(profile_id) {
    var profile = PROFILE_MAP.get(profile_id);
    if (profile) {
        PROFILE_MAP.delete(profile_id);
    }
    return profile;
}
/**
 * Adds profile to global cache and evicts the oldest profile if the cache is full.
 */ function addProfileToGlobalCache(profile_id, profile) {
    PROFILE_MAP.set(profile_id, profile);
    if (PROFILE_MAP.size > 30) {
        var last = PROFILE_MAP.keys().next().value;
        PROFILE_MAP.delete(last);
    }
}
 //# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/profiling/hubextensions.js







/* eslint-disable complexity */ /**
 * Safety wrapper for startTransaction for the unlikely case that transaction starts before tracing is imported -
 * if that happens we want to avoid throwing an error from profiling code.
 * see https://github.com/getsentry/sentry-javascript/issues/4731.
 *
 * @experimental
 */ function onProfilingStartRouteTransaction(transaction) {
    if (!transaction) {
        if (esm_debug_build/* DEBUG_BUILD */.X) {
            logger/* logger.log */.kg.log("[Profiling] Transaction is undefined, skipping profiling");
        }
        return transaction;
    }
    if (shouldProfileTransaction(transaction)) {
        return startProfileForTransaction(transaction);
    }
    return transaction;
}
/**
 * Wraps startTransaction and stopTransaction with profiling related logic.
 * startProfileForTransaction is called after the call to startTransaction in order to avoid our own code from
 * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
 */ function startProfileForTransaction(transaction) {
    var profilingWrappedTransactionEnd = /**
   * Wraps startTransaction and stopTransaction with profiling related logic.
   * startProfiling is called after the call to startTransaction in order to avoid our own code from
   * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
   */ function profilingWrappedTransactionEnd() {
        if (!transaction) {
            return originalEnd();
        }
        // onProfileHandler should always return the same profile even if this is called multiple times.
        // Always call onProfileHandler to ensure stopProfiling is called and the timeout is cleared.
        void onProfileHandler().then(function() {
            // TODO: Can we rewrite this to use attributes?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setContext("profile", {
                profile_id: profileId,
                start_timestamp: startTimestamp
            });
            originalEnd();
        }, function() {
            // If onProfileHandler fails, we still want to call the original finish method.
            originalEnd();
        });
        return transaction;
    };
    // Start the profiler and get the profiler instance.
    var startTimestamp;
    if (isAutomatedPageLoadTransaction(transaction)) {
        startTimestamp = (0,time/* timestampInSeconds */.ph)() * 1000;
    }
    var profiler = startJSSelfProfile();
    // We failed to construct the profiler, fallback to original transaction.
    // No need to log anything as this has already been logged in startProfile.
    if (!profiler) {
        return transaction;
    }
    if (esm_debug_build/* DEBUG_BUILD */.X) {
        logger/* logger.log */.kg.log("[Profiling] started profiling transaction: ".concat((0,spanUtils/* spanToJSON */.XU)(transaction).description));
    }
    // We create "unique" transaction names to avoid concurrent transactions with same names
    // from being ignored by the profiler. From here on, only this transaction name should be used when
    // calling the profiler methods. Note: we log the original name to the user to avoid confusion.
    var profileId = (0,misc/* uuid4 */.DM)();
    function onProfileHandler() {
        return _onProfileHandler.apply(this, arguments);
    }
    function _onProfileHandler() {
        _onProfileHandler = /**
   * Idempotent handler for profile stop
   */ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                // Check if the profile exists and return it the behavior has to be idempotent as users may call transaction.finish multiple times.
                if (!transaction) {
                    return [
                        2,
                        null
                    ];
                }
                // Satisfy the type checker, but profiler will always be defined here.
                if (!profiler) {
                    return [
                        2,
                        null
                    ];
                }
                return [
                    2,
                    profiler.stop().then(function(profile) {
                        if (maxDurationTimeoutID) {
                            helpers/* WINDOW.clearTimeout */.m9.clearTimeout(maxDurationTimeoutID);
                            maxDurationTimeoutID = undefined;
                        }
                        if (esm_debug_build/* DEBUG_BUILD */.X) {
                            logger/* logger.log */.kg.log("[Profiling] stopped profiling of transaction: ".concat((0,spanUtils/* spanToJSON */.XU)(transaction).description));
                        }
                        // In case of an overlapping transaction, stopProfiling may return null and silently ignore the overlapping profile.
                        if (!profile) {
                            if (esm_debug_build/* DEBUG_BUILD */.X) {
                                logger/* logger.log */.kg.log("[Profiling] profiler returned null profile for: ".concat((0,spanUtils/* spanToJSON */.XU)(transaction).description), "this may indicate an overlapping transaction or a call to stopProfiling with a profile title that was never started");
                            }
                            return null;
                        }
                        addProfileToGlobalCache(profileId, profile);
                        return null;
                    }).catch(function(error) {
                        if (esm_debug_build/* DEBUG_BUILD */.X) {
                            logger/* logger.log */.kg.log("[Profiling] error while stopping profiler:", error);
                        }
                        return null;
                    })
                ];
            });
        });
        return _onProfileHandler.apply(this, arguments);
    }
    // Enqueue a timeout to prevent profiles from running over max duration.
    var maxDurationTimeoutID = helpers/* WINDOW.setTimeout */.m9.setTimeout(function() {
        if (esm_debug_build/* DEBUG_BUILD */.X) {
            logger/* logger.log */.kg.log("[Profiling] max profile duration elapsed, stopping profiling for:", (0,spanUtils/* spanToJSON */.XU)(transaction).description);
        }
        // If the timeout exceeds, we want to stop profiling, but not finish the transaction
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onProfileHandler();
    }, MAX_PROFILE_DURATION_MS);
    // We need to reference the original end call to avoid creating an infinite loop
    var originalEnd = transaction.end.bind(transaction);
    transaction.end = profilingWrappedTransactionEnd;
    return transaction;
}
 //# sourceMappingURL=hubextensions.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/profiling/integration.js





var profiling_integration_INTEGRATION_NAME = "BrowserProfiling";
var _browserProfilingIntegration = function() {
    return {
        name: profiling_integration_INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        setup: function setup(client) {
            var scope = (0,esm_exports/* getCurrentScope */.nZ)();
            // eslint-disable-next-line deprecation/deprecation
            var transaction = scope.getTransaction();
            if (transaction && isAutomatedPageLoadTransaction(transaction)) {
                if (shouldProfileTransaction(transaction)) {
                    startProfileForTransaction(transaction);
                }
            }
            if (typeof client.on !== "function") {
                logger/* logger.warn */.kg.warn("[Profiling] Client does not support hooks, profiling will be disabled");
                return;
            }
            client.on("startTransaction", function(transaction) {
                if (shouldProfileTransaction(transaction)) {
                    startProfileForTransaction(transaction);
                }
            });
            client.on("beforeEnvelope", function(envelope) {
                // if not profiles are in queue, there is nothing to add to the envelope.
                if (!getActiveProfilesCount()) {
                    return;
                }
                var profiledTransactionEvents = findProfiledTransactionsFromEnvelope(envelope);
                if (!profiledTransactionEvents.length) {
                    return;
                }
                var profilesToAddToEnvelope = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = profiledTransactionEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var profiledTransaction = _step.value;
                        var context = profiledTransaction && profiledTransaction.contexts;
                        var profile_id = context && context["profile"] && context["profile"]["profile_id"];
                        var start_timestamp = context && context["profile"] && context["profile"]["start_timestamp"];
                        if (typeof profile_id !== "string") {
                            esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Profiling] cannot find profile for a transaction without a profile context");
                            continue;
                        }
                        if (!profile_id) {
                            esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Profiling] cannot find profile for a transaction without a profile context");
                            continue;
                        }
                        // Remove the profile from the transaction context before sending, relay will take care of the rest.
                        if (context && context["profile"]) {
                            delete context.profile;
                        }
                        var profile = takeProfileFromGlobalCache(profile_id);
                        if (!profile) {
                            esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Profiling] Could not retrieve profile for transaction: ".concat(profile_id));
                            continue;
                        }
                        var profileEvent = createProfilingEvent(profile_id, start_timestamp, profile, profiledTransaction);
                        if (profileEvent) {
                            profilesToAddToEnvelope.push(profileEvent);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                addProfilesToEnvelope(envelope, profilesToAddToEnvelope);
            });
        }
    };
};
var browserProfilingIntegration = (0,integration/* defineIntegration */._I)(_browserProfilingIntegration);
/**
 * Browser profiling integration. Stores any event that has contexts["profile"]["profile_id"]
 * This exists because we do not want to await async profiler.stop calls as transaction.finish is called
 * in a synchronous context. Instead, we handle sending the profile async from the promise callback and
 * rely on being able to pull the event from the cache when we need to construct the envelope. This makes the
 * integration less reliable as we might be dropping profiles when the cache is full.
 *
 * @experimental
 * @deprecated Use `browserProfilingIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var BrowserProfilingIntegration = (0,integration/* convertIntegrationFnToClass */.RN)(profiling_integration_INTEGRATION_NAME, browserProfilingIntegration);
// eslint-disable-next-line deprecation/deprecation
 //# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/index.js



























var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
if (helpers/* WINDOW.Sentry */.m9.Sentry && helpers/* WINDOW.Sentry.Integrations */.m9.Sentry.Integrations) {
    windowIntegrations = helpers/* WINDOW.Sentry.Integrations */.m9.Sentry.Integrations;
}
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ var INTEGRATIONS = (0,src_object_spread/* default */.Z)({}, windowIntegrations, Integrations, esm_integrations_namespaceObject);
 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 47394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Breadcrumbs; },
/* harmony export */   "f": function() { return /* binding */ breadcrumbsIntegration; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69396);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62909);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77668);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43445);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89232);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33224);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99096);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41549);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11591);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92957);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41413);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41824);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68813);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(57323);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53289);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50203);






/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ var MAX_ALLOWED_STRING_LENGTH = 1024;
var INTEGRATION_NAME = "Breadcrumbs";
var _breadcrumbsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true
    }, options);
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        setup: function setup(client) {
            if (_options.console) {
                (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .addConsoleInstrumentationHandler */ .e)(_getConsoleBreadcrumbHandler(client));
            }
            if (_options.dom) {
                (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .addClickKeypressInstrumentationHandler */ .O)(_getDomBreadcrumbHandler(client, _options.dom));
            }
            if (_options.xhr) {
                (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .addXhrInstrumentationHandler */ .UK)(_getXhrBreadcrumbHandler(client));
            }
            if (_options.fetch) {
                (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .addFetchInstrumentationHandler */ .U)(_getFetchBreadcrumbHandler(client));
            }
            if (_options.history) {
                (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .addHistoryInstrumentationHandler */ .a)(_getHistoryBreadcrumbHandler(client));
            }
            if (_options.sentry && client.on) {
                client.on("beforeSendEvent", _getSentryBreadcrumbHandler(client));
            }
        }
    };
};
var breadcrumbsIntegration = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .defineIntegration */ ._I)(_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var Breadcrumbs = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_6__/* .convertIntegrationFnToClass */ .RN)(INTEGRATION_NAME, breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function _getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .getClient */ .s3)() !== client) {
            return;
        }
        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .addBreadcrumb */ .n_)({
            category: "sentry.".concat(event.type === "transaction" ? "transaction" : "event"),
            event_id: event.event_id,
            level: event.level,
            message: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .getEventDescription */ .jH)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function _getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .getClient */ .s3)() !== client) {
            return;
        }
        var target;
        var componentName;
        var keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        var maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
            _debug_build_js__WEBPACK_IMPORTED_MODULE_9__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_10__/* .logger.warn */ .kg.warn("`dom.maxStringLength` cannot exceed ".concat(MAX_ALLOWED_STRING_LENGTH, ", but a value of ").concat(maxStringLength, " was configured. Sentry will use ").concat(MAX_ALLOWED_STRING_LENGTH, " instead."));
            maxStringLength = MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") {
            keyAttrs = [
                keyAttrs
            ];
        }
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            var event = handlerData.event;
            var element = _isEvent(event) ? event.target : event;
            target = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .htmlTreeAsString */ .Rt)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .getComponentName */ .iY)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) {
            return;
        }
        var breadcrumb = {
            category: "ui.".concat(handlerData.name),
            message: target
        };
        if (componentName) {
            breadcrumb.data = {
                "ui.component_name": componentName
            };
        }
        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .addBreadcrumb */ .n_)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function _getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .getClient */ .s3)() !== client) {
            return;
        }
        var breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .severityLevelFromString */ .VT)(handlerData.level),
            message: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .safeJoin */ .nK)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: ".concat((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .safeJoin */ .nK)(handlerData.args.slice(1), " ") || "console.assert");
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else {
                // Don't capture a breadcrumb for passed assertions
                return;
            }
        }
        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .addBreadcrumb */ .n_)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function _getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .getClient */ .s3)() !== client) {
            return;
        }
        var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp;
        var sentryXhrData = handlerData.xhr[_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .SENTRY_XHR_DATA_KEY */ .xU];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) {
            return;
        }
        var method = sentryXhrData.method, url = sentryXhrData.url, status_code = sentryXhrData.status_code, body = sentryXhrData.body;
        var data = {
            method: method,
            url: url,
            status_code: status_code
        };
        var hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .addBreadcrumb */ .n_)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function _getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .getClient */ .s3)() !== client) {
            return;
        }
        var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp;
        // We only capture complete fetch requests
        if (!endTimestamp) {
            return;
        }
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") {
            // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
            return;
        }
        if (handlerData.error) {
            var data = handlerData.fetchData;
            var hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .addBreadcrumb */ .n_)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            var response = handlerData.response;
            var data1 = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, handlerData.fetchData), {
                status_code: response && response.status
            });
            var hint1 = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .addBreadcrumb */ .n_)({
                category: "fetch",
                data: data1,
                type: "http"
            }, hint1);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function _getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .getClient */ .s3)() !== client) {
            return;
        }
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_15__/* .parseUrl */ .en)(_helpers_js__WEBPACK_IMPORTED_MODULE_16__/* .WINDOW.location.href */ .m9.location.href);
        var parsedFrom = from ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_15__/* .parseUrl */ .en)(from) : undefined;
        var parsedTo = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_15__/* .parseUrl */ .en)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) {
            parsedFrom = parsedLoc;
        }
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
            to = parsedTo.relative;
        }
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
            from = parsedFrom.relative;
        }
        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .addBreadcrumb */ .n_)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function _isEvent(event) {
    return !!event && !!event.target;
}
 //# sourceMappingURL=breadcrumbs.js.map


/***/ }),

/***/ 78849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Dedupe; },
/* harmony export */   "R": function() { return /* binding */ dedupeIntegration; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62909);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92957);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53289);



var INTEGRATION_NAME = "Dedupe";
var _dedupeIntegration = function() {
    var previousEvent;
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        processEvent: function processEvent(currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) {
                return currentEvent;
            }
            // Juuust in case something goes wrong
            try {
                if (_shouldDropEvent(currentEvent, previousEvent)) {
                    _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
var dedupeIntegration = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .defineIntegration */ ._I)(_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var Dedupe = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .convertIntegrationFnToClass */ .RN)(INTEGRATION_NAME, dedupeIntegration);
function _shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) {
        return false;
    }
    if (_isSameMessageEvent(currentEvent, previousEvent)) {
        return true;
    }
    if (_isSameExceptionEvent(currentEvent, previousEvent)) {
        return true;
    }
    return false;
}
function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) {
        return false;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) {
        return false;
    }
    if (currentMessage !== previousMessage) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) {
        return false;
    }
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = _getFramesFromEvent(currentEvent);
    var previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) {
        return true;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) {
        return false;
    }
    currentFrames = currentFrames;
    previousFrames = previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) {
        return false;
    }
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) {
            return false;
        }
    }
    return true;
}
function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) {
        return true;
    }
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) {
        return false;
    }
    currentFingerprint = currentFingerprint;
    previousFingerprint = previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function _getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) {
        try {
            // @ts-expect-error Object could be undefined
            return exception.values[0].stacktrace.frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}
 //# sourceMappingURL=dedupe.js.map


/***/ }),

/***/ 33950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ GlobalHandlers; },
/* harmony export */   "k": function() { return /* binding */ globalHandlersIntegration; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62909);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77668);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62869);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74020);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25534);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41413);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92957);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53289);
/* harmony import */ var _eventbuilder_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50376);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50203);






/* eslint-disable @typescript-eslint/no-unsafe-member-access */ var INTEGRATION_NAME = "GlobalHandlers";
var _globalHandlersIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        onerror: true,
        onunhandledrejection: true
    }, options);
    return {
        name: INTEGRATION_NAME,
        setupOnce: function setupOnce() {
            Error.stackTraceLimit = 50;
        },
        setup: function setup(client) {
            if (_options.onerror) {
                _installGlobalOnErrorHandler(client);
                globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                _installGlobalOnUnhandledRejectionHandler(client);
                globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
var globalHandlersIntegration = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .defineIntegration */ ._I)(_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var GlobalHandlers = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .convertIntegrationFnToClass */ .RN)(INTEGRATION_NAME, globalHandlersIntegration);
function _installGlobalOnErrorHandler(client) {
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .addGlobalErrorInstrumentationHandler */ .V)(function(data) {
        var ref = getOptions(), stackParser = ref.stackParser, attachStacktrace = ref.attachStacktrace;
        if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .getClient */ .s3)() !== client || (0,_helpers_js__WEBPACK_IMPORTED_MODULE_4__/* .shouldIgnoreOnError */ .Wz)()) {
            return;
        }
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        var event = error === undefined && (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(msg) ? _eventFromIncompleteOnError(msg, url, line, column) : _enhanceEventWithInitialFrame((0,_eventbuilder_js__WEBPACK_IMPORTED_MODULE_6__/* .eventFromUnknownInput */ .ME)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .captureEvent */ .eN)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function _installGlobalOnUnhandledRejectionHandler(client) {
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .addGlobalUnhandledRejectionInstrumentationHandler */ .h)(function(e) {
        var ref = getOptions(), stackParser = ref.stackParser, attachStacktrace = ref.attachStacktrace;
        if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .getClient */ .s3)() !== client || (0,_helpers_js__WEBPACK_IMPORTED_MODULE_4__/* .shouldIgnoreOnError */ .Wz)()) {
            return;
        }
        var error = _getUnhandledRejectionError(e);
        var event = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .isPrimitive */ .pt)(error) ? _eventFromRejectionWithPrimitive(error) : (0,_eventbuilder_js__WEBPACK_IMPORTED_MODULE_6__/* .eventFromUnknownInput */ .ME)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .captureEvent */ .eN)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function _getUnhandledRejectionError(error) {
    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .isPrimitive */ .pt)(error)) {
        return error;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) {
            return e.reason;
        } else if ("detail" in e && "reason" in e.detail) {
            return e.detail.reason;
        }
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function _eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: ".concat(String(reason))
                }, 
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .isErrorEvent */ .VW)(msg) ? msg.message : msg;
    var name = "Error";
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }, 
            ]
        }
    };
    return _enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(url) && url.length > 0 ? url : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .getLocationHref */ .l4)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) {
        ev0sf.push({
            colno: colno,
            filename: filename,
            function: "?",
            in_app: true,
            lineno: lineno
        });
    }
    return event;
}
function globalHandlerLog(type) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_9__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_10__/* .logger.log */ .kg.log("Global Handler attached: ".concat(type));
}
function getOptions() {
    var client = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .getClient */ .s3)();
    var options = client && client.getOptions() || {
        stackParser: function() {
            return [];
        },
        attachStacktrace: false
    };
    return options;
}
 //# sourceMappingURL=globalhandlers.js.map


/***/ }),

/***/ 99027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ HttpContext; },
/* harmony export */   "s": function() { return /* binding */ httpContextIntegration; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62909);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50203);




var INTEGRATION_NAME = "HttpContext";
var _httpContextIntegration = function() {
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        preprocessEvent: function preprocessEvent(event) {
            // if none of the information we want exists, don't bother
            if (!_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.navigator */ .m9.navigator && !_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.location */ .m9.location && !_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document */ .m9.document) {
                return;
            }
            // grab as much info as exists and add it to the event
            var url = event.request && event.request.url || _helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.location */ .m9.location && _helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.location.href */ .m9.location.href;
            var referrer = (_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.document */ .m9.document || {}).referrer;
            var userAgent = (_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW.navigator */ .m9.navigator || {}).userAgent;
            var headers = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, event.request && event.request.headers, referrer && {
                Referer: referrer
            }, userAgent && {
                "User-Agent": userAgent
            });
            var request = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, event.request, url && {
                url: url
            }), {
                headers: headers
            });
            event.request = request;
        }
    };
};
var httpContextIntegration = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .defineIntegration */ ._I)(_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var HttpContext = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .convertIntegrationFnToClass */ .RN)(INTEGRATION_NAME, httpContextIntegration);
 //# sourceMappingURL=httpcontext.js.map


/***/ }),

/***/ 64980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ linkedErrorsIntegration; },
/* harmony export */   "i": function() { return /* binding */ LinkedErrors; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62909);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6837);
/* harmony import */ var _eventbuilder_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50376);



var DEFAULT_KEY = "cause";
var DEFAULT_LIMIT = 5;
var INTEGRATION_NAME = "LinkedErrors";
var _linkedErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var limit = options.limit || DEFAULT_LIMIT;
    var key = options.key || DEFAULT_KEY;
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        preprocessEvent: function preprocessEvent(event, hint, client) {
            var options = client.getOptions();
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .applyAggregateErrorsToEvent */ .Z)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            _eventbuilder_js__WEBPACK_IMPORTED_MODULE_1__/* .exceptionFromError */ .GJ, options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
var linkedErrorsIntegration = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .defineIntegration */ ._I)(_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var LinkedErrors = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .convertIntegrationFnToClass */ .RN)(INTEGRATION_NAME, linkedErrorsIntegration);
 //# sourceMappingURL=linkederrors.js.map


/***/ }),

/***/ 66155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ TryCatch; },
/* harmony export */   "t": function() { return /* binding */ browserApiErrorsIntegration; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62909);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27389);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91987);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50203);




var DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload", 
];
var INTEGRATION_NAME = "TryCatch";
var _browserApiErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true
    }, options);
    return {
        name: INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce: function setupOnce() {
            if (_options.setTimeout) {
                (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .hl)(_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW */ .m9, "setTimeout", _wrapTimeFunction);
            }
            if (_options.setInterval) {
                (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .hl)(_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW */ .m9, "setInterval", _wrapTimeFunction);
            }
            if (_options.requestAnimationFrame) {
                (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .hl)(_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW */ .m9, "requestAnimationFrame", _wrapRAF);
            }
            if (_options.XMLHttpRequest && "XMLHttpRequest" in _helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW */ .m9) {
                (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .hl)(XMLHttpRequest.prototype, "send", _wrapXHR);
            }
            var eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
                eventTarget.forEach(_wrapEventTarget);
            }
        }
    };
};
var browserApiErrorsIntegration = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .defineIntegration */ ._I)(_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var TryCatch = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .convertIntegrationFnToClass */ .RN)(INTEGRATION_NAME, browserApiErrorsIntegration);
function _wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var originalCallback = args[0];
        args[0] = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .wrap */ .re)(originalCallback, {
            mechanism: {
                data: {
                    function: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0,_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .wrap */ .re)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            }), 
        ]);
    };
}
function _wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === "function") {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .hl)(xhr, prop, function(original) {
                    var wrapOptions = {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(original)
                            },
                            handled: false,
                            type: "instrument"
                        }
                    };
                    // If Instrument integration has been called before TryCatch, get the name of original function
                    var originalFunction = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getOriginalFunction */ .HK)(original);
                    if (originalFunction) {
                        wrapOptions.mechanism.data.handler = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(originalFunction);
                    }
                    // Otherwise wrap directly
                    return (0,_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .wrap */ .re)(original, wrapOptions);
                });
            }
        });
        return originalSend.apply(this, args);
    };
}
function _wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var globalObject = _helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW */ .m9;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) {
        return;
    }
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .hl)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") {
                    // ESlint disable explanation:
                    //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                    //  introduce a bug here, because bind returns a new function that doesn't have our
                    //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                    //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                    // eslint-disable-next-line @typescript-eslint/unbound-method
                    fn.handleEvent = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .wrap */ .re)(fn.handleEvent, {
                        mechanism: {
                            data: {
                                function: "handleEvent",
                                handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(fn),
                                target: target
                            },
                            handled: false,
                            type: "instrument"
                        }
                    });
                }
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0,_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .wrap */ .re)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFunctionName */ .$P)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options, 
            ]);
        };
    });
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .hl)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) {
                    originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}
 //# sourceMappingURL=trycatch.js.map


/***/ }),

/***/ 26279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eg": function() { return /* binding */ forceLoad; },
/* harmony export */   "Jd": function() { return /* binding */ captureUserFeedback; },
/* harmony export */   "S1": function() { return /* binding */ init; },
/* harmony export */   "SS": function() { return /* binding */ defaultIntegrations; },
/* harmony export */   "jp": function() { return /* binding */ showReportDialog; },
/* harmony export */   "lA": function() { return /* binding */ onLoad; },
/* harmony export */   "nV": function() { return /* binding */ getDefaultIntegrations; },
/* harmony export */   "re": function() { return /* binding */ wrap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36305);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22283);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97936);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(62909);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(83283);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(19217);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(89342);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(77668);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(91987);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59036);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(92957);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(41549);
/* harmony import */ var _client_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(4973);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(53289);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50203);
/* harmony import */ var _integrations_breadcrumbs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47394);
/* harmony import */ var _integrations_dedupe_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78849);
/* harmony import */ var _integrations_globalhandlers_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33950);
/* harmony import */ var _integrations_httpcontext_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99027);
/* harmony import */ var _integrations_linkederrors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64980);
/* harmony import */ var _integrations_trycatch_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66155);
/* harmony import */ var _stack_parsers_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(37789);
/* harmony import */ var _transports_fetch_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(92409);
/* harmony import */ var _transports_xhr_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(81738);

















/** @deprecated Use `getDefaultIntegrations(options)` instead. */ var defaultIntegrations = [
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .inboundFiltersIntegration */ .S)(),
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .functionToStringIntegration */ .C)(),
    (0,_integrations_trycatch_js__WEBPACK_IMPORTED_MODULE_2__/* .browserApiErrorsIntegration */ .t)(),
    (0,_integrations_breadcrumbs_js__WEBPACK_IMPORTED_MODULE_3__/* .breadcrumbsIntegration */ .f)(),
    (0,_integrations_globalhandlers_js__WEBPACK_IMPORTED_MODULE_4__/* .globalHandlersIntegration */ .k)(),
    (0,_integrations_linkederrors_js__WEBPACK_IMPORTED_MODULE_5__/* .linkedErrorsIntegration */ .O)(),
    (0,_integrations_dedupe_js__WEBPACK_IMPORTED_MODULE_6__/* .dedupeIntegration */ .R)(),
    (0,_integrations_httpcontext_js__WEBPACK_IMPORTED_MODULE_7__/* .httpContextIntegration */ .s)(), 
];
/** Get the default integrations for the browser SDK. */ function getDefaultIntegrations(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return(// eslint-disable-next-line deprecation/deprecation
    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(defaultIntegrations));
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function init() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = getDefaultIntegrations();
    }
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") {
            options.release = __SENTRY_RELEASE__;
        }
        // This supports the variable that sentry-webpack-plugin injects
        if (_helpers_js__WEBPACK_IMPORTED_MODULE_9__/* .WINDOW.SENTRY_RELEASE */ .m9.SENTRY_RELEASE && _helpers_js__WEBPACK_IMPORTED_MODULE_9__/* .WINDOW.SENTRY_RELEASE.id */ .m9.SENTRY_RELEASE.id) {
            options.release = _helpers_js__WEBPACK_IMPORTED_MODULE_9__/* .WINDOW.SENTRY_RELEASE.id */ .m9.SENTRY_RELEASE.id;
        }
    }
    if (options.autoSessionTracking === undefined) {
        options.autoSessionTracking = true;
    }
    if (options.sendClientReports === undefined) {
        options.sendClientReports = true;
    }
    var clientOptions = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, options), {
        stackParser: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .stackParserFromStackParserOptions */ .Sq)(options.stackParser || _stack_parsers_js__WEBPACK_IMPORTED_MODULE_13__/* .defaultStackParser */ .Dt),
        integrations: (0,_sentry_core__WEBPACK_IMPORTED_MODULE_14__/* .getIntegrationsToSetup */ .m8)(options),
        transport: options.transport || ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_15__/* .supportsFetch */ .Ak)() ? _transports_fetch_js__WEBPACK_IMPORTED_MODULE_16__/* .makeFetchTransport */ .f : _transports_xhr_js__WEBPACK_IMPORTED_MODULE_17__/* .makeXHRTransport */ .K)
    });
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_18__/* .initAndBind */ .M)(_client_js__WEBPACK_IMPORTED_MODULE_19__/* .BrowserClient */ .R, clientOptions);
    if (options.autoSessionTracking) {
        startSessionTracking();
    }
}
var showReportDialog = function() {
    var // eslint-disable-next-line deprecation/deprecation
    options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, // eslint-disable-next-line deprecation/deprecation
    hub = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0,_sentry_core__WEBPACK_IMPORTED_MODULE_20__/* .getCurrentHub */ .Gd)();
    // doesn't work without a document (React Native)
    if (!_helpers_js__WEBPACK_IMPORTED_MODULE_9__/* .WINDOW.document */ .m9.document) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_21__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_22__/* .logger.error */ .kg.error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    var ref = hub.getStackTop(), client = ref.client, scope = ref.scope;
    var dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_21__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_22__/* .logger.error */ .kg.error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) {
        options.user = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, scope.getUser(), options.user);
    }
    if (!options.eventId) {
        // eslint-disable-next-line deprecation/deprecation
        options.eventId = hub.lastEventId();
    }
    var script = _helpers_js__WEBPACK_IMPORTED_MODULE_9__/* .WINDOW.document.createElement */ .m9.document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_23__/* .getReportDialogEndpoint */ .h)(dsn, options);
    if (options.onLoad) {
        script.onload = options.onLoad;
    }
    var onClose = options.onClose;
    if (onClose) {
        var reportDialogClosedMessageHandler = function(event) {
            if (event.data === "__sentry_reportdialog_closed__") {
                try {
                    onClose();
                } finally{
                    _helpers_js__WEBPACK_IMPORTED_MODULE_9__/* .WINDOW.removeEventListener */ .m9.removeEventListener("message", reportDialogClosedMessageHandler);
                }
            }
        };
        _helpers_js__WEBPACK_IMPORTED_MODULE_9__/* .WINDOW.addEventListener */ .m9.addEventListener("message", reportDialogClosedMessageHandler);
    }
    var injectionPoint = _helpers_js__WEBPACK_IMPORTED_MODULE_9__/* .WINDOW.document.head */ .m9.document.head || _helpers_js__WEBPACK_IMPORTED_MODULE_9__/* .WINDOW.document.body */ .m9.document.body;
    if (injectionPoint) {
        injectionPoint.appendChild(script);
    } else {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_21__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_22__/* .logger.error */ .kg.error("Not injecting report dialog. No injection point found in HTML");
    }
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function forceLoad() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function onLoad(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrap(fn) {
    return (0,_helpers_js__WEBPACK_IMPORTED_MODULE_9__/* .wrap */ .re)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function startSessionTracking() {
    if (typeof _helpers_js__WEBPACK_IMPORTED_MODULE_9__/* .WINDOW.document */ .m9.document === "undefined") {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_21__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_22__/* .logger.warn */ .kg.warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_24__/* .startSession */ .yj)({
        ignoreDuration: true
    });
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_24__/* .captureSession */ .cg)();
    // We want to create a session for every navigation as well
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_25__/* .addHistoryInstrumentationHandler */ .a)(function(param) {
        var from = param.from, to = param.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0,_sentry_core__WEBPACK_IMPORTED_MODULE_24__/* .startSession */ .yj)({
                ignoreDuration: true
            });
            (0,_sentry_core__WEBPACK_IMPORTED_MODULE_24__/* .captureSession */ .cg)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function captureUserFeedback(feedback) {
    var client = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_24__/* .getClient */ .s3)();
    if (client) {
        client.captureUserFeedback(feedback);
    }
}
 //# sourceMappingURL=sdk.js.map


/***/ }),

/***/ 37789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$3": function() { return /* binding */ chromeStackLineParser; },
/* harmony export */   "$Q": function() { return /* binding */ geckoStackLineParser; },
/* harmony export */   "Dt": function() { return /* binding */ defaultStackParser; },
/* harmony export */   "HH": function() { return /* binding */ opera11StackLineParser; },
/* harmony export */   "NP": function() { return /* binding */ opera10StackLineParser; },
/* harmony export */   "R2": function() { return /* binding */ winjsStackLineParser; },
/* harmony export */   "d8": function() { return /* binding */ defaultStackLineParsers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);



// global reference to slice
var UNKNOWN_FUNCTION = "?";
var OPERA10_PRIORITY = 10;
var OPERA11_PRIORITY = 20;
var CHROME_PRIORITY = 30;
var WINJS_PRIORITY = 40;
var GECKO_PRIORITY = 50;
function createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) {
        frame.lineno = lineno;
    }
    if (colno !== undefined) {
        frame.colno = colno;
    }
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
var chromeStackParserFn = function(line) {
    var parts = chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            var subMatch = chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]), 2), func = ref[0], filename = ref[1];
        return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var chromeStackLineParser = [
    CHROME_PRIORITY,
    chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var gecko = function(line) {
    var parts = geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            var subMatch = geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || UNKNOWN_FUNCTION;
        var ref;
        ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(extractSafariExtensionDetails(func, filename), 2), func = ref[0], filename = ref[1], ref;
        return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var geckoStackLineParser = [
    GECKO_PRIORITY,
    gecko
];
var winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var winjs = function(line) {
    var parts = winjsRegex.exec(line);
    return parts ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var winjsStackLineParser = [
    WINJS_PRIORITY,
    winjs
];
var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var opera10 = function(line) {
    var parts = opera10Regex.exec(line);
    return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var opera10StackLineParser = [
    OPERA10_PRIORITY,
    opera10
];
var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var opera11 = function(line) {
    var parts = opera11Regex.exec(line);
    return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var opera11StackLineParser = [
    OPERA11_PRIORITY,
    opera11
];
var defaultStackLineParsers = [
    chromeStackLineParser,
    geckoStackLineParser,
    winjsStackLineParser
];
var defaultStackParser = _sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .createStackParser.apply */ .pE.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(defaultStackLineParsers));
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf("safari-extension") !== -1;
    var isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:".concat(filename) : "safari-web-extension:".concat(filename), 
    ] : [
        func,
        filename
    ];
};
 //# sourceMappingURL=stack-parsers.js.map


/***/ }),

/***/ 92409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ makeFetchTransport; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/transports/base.js + 1 modules
var base = __webpack_require__(25576);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(21200);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(59036);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(92957);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/debug-build.js
var debug_build = __webpack_require__(53289);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(50203);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/utils.js



var cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function getNativeFetchImplementation() {
    if (cachedFetchImpl) {
        return cachedFetchImpl;
    }
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0,supports/* isNativeFetch */.Du)(helpers/* WINDOW.fetch */.m9.fetch)) {
        return cachedFetchImpl = helpers/* WINDOW.fetch.bind */.m9.fetch.bind(helpers/* WINDOW */.m9);
    }
    var document = helpers/* WINDOW.document */.m9.document;
    var fetchImpl = helpers/* WINDOW.fetch */.m9.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") {
        try {
            var sandbox = document.createElement("iframe");
            sandbox.hidden = true;
            document.head.appendChild(sandbox);
            var contentWindow = sandbox.contentWindow;
            if (contentWindow && contentWindow.fetch) {
                fetchImpl = contentWindow.fetch;
            }
            document.head.removeChild(sandbox);
        } catch (e) {
            debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
        }
    }
    return cachedFetchImpl = fetchImpl.bind(helpers/* WINDOW */.m9);
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function clearCachedFetchImplementation() {
    cachedFetchImpl = undefined;
}
 //# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js




/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function makeFetchTransport(options) {
    var nativeFetch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getNativeFetchImplementation();
    var makeRequest = function makeRequest(request) {
        var requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        var requestOptions = (0,_object_spread/* default */.Z)({
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15
        }, options.fetchOptions);
        try {
            return nativeFetch(options.url, requestOptions).then(function(response) {
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            clearCachedFetchImplementation();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0,syncpromise/* rejectedSyncPromise */.$2)(e);
        }
    };
    var pendingBodySize = 0;
    var pendingCount = 0;
    return (0,base/* createTransport */.q)(options, makeRequest);
}
 //# sourceMappingURL=fetch.js.map


/***/ }),

/***/ 81738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ makeXHRTransport; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25576);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21200);


/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function makeXHRTransport(options) {
    var makeRequest = function makeRequest(request) {
        return new _sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .SyncPromise */ .cW(function(resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = function() {
                if (xhr.readyState === XHR_READYSTATE_DONE) {
                    resolve({
                        statusCode: xhr.status,
                        headers: {
                            "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                            "retry-after": xhr.getResponseHeader("Retry-After")
                        }
                    });
                }
            };
            xhr.open("POST", options.url);
            for(var header in options.headers){
                if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
                    xhr.setRequestHeader(header, options.headers[header]);
                }
            }
            xhr.send(request.body);
        });
    };
    return (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .createTransport */ .q)(options, makeRequest);
}
 //# sourceMappingURL=xhr.js.map


/***/ }),

/***/ 51339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ createUserFeedbackEnvelope; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74094);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62486);


/**
 * Creates an envelope from a user feedback.
 */ function createUserFeedbackEnvelope(feedback, param) {
    var metadata = param.metadata, tunnel = param.tunnel, dsn = param.dsn;
    var headers = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        event_id: feedback.event_id,
        sent_at: new Date().toISOString()
    }, metadata && metadata.sdk && {
        sdk: {
            name: metadata.sdk.name,
            version: metadata.sdk.version
        }
    }, !!tunnel && !!dsn && {
        dsn: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .dsnToString */ .RA)(dsn)
    });
    var item = createUserFeedbackEnvelopeItem(feedback);
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .createEnvelope */ .Jd)(headers, [
        item
    ]);
}
function createUserFeedbackEnvelopeItem(feedback) {
    var feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}
 //# sourceMappingURL=userfeedback.js.map


/***/ }),

/***/ 89342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getEnvelopeEndpointWithUrlEncodedAuth; },
/* harmony export */   "h": function() { return /* binding */ getReportDialogEndpoint; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27389);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74094);


var SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? "".concat(dsn.protocol, ":") : "";
    var port = dsn.port ? ":".concat(dsn.port) : "";
    return "".concat(protocol, "//").concat(dsn.host).concat(port).concat(dsn.path ? "/".concat(dsn.path) : "", "/api/");
}
/** Returns the ingest API endpoint for target. */ function _getIngestEndpoint(dsn) {
    return "".concat(getBaseApiEndpoint(dsn)).concat(dsn.projectId, "/envelope/");
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function _encodedAuth(dsn, sdkInfo) {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .urlEncode */ ._j)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: SENTRY_API_VERSION
    }, sdkInfo && {
        sentry_client: "".concat(sdkInfo.name, "/").concat(sdkInfo.version)
    }));
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function getEnvelopeEndpointWithUrlEncodedAuth(dsn) {
    var // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
    // options: ClientOptions = {} as ClientOptions,
    tunnelOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    var tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    var sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : "".concat(_getIngestEndpoint(dsn), "?").concat(_encodedAuth(dsn, sdkInfo));
}
/** Returns the url to the report dialog endpoint. */ function getReportDialogEndpoint(dsnLike, dialogOptions) {
    var dsn = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .makeDsn */ .vK)(dsnLike);
    if (!dsn) {
        return "";
    }
    var endpoint = "".concat(getBaseApiEndpoint(dsn), "embed/error-page/");
    var encodedOptions = "dsn=".concat((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dsnToString */ .RA)(dsn));
    for(var key in dialogOptions){
        if (key === "dsn") {
            continue;
        }
        if (key === "onClose") {
            continue;
        }
        if (key === "user") {
            var user = dialogOptions.user;
            if (!user) {
                continue;
            }
            if (user.name) {
                encodedOptions += "&name=".concat(encodeURIComponent(user.name));
            }
            if (user.email) {
                encodedOptions += "&email=".concat(encodeURIComponent(user.email));
            }
        } else {
            encodedOptions += "&".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(dialogOptions[key]));
        }
    }
    return "".concat(endpoint, "?").concat(encodedOptions);
}
 //# sourceMappingURL=api.js.map


/***/ }),

/***/ 99892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ BaseClient; },
  "Q": function() { return /* binding */ addEventProcessor; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/dsn.js
var esm_dsn = __webpack_require__(74094);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(92957);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(11591);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(74020);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(21200);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/envelope.js
var envelope = __webpack_require__(62486);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/error.js
var error = __webpack_require__(16901);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/api.js
var api = __webpack_require__(89342);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/debug-build.js
var debug_build = __webpack_require__(80107);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/envelope.js
var esm_envelope = __webpack_require__(15193);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(77668);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(19217);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/integration.js
var esm_integration = __webpack_require__(62909);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/metrics/utils.js
var utils = __webpack_require__(8168);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/metrics/envelope.js


/**
 * Create envelope from a metric aggregate.
 */ function createMetricEnvelope(metricBucketItems, dsn, metadata, tunnel) {
    var headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) {
        headers.sdk = {
            name: metadata.sdk.name,
            version: metadata.sdk.version
        };
    }
    if (!!tunnel && dsn) {
        headers.dsn = (0,esm_dsn/* dsnToString */.RA)(dsn);
    }
    var item = createMetricEnvelopeItem(metricBucketItems);
    return (0,envelope/* createEnvelope */.Jd)(headers, [
        item
    ]);
}
function createMetricEnvelopeItem(metricBucketItems) {
    var payload = (0,utils/* serializeMetricBuckets */.uv)(metricBucketItems);
    var metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}
 //# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/session.js
var esm_session = __webpack_require__(36463);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/dynamicSamplingContext.js
var tracing_dynamicSamplingContext = __webpack_require__(63055);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/prepareEvent.js
var prepareEvent = __webpack_require__(70271);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/baseclient.js


















var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ var BaseClient = /*#__PURE__*/ function() {
    "use strict";
    function BaseClient(options) {
        (0,_class_call_check/* default */.Z)(this, BaseClient);
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) {
            this._dsn = (0,esm_dsn/* makeDsn */.vK)(options.dsn);
        } else {
            debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("No DSN provided, client will not send events.");
        }
        if (this._dsn) {
            var url = (0,api/* getEnvelopeEndpointWithUrlEncodedAuth */.U)(this._dsn, options);
            this._transport = options.transport((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this)
            }, options.transportOptions), {
                url: url
            }));
        }
    }
    (0,_create_class/* default */.Z)(BaseClient, [
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
            key: "captureException",
            value: function captureException(exception, hint, scope) {
                var _this = this;
                // ensure we haven't captured this very object before
                if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
                    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
                    return;
                }
                var eventId = hint && hint.event_id;
                this._process(this.eventFromException(exception, hint).then(function(event) {
                    return _this._captureEvent(event, hint, scope);
                }).then(function(result) {
                    eventId = result;
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureMessage",
            value: function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
            level, hint, scope) {
                var _this = this;
                var eventId = hint && hint.event_id;
                var eventMessage = (0,is/* isParameterizedString */.Le)(message) ? message : String(message);
                var promisedEvent = (0,is/* isPrimitive */.pt)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
                this._process(promisedEvent.then(function(event) {
                    return _this._captureEvent(event, hint, scope);
                }).then(function(result) {
                    eventId = result;
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureEvent",
            value: function captureEvent(event, hint, scope) {
                // ensure we haven't captured this very object before
                if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
                    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
                    return;
                }
                var eventId = hint && hint.event_id;
                var sdkProcessingMetadata = event.sdkProcessingMetadata || {};
                var capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
                this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then(function(result) {
                    eventId = result;
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureSession",
            value: function captureSession(session) {
                if (!(typeof session.release === "string")) {
                    debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("Discarded session because of missing or non-string release");
                } else {
                    this.sendSession(session);
                    // After sending, we set init false to indicate it's not the first occurrence
                    (0,esm_session/* updateSession */.CT)(session, {
                        init: false
                    });
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getDsn",
            value: function getDsn() {
                return this._dsn;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getOptions",
            value: function getOptions() {
                return this._options;
            }
        },
        {
            /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ key: "getSdkMetadata",
            value: function getSdkMetadata() {
                return this._options._metadata;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getTransport",
            value: function getTransport() {
                return this._transport;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "flush",
            value: function flush(timeout) {
                var transport = this._transport;
                if (transport) {
                    if (this.metricsAggregator) {
                        this.metricsAggregator.flush();
                    }
                    return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
                        return transport.flush(timeout).then(function(transportFlushed) {
                            return clientFinished && transportFlushed;
                        });
                    });
                } else {
                    return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "close",
            value: function close(timeout) {
                var _this = this;
                return this.flush(timeout).then(function(result) {
                    _this.getOptions().enabled = false;
                    if (_this.metricsAggregator) {
                        _this.metricsAggregator.close();
                    }
                    return result;
                });
            }
        },
        {
            /** Get all installed event processors. */ key: "getEventProcessors",
            value: function getEventProcessors() {
                return this._eventProcessors;
            }
        },
        {
            /** @inheritDoc */ key: "addEventProcessor",
            value: function addEventProcessor(eventProcessor) {
                this._eventProcessors.push(eventProcessor);
            }
        },
        {
            /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ key: "setupIntegrations",
            value: function setupIntegrations(forceInitialize) {
                if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) {
                    this._setupIntegrations();
                }
            }
        },
        {
            /** @inheritdoc */ key: "init",
            value: function init() {
                if (this._isEnabled()) {
                    this._setupIntegrations();
                }
            }
        },
        {
            /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ key: "getIntegrationById",
            value: function getIntegrationById(integrationId) {
                return this.getIntegrationByName(integrationId);
            }
        },
        {
            /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ key: "getIntegrationByName",
            value: function getIntegrationByName(integrationName) {
                return this._integrations[integrationName];
            }
        },
        {
            /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ key: "getIntegration",
            value: function getIntegration(integration) {
                try {
                    return this._integrations[integration.id] || null;
                } catch (_oO) {
                    debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("Cannot retrieve integration ".concat(integration.id, " from the current Client"));
                    return null;
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addIntegration",
            value: function addIntegration(integration) {
                var isAlreadyInstalled = this._integrations[integration.name];
                // This hook takes care of only installing if not already installed
                (0,esm_integration/* setupIntegration */.m7)(this, integration, this._integrations);
                // Here we need to check manually to make sure to not run this multiple times
                if (!isAlreadyInstalled) {
                    (0,esm_integration/* afterSetupIntegrations */.uf)(this, [
                        integration
                    ]);
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "sendEvent",
            value: function sendEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                this.emit("beforeSendEvent", event, hint);
                var env = (0,esm_envelope/* createEventEnvelope */.M)(event, this._dsn, this._options._metadata, this._options.tunnel);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (hint.attachments || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var attachment = _step.value;
                        env = (0,envelope/* addItemToEnvelope */.BO)(env, (0,envelope/* createAttachmentEnvelopeItem */.zQ)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var promise = this._sendEnvelope(env);
                if (promise) {
                    promise.then(function(sendResponse) {
                        return _this.emit("afterSendEvent", event, sendResponse);
                    }, null);
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "sendSession",
            value: function sendSession(session) {
                var env = (0,esm_envelope/* createSessionEnvelope */.Q)(session, this._dsn, this._options._metadata, this._options.tunnel);
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(env);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "recordDroppedEvent",
            value: function recordDroppedEvent(reason, category, eventOrCount) {
                if (this._options.sendClientReports) {
                    // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
                    // If event is passed as third argument, we assume this is a count of 1
                    var count = typeof eventOrCount === "number" ? eventOrCount : 1;
                    // We want to track each category (error, transaction, session, replay_event) separately
                    // but still keep the distinction between different type of outcomes.
                    // We could use nested maps, but it's much easier to read and type this way.
                    // A correct type for map-based implementation if we want to go that route
                    // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
                    // With typescript 4.1 we could even use template literal types
                    var key = "".concat(reason, ":").concat(category);
                    debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log('Recording outcome: "'.concat(key, '"').concat(count > 1 ? " (".concat(count, " times)") : ""));
                    this._outcomes[key] = (this._outcomes[key] || 0) + count;
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureAggregateMetrics",
            value: function captureAggregateMetrics(metricBucketItems) {
                debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("Flushing aggregated metrics, number of metrics: ".concat(metricBucketItems.length));
                var metricsEnvelope = createMetricEnvelope(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(metricsEnvelope);
            }
        },
        {
            // Keep on() & emit() signatures in sync with types' client.ts interface
            /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ key: "on",
            value: function on(hook, callback) {
                if (!this._hooks[hook]) {
                    this._hooks[hook] = [];
                }
                // @ts-expect-error We assue the types are correct
                this._hooks[hook].push(callback);
            }
        },
        {
            /** @inheritdoc */ /** @inheritdoc */ key: "emit",
            value: function emit(hook) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                if (this._hooks[hook]) {
                    this._hooks[hook].forEach(function(callback) {
                        return callback.apply(void 0, (0,_to_consumable_array/* default */.Z)(rest));
                    });
                }
            }
        },
        {
            /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ key: "_setupIntegrations",
            value: function _setupIntegrations() {
                var integrations = this._options.integrations;
                this._integrations = (0,esm_integration/* setupIntegrations */.q4)(this, integrations);
                (0,esm_integration/* afterSetupIntegrations */.uf)(this, integrations);
                // TODO v8: We don't need this flag anymore
                this._integrationsInitialized = true;
            }
        },
        {
            /** Updates existing session based on the provided event */ key: "_updateSessionFromEvent",
            value: function _updateSessionFromEvent(session, event) {
                var crashed = false;
                var errored = false;
                var exceptions = event.exception && event.exception.values;
                if (exceptions) {
                    errored = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = exceptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var ex = _step.value;
                            var mechanism = ex.mechanism;
                            if (mechanism && mechanism.handled === false) {
                                crashed = true;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                // A session is updated and that session update is sent in only one of the two following scenarios:
                // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
                // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
                var sessionNonTerminal = session.status === "ok";
                var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
                if (shouldUpdateAndSend) {
                    (0,esm_session/* updateSession */.CT)(session, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, crashed && {
                        status: "crashed"
                    }), {
                        errors: session.errors || Number(errored || crashed)
                    }));
                    this.captureSession(session);
                }
            }
        },
        {
            /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ key: "_isClientDoneProcessing",
            value: function _isClientDoneProcessing(timeout) {
                var _this = this;
                return new syncpromise/* SyncPromise */.cW(function(resolve) {
                    var ticked = 0;
                    var tick = 1;
                    var interval = setInterval(function() {
                        if (_this._numProcessing == 0) {
                            clearInterval(interval);
                            resolve(true);
                        } else {
                            ticked += tick;
                            if (timeout && ticked >= timeout) {
                                clearInterval(interval);
                                resolve(false);
                            }
                        }
                    }, tick);
                });
            }
        },
        {
            /** Determines whether this SDK is enabled and a transport is present. */ key: "_isEnabled",
            value: function _isEnabled() {
                return this.getOptions().enabled !== false && this._transport !== undefined;
            }
        },
        {
            /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ key: "_prepareEvent",
            value: function _prepareEvent(event, hint, scope) {
                var isolationScope = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (0,hub/* getIsolationScope */.aF)();
                var _this = this;
                var options = this.getOptions();
                var integrations = Object.keys(this._integrations);
                if (!hint.integrations && integrations.length > 0) {
                    hint.integrations = integrations;
                }
                this.emit("preprocessEvent", event, hint);
                return (0,prepareEvent/* prepareEvent */.R)(options, event, hint, scope, this, isolationScope).then(function(evt) {
                    if (evt === null) {
                        return evt;
                    }
                    var propagationContext = (0,_object_spread/* default */.Z)({}, isolationScope.getPropagationContext(), scope ? scope.getPropagationContext() : undefined);
                    var trace = evt.contexts && evt.contexts.trace;
                    if (!trace && propagationContext) {
                        var trace_id = propagationContext.traceId, spanId = propagationContext.spanId, parentSpanId = propagationContext.parentSpanId, dsc = propagationContext.dsc;
                        evt.contexts = (0,_object_spread/* default */.Z)({
                            trace: {
                                trace_id: trace_id,
                                span_id: spanId,
                                parent_span_id: parentSpanId
                            }
                        }, evt.contexts);
                        var dynamicSamplingContext = dsc ? dsc : (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromClient */._)(trace_id, _this, scope);
                        evt.sdkProcessingMetadata = (0,_object_spread/* default */.Z)({
                            dynamicSamplingContext: dynamicSamplingContext
                        }, evt.sdkProcessingMetadata);
                    }
                    return evt;
                });
            }
        },
        {
            /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ key: "_captureEvent",
            value: function _captureEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, scope = arguments.length > 2 ? arguments[2] : void 0;
                return this._processEvent(event, hint, scope).then(function(finalEvent) {
                    return finalEvent.event_id;
                }, function(reason) {
                    if (debug_build/* DEBUG_BUILD */.X) {
                        // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                        // control flow, log just the message (no stack) as a log-level log.
                        var sentryError = reason;
                        if (sentryError.logLevel === "log") {
                            logger/* logger.log */.kg.log(sentryError.message);
                        } else {
                            logger/* logger.warn */.kg.warn(sentryError);
                        }
                    }
                    return undefined;
                });
            }
        },
        {
            /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ key: "_processEvent",
            value: function _processEvent(event, hint, scope) {
                var _this = this;
                var options = this.getOptions();
                var sampleRate = options.sampleRate;
                var isTransaction = isTransactionEvent(event);
                var isError = isErrorEvent(event);
                var eventType = event.type || "error";
                var beforeSendLabel = "before send for type `".concat(eventType, "`");
                // 1.0 === 100% events are sent
                // 0.0 === 0% events are sent
                // Sampling for transaction happens somewhere else
                if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
                    this.recordDroppedEvent("sample_rate", "error", event);
                    return (0,syncpromise/* rejectedSyncPromise */.$2)(new error/* SentryError */.b("Discarding event because it's not included in the random sample (sampling rate = ".concat(sampleRate, ")"), "log"));
                }
                var dataCategory = eventType === "replay_event" ? "replay" : eventType;
                var sdkProcessingMetadata = event.sdkProcessingMetadata || {};
                var capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
                return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then(function(prepared) {
                    if (prepared === null) {
                        _this.recordDroppedEvent("event_processor", dataCategory, event);
                        throw new error/* SentryError */.b("An event processor returned `null`, will not send event.", "log");
                    }
                    var isInternalException = hint.data && hint.data.__sentry__ === true;
                    if (isInternalException) {
                        return prepared;
                    }
                    var result = processBeforeSend(options, prepared, hint);
                    return _validateBeforeSendResult(result, beforeSendLabel);
                }).then(function(processedEvent) {
                    if (processedEvent === null) {
                        _this.recordDroppedEvent("before_send", dataCategory, event);
                        if (isTransaction) {
                            var spans = event.spans || [];
                            // the transaction itself counts as one span, plus all the child spans that are added
                            var spanCount = 1 + spans.length;
                            _this.recordDroppedEvent("before_send", "span", spanCount);
                        }
                        throw new error/* SentryError */.b("".concat(beforeSendLabel, " returned `null`, will not send event."), "log");
                    }
                    var session = scope && scope.getSession();
                    if (!isTransaction && session) {
                        _this._updateSessionFromEvent(session, processedEvent);
                    }
                    if (isTransaction) {
                        var spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                        var spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                        var droppedSpanCount = spanCountBefore - spanCountAfter;
                        if (droppedSpanCount > 0) {
                            _this.recordDroppedEvent("before_send", "span", droppedSpanCount);
                        }
                    }
                    // None of the Sentry built event processor will update transaction name,
                    // so if the transaction name has been changed by an event processor, we know
                    // it has to come from custom event processor added by a user
                    var transactionInfo = processedEvent.transaction_info;
                    if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                        var source = "custom";
                        processedEvent.transaction_info = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, transactionInfo), {
                            source: source
                        });
                    }
                    _this.sendEvent(processedEvent, hint);
                    return processedEvent;
                }).then(null, function(reason) {
                    if ((0,_instanceof/* default */.Z)(reason, error/* SentryError */.b)) {
                        throw reason;
                    }
                    _this.captureException(reason, {
                        data: {
                            __sentry__: true
                        },
                        originalException: reason
                    });
                    throw new error/* SentryError */.b("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ".concat(reason));
                });
            }
        },
        {
            /**
   * Occupies the client with processing and event
   */ key: "_process",
            value: function _process(promise) {
                var _this = this;
                this._numProcessing++;
                void promise.then(function(value) {
                    _this._numProcessing--;
                    return value;
                }, function(reason) {
                    _this._numProcessing--;
                    return reason;
                });
            }
        },
        {
            /**
   * @inheritdoc
   */ key: "_sendEnvelope",
            value: function _sendEnvelope(envelope) {
                this.emit("beforeEnvelope", envelope);
                if (this._isEnabled() && this._transport) {
                    return this._transport.send(envelope).then(null, function(reason) {
                        debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error("Error while sending event:", reason);
                    });
                } else {
                    debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error("Transport disabled");
                }
            }
        },
        {
            /**
   * Clears outcomes on this client and returns them.
   */ key: "_clearOutcomes",
            value: function _clearOutcomes() {
                var outcomes = this._outcomes;
                this._outcomes = {};
                return Object.keys(outcomes).map(function(key) {
                    var ref = (0,_sliced_to_array/* default */.Z)(key.split(":"), 2), reason = ref[0], category = ref[1];
                    return {
                        reason: reason,
                        category: category,
                        quantity: outcomes[key]
                    };
                });
            }
        }
    ]);
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function _validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    var invalidValueError = "".concat(beforeSendLabel, " must return `null` or a valid event.");
    if ((0,is/* isThenable */.J8)(beforeSendResult)) {
        return beforeSendResult.then(function(event) {
            if (!(0,is/* isPlainObject */.PO)(event) && event !== null) {
                throw new error/* SentryError */.b(invalidValueError);
            }
            return event;
        }, function(e) {
            throw new error/* SentryError */.b("".concat(beforeSendLabel, " rejected with ").concat(e));
        });
    } else if (!(0,is/* isPlainObject */.PO)(beforeSendResult) && beforeSendResult !== null) {
        throw new error/* SentryError */.b(invalidValueError);
    }
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function processBeforeSend(options, event, hint) {
    var beforeSend = options.beforeSend, beforeSendTransaction = options.beforeSendTransaction;
    if (isErrorEvent(event) && beforeSend) {
        return beforeSend(event, hint);
    }
    if (isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            var spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, event.sdkProcessingMetadata), {
                spanCountBeforeProcessing: spanCountBefore
            });
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function isErrorEvent(event) {
    return event.type === undefined;
}
function isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function addEventProcessor(callback) {
    var client = (0,esm_exports/* getClient */.s3)();
    if (!client || !client.addEventProcessor) {
        return;
    }
    client.addEventProcessor(callback);
}
 //# sourceMappingURL=baseclient.js.map


/***/ }),

/***/ 15193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ createEventEnvelope; },
/* harmony export */   "Q": function() { return /* binding */ createSessionEnvelope; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36305);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62486);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74094);



/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) {
        return event;
    }
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(event.sdk.integrations || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(sdkInfo.integrations || []));
    event.sdk.packages = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(event.sdk.packages || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(sdkInfo.packages || []));
    return event;
}
/** Creates an envelope from a Session */ function createSessionEnvelope(session, dsn, metadata, tunnel) {
    var sdkInfo = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getSdkMetadataForEnvelopeHeader */ .HY)(metadata);
    var envelopeHeaders = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dsnToString */ .RA)(dsn)
    });
    var envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .createEnvelope */ .Jd)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function createEventEnvelope(event, dsn, metadata, tunnel) {
    var sdkInfo = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .getSdkMetadataForEnvelopeHeader */ .HY)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ var eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    var envelopeHeaders = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .createEventEnvelopeHeaders */ .Cd)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    var eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .createEnvelope */ .Jd)(envelopeHeaders, [
        eventItem
    ]);
}
 //# sourceMappingURL=envelope.js.map


/***/ }),

/***/ 62909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M5": function() { return /* binding */ addIntegration; },
/* harmony export */   "RN": function() { return /* binding */ convertIntegrationFnToClass; },
/* harmony export */   "_I": function() { return /* binding */ defineIntegration; },
/* harmony export */   "m7": function() { return /* binding */ setupIntegration; },
/* harmony export */   "m8": function() { return /* binding */ getIntegrationsToSetup; },
/* harmony export */   "q4": function() { return /* binding */ setupIntegrations; },
/* harmony export */   "uf": function() { return /* binding */ afterSetupIntegrations; }
/* harmony export */ });
/* unused harmony export installedIntegrations */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36305);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11591);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92957);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80107);
/* harmony import */ var _eventProcessors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38126);
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77668);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19217);







var installedIntegrations = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function filterDuplicates(integrations) {
    var integrationsByName = {};
    integrations.forEach(function(currentInstance) {
        var name = currentInstance.name;
        var existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
            return;
        }
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map(function(k) {
        return integrationsByName[k];
    });
}
/** Gets integrations to install */ function getIntegrationsToSetup(options) {
    var defaultIntegrations = options.defaultIntegrations || [];
    var userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach(function(integration) {
        integration.isDefaultInstance = true;
    });
    var integrations;
    if (Array.isArray(userIntegrations)) {
        integrations = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(defaultIntegrations).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(userIntegrations));
    } else if (typeof userIntegrations === "function") {
        integrations = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .arrayify */ .lE)(userIntegrations(defaultIntegrations));
    } else {
        integrations = defaultIntegrations;
    }
    var finalIntegrations = filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    var debugIndex = findIndex(finalIntegrations, function(integration) {
        return integration.name === "Debug";
    });
    if (debugIndex !== -1) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(finalIntegrations.splice(debugIndex, 1), 1), debugInstance = ref[0];
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function setupIntegrations(client, integrations) {
    var integrationIndex = {};
    integrations.forEach(function(integration) {
        // guard against empty provided integrations
        if (integration) {
            setupIntegration(client, integration, integrationIndex);
        }
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function afterSetupIntegrations(client, integrations) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = integrations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var integration = _step.value;
            // guard against empty provided integrations
            if (integration && integration.afterAllSetup) {
                integration.afterAllSetup(client);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/** Setup a single integration.  */ function setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log("Integration skipped because it was already installed: ".concat(integration.name));
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if (installedIntegrations.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce(_eventProcessors_js__WEBPACK_IMPORTED_MODULE_5__/* .addGlobalEventProcessor */ .cc, _hub_js__WEBPACK_IMPORTED_MODULE_6__/* .getCurrentHub */ .Gd);
        installedIntegrations.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") {
        integration.setup(client);
    }
    if (client.on && typeof integration.preprocessEvent === "function") {
        var callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", function(event, hint) {
            return callback(event, hint, client);
        });
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        var callback1 = integration.processEvent.bind(integration);
        var processor = Object.assign(function(event, hint) {
            return callback1(event, hint, client);
        }, {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log("Integration installed: ".concat(integration.name));
}
/** Add an integration to the current hub's client. */ function addIntegration(integration) {
    var client = (0,_exports_js__WEBPACK_IMPORTED_MODULE_7__/* .getClient */ .s3)();
    if (!client || !client.addIntegration) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_3__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.warn */ .kg.warn('Cannot add integration "'.concat(integration.name, '" because no SDK Client is available.'));
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function findIndex(arr, callback) {
    for(var i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) {
            return i;
        }
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function convertIntegrationFnToClass(name, fn) {
    return Object.assign(function ConvertedIntegration() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return fn.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(args));
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function defineIntegration(fn) {
    return fn;
}
 //# sourceMappingURL=integration.js.map


/***/ }),

/***/ 97936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ functionToStringIntegration; },
/* harmony export */   "c": function() { return /* binding */ FunctionToString; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27389);
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77668);
/* harmony import */ var _integration_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62909);



var originalFunctionToString;
var INTEGRATION_NAME = "FunctionToString";
var SETUP_CLIENTS = new WeakMap();
var _functionToStringIntegration = function() {
    return {
        name: INTEGRATION_NAME,
        setupOnce: function setupOnce() {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var originalFunction = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getOriginalFunction */ .HK)(this);
                    var context = SETUP_CLIENTS.has((0,_exports_js__WEBPACK_IMPORTED_MODULE_1__/* .getClient */ .s3)()) && originalFunction !== undefined ? originalFunction : this;
                    return originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup: function setup(client) {
            SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ var functionToStringIntegration = (0,_integration_js__WEBPACK_IMPORTED_MODULE_2__/* .defineIntegration */ ._I)(_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var FunctionToString = (0,_integration_js__WEBPACK_IMPORTED_MODULE_2__/* .convertIntegrationFnToClass */ .RN)(INTEGRATION_NAME, functionToStringIntegration);
// eslint-disable-next-line deprecation/deprecation
 //# sourceMappingURL=functiontostring.js.map


/***/ }),

/***/ 22283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ InboundFilters; },
/* harmony export */   "S": function() { return /* binding */ inboundFiltersIntegration; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92957);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11591);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68813);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80107);
/* harmony import */ var _integration_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62909);




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/, 
];
var DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/, 
];
/** Options for the InboundFilters integration */ var INTEGRATION_NAME = "InboundFilters";
var _inboundFiltersIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        processEvent: function processEvent(event, _hint, client) {
            var clientOptions = client.getOptions();
            var mergedOptions = _mergeOptions(options, clientOptions);
            return _shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
var inboundFiltersIntegration = (0,_integration_js__WEBPACK_IMPORTED_MODULE_0__/* .defineIntegration */ ._I)(_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var InboundFilters = (0,_integration_js__WEBPACK_IMPORTED_MODULE_0__/* .convertIntegrationFnToClass */ .RN)(INTEGRATION_NAME, inboundFiltersIntegration);
function _mergeOptions() {
    var internalOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, clientOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        allowUrls: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(internalOptions.allowUrls || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(clientOptions.allowUrls || [])),
        denyUrls: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(internalOptions.denyUrls || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(clientOptions.denyUrls || [])),
        ignoreErrors: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(internalOptions.ignoreErrors || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(clientOptions.ignoreErrors || []), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS)),
        ignoreTransactions: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(internalOptions.ignoreTransactions || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(clientOptions.ignoreTransactions || []), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(internalOptions.disableTransactionDefaults ? [] : DEFAULT_IGNORE_TRANSACTIONS)),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function _shouldDropEvent(event, options) {
    if (options.ignoreInternal && _isSentryError(event)) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn("Event dropped due to being internal Sentry Error.\nEvent: ".concat((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getEventDescription */ .jH)(event)));
        return true;
    }
    if (_isIgnoredError(event, options.ignoreErrors)) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: ".concat((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getEventDescription */ .jH)(event)));
        return true;
    }
    if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn("Event dropped due to being matched by `ignoreTransactions` option.\nEvent: ".concat((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getEventDescription */ .jH)(event)));
        return true;
    }
    if (_isDeniedUrl(event, options.denyUrls)) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: ".concat((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getEventDescription */ .jH)(event), ".\nUrl: ").concat(_getEventFilterUrl(event)));
        return true;
    }
    if (!_isAllowedUrl(event, options.allowUrls)) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: ".concat((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getEventDescription */ .jH)(event), ".\nUrl: ").concat(_getEventFilterUrl(event)));
        return true;
    }
    return false;
}
function _isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) {
        return false;
    }
    return _getPossibleEventMessages(event).some(function(message) {
        return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .stringMatchesSomePattern */ .U0)(message, ignoreErrors);
    });
}
function _isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) {
        return false;
    }
    var name = event.transaction;
    return name ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .stringMatchesSomePattern */ .U0)(name, ignoreTransactions) : false;
}
function _isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) {
        return false;
    }
    var url = _getEventFilterUrl(event);
    return !url ? false : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .stringMatchesSomePattern */ .U0)(url, denyUrls);
}
function _isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) {
        return true;
    }
    var url = _getEventFilterUrl(event);
    return !url ? true : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .stringMatchesSomePattern */ .U0)(url, allowUrls);
}
function _getPossibleEventMessages(event) {
    var possibleMessages = [];
    if (event.message) {
        possibleMessages.push(event.message);
    }
    var lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) {
                possibleMessages.push("".concat(lastException.type, ": ").concat(lastException.value));
            }
        }
    }
    if (_debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && possibleMessages.length === 0) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.error */ .kg.error("Could not extract message for event ".concat((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getEventDescription */ .jH)(event)));
    }
    return possibleMessages;
}
function _isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function _getLastValidUrl() {
    var frames = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") {
            return frame.filename || null;
        }
    }
    return null;
}
function _getEventFilterUrl(event) {
    try {
        var frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? _getLastValidUrl(frames) : null;
    } catch (oO) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.error */ .kg.error("Cannot extract url for event ".concat((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .getEventDescription */ .jH)(event)));
        return null;
    }
}
 //# sourceMappingURL=inboundfilters.js.map


/***/ }),

/***/ 30268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ updateMetricSummaryOnActiveSpan; },
/* harmony export */   "y": function() { return /* binding */ getMetricSummaryJsonForSpan; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10253);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27389);
/* harmony import */ var _tracing_trace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19381);






/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ var SPAN_METRIC_SUMMARY;
function getMetricStorageForSpan(span) {
    return SPAN_METRIC_SUMMARY ? SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function getMetricSummaryJsonForSpan(span) {
    var storage = getMetricStorageForSpan(span);
    if (!storage) {
        return undefined;
    }
    var output = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = storage[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_step.value, 2), ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_value[1], 2), exportKey = ref[0], summary = ref[1];
            if (!output[exportKey]) {
                output[exportKey] = [];
            }
            output[exportKey].push((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .dropUndefinedKeys */ .Jr)(summary));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function updateMetricSummaryOnActiveSpan(metricType, sanitizedName, value, unit, tags, bucketKey) {
    var span = (0,_tracing_trace_js__WEBPACK_IMPORTED_MODULE_2__/* .getActiveSpan */ .HN)();
    if (span) {
        var storage = getMetricStorageForSpan(span) || new Map();
        var exportKey = "".concat(metricType, ":").concat(sanitizedName, "@").concat(unit);
        var bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            var _bucketItem = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(bucketItem, 2), summary = _bucketItem[1];
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }, 
            ]);
        } else {
            storage.set(bucketKey, [
                exportKey,
                {
                    min: value,
                    max: value,
                    count: 1,
                    sum: value,
                    tags: tags
                }, 
            ]);
        }
        if (!SPAN_METRIC_SUMMARY) {
            SPAN_METRIC_SUMMARY = new WeakMap();
        }
        SPAN_METRIC_SUMMARY.set(span, storage);
    }
}
 //# sourceMappingURL=metric-summary.js.map


/***/ }),

/***/ 8168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bg": function() { return /* binding */ sanitizeTags; },
/* harmony export */   "Ic": function() { return /* binding */ getBucketKey; },
/* harmony export */   "M": function() { return /* binding */ simpleHash; },
/* harmony export */   "OC": function() { return /* binding */ sanitizeUnit; },
/* harmony export */   "s3": function() { return /* binding */ sanitizeMetricKey; },
/* harmony export */   "uv": function() { return /* binding */ serializeMetricBuckets; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27389);



/**
 * Generate bucket key from metric properties.
 */ function getBucketKey(metricType, name, unit, tags) {
    var stringifiedTags = Object.entries((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)(tags)).sort(function(a, b) {
        return a[0].localeCompare(b[0]);
    });
    return "".concat(metricType).concat(name).concat(unit).concat(stringifiedTags);
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function simpleHash(s) {
    var rv = 0;
    for(var i = 0; i < s.length; i++){
        var c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function serializeMetricBuckets(metricBucketItems) {
    var out = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = metricBucketItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var tagEntries = Object.entries(item.tags);
            var maybeTags = tagEntries.length > 0 ? "|#".concat(tagEntries.map(function(param) {
                var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
                return "".concat(key, ":").concat(value);
            }).join(",")) : "";
            out += "".concat(item.name, "@").concat(item.unit, ":").concat(item.metric, "|").concat(item.metricType).concat(maybeTags, "|T").concat(item.timestamp, "\n");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return out;
}
/** Sanitizes units */ function sanitizeUnit(unit) {
    return unit.replace(/[^\w]+/gi, "_");
}
/** Sanitizes metric keys */ function sanitizeMetricKey(key) {
    return key.replace(/[^\w\-.]+/gi, "_");
}
function sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, "");
}
var tagValueReplacements = [
    [
        "\n",
        "\\n"
    ],
    [
        "\r",
        "\\r"
    ],
    [
        "	",
        "\\t"
    ],
    [
        "\\",
        "\\\\"
    ],
    [
        "|",
        "\\u{7c}"
    ],
    [
        ",",
        "\\u{2c}"
    ], 
];
function getCharOrReplacement(input) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = tagValueReplacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_step.value, 2), search = _value[0], replacement = _value[1];
            if (input === search) {
                return replacement;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return input;
}
function sanitizeTagValue(value) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(value).reduce(function(acc, char) {
        return acc + getCharOrReplacement(char);
    }, "");
}
/**
 * Sanitizes tags.
 */ function sanitizeTags(unsanitizedTags) {
    var tags = {};
    for(var key in unsanitizedTags){
        if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
            var sanitizedKey = sanitizeTagKey(key);
            tags[sanitizedKey] = sanitizeTagValue(String(unsanitizedTags[key]));
        }
    }
    return tags;
}
 //# sourceMappingURL=utils.js.map


/***/ }),

/***/ 83283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ setCurrentClient; },
/* harmony export */   "M": function() { return /* binding */ initAndBind; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92957);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80107);
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77668);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19217);




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function initAndBind(clientClass, options) {
    if (options.debug === true) {
        if (_debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X) {
            _sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .logger.enable */ .kg.enable();
        } else {
            // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
            (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .consoleSandbox */ .Cf)(function() {
                // eslint-disable-next-line no-console
                console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
            });
        }
    }
    var scope = (0,_exports_js__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentScope */ .nZ)();
    scope.update(options.initialScope);
    var client = new clientClass(options);
    setCurrentClient(client);
    initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function setCurrentClient(client) {
    // eslint-disable-next-line deprecation/deprecation
    var hub = (0,_hub_js__WEBPACK_IMPORTED_MODULE_3__/* .getCurrentHub */ .Gd)();
    // eslint-disable-next-line deprecation/deprecation
    var top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function initializeClient(client) {
    if (client.init) {
        client.init();
    // TODO v8: Remove this fallback
    // eslint-disable-next-line deprecation/deprecation
    } else if (client.setupIntegrations) {
        // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
}
 //# sourceMappingURL=sdk.js.map


/***/ }),

/***/ 91292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$J": function() { return /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_OP; },
/* harmony export */   "S3": function() { return /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN; },
/* harmony export */   "TE": function() { return /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE; },
/* harmony export */   "Zj": function() { return /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_SOURCE; },
/* harmony export */   "p6": function() { return /* binding */ SEMANTIC_ATTRIBUTE_PROFILE_ID; }
/* harmony export */ });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ var SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
/**
 * The id of the profile that this span occured in.
 */ var SEMANTIC_ATTRIBUTE_PROFILE_ID = "profile_id";
 //# sourceMappingURL=semanticAttributes.js.map


/***/ }),

/***/ 97576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ addTracingExtensions; },
  "l": function() { return /* binding */ startIdleTransaction; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(92957);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/debug-build.js
var debug_build = __webpack_require__(80107);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(19217);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(76190);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument/globalError.js
var globalError = __webpack_require__(62869);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument/globalUnhandledRejection.js
var globalUnhandledRejection = __webpack_require__(25534);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/utils.js
var utils = __webpack_require__(4124);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/errors.js



var errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function registerErrorInstrumentation() {
    if (errorsInstrumented) {
        return;
    }
    errorsInstrumented = true;
    (0,globalError/* addGlobalErrorInstrumentationHandler */.V)(errorCallback);
    (0,globalUnhandledRejection/* addGlobalUnhandledRejectionInstrumentationHandler */.h)(errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
    if (activeTransaction) {
        var status = "internal_error";
        debug_build/* DEBUG_BUILD */.X && logger/* logger.log */.kg.log("[Tracing] Transaction: ".concat(status, " -> Global error occured"));
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
errorCallback.tag = "sentry_tracingErrorCallback";
 //# sourceMappingURL=errors.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/idletransaction.js
var idletransaction = __webpack_require__(14483);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/sampling.js
var sampling = __webpack_require__(4249);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/transaction.js
var tracing_transaction = __webpack_require__(365);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/tracing/hubextensions.js









/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    var scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    var span = scope.getSpan();
    return span ? {
        "sentry-trace": (0,spanUtils/* spanToTraceHeader */.Hb)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function _startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    var client = this.getClient();
    var options = client && client.getOptions() || {};
    var configInstrumenter = options.instrumenter || "sentry";
    var transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error("A transaction was started with instrumenter=`".concat(transactionInstrumenter, "`, but the SDK is configured with the `").concat(configInstrumenter, "` instrumenter.\nThe transaction will not be sampled. Please use the ").concat(configInstrumenter, " instrumentation to start transactions."));
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    var transaction = new tracing_transaction/* Transaction */.Y(transactionContext, this);
    transaction = (0,sampling/* sampleTransaction */.f)(transaction, options, (0,_object_spread/* default */.Z)({
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: (0,_object_spread/* default */.Z)({}, transactionContext.data, transactionContext.attributes)
    }, customSamplingContext));
    if (transaction.isRecording()) {
        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    }
    if (client && client.emit) {
        client.emit("startTransaction", transaction);
    }
    return transaction;
}
/**
 * Create new idle transaction.
 */ function startIdleTransaction(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval) {
    var delayAutoFinishUntilSignal = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    // eslint-disable-next-line deprecation/deprecation
    var client = hub.getClient();
    var options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    var transaction = new idletransaction/* IdleTransaction */.io(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0,sampling/* sampleTransaction */.f)(transaction, options, (0,_object_spread/* default */.Z)({
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: (0,_object_spread/* default */.Z)({}, transactionContext.data, transactionContext.attributes)
    }, customSamplingContext));
    if (transaction.isRecording()) {
        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    }
    if (client && client.emit) {
        client.emit("startTransaction", transaction);
    }
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function addTracingExtensions() {
    var carrier = (0,hub/* getMainCarrier */.cu)();
    if (!carrier.__SENTRY__) {
        return;
    }
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) {
        carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
    }
    if (!carrier.__SENTRY__.extensions.traceHeaders) {
        carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
    }
    registerErrorInstrumentation();
}
 //# sourceMappingURL=hubextensions.js.map


/***/ }),

/***/ 14483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AT": function() { return /* binding */ TRACING_DEFAULTS; },
/* harmony export */   "io": function() { return /* binding */ IdleTransaction; }
/* harmony export */ });
/* unused harmony export IdleTransactionSpanRecorder */
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_get_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45785);
/* harmony import */ var _swc_helpers_src_get_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82662);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71418);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92957);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96233);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80107);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76190);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95293);
/* harmony import */ var _transaction_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(365);












var TRACING_DEFAULTS = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
var FINISH_REASON_TAG = "finishReason";
var IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled", 
];
/**
 * @inheritDoc
 */ var IdleTransactionSpanRecorder = /*#__PURE__*/ function(SpanRecorder) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(IdleTransactionSpanRecorder, SpanRecorder);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(IdleTransactionSpanRecorder);
    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, IdleTransactionSpanRecorder);
        var _this;
        _this = _super.call(this, maxlen);
        _this._pushActivity = _pushActivity;
        _this._popActivity = _popActivity;
        _this.transactionSpanId = transactionSpanId;
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(IdleTransactionSpanRecorder, [
        {
            /**
   * @inheritDoc
   */ key: "add",
            value: function add(span) {
                var _this = this;
                // We should make sure we do not push and pop activities for
                // the transaction that this span recorder belongs to.
                if (span.spanContext().spanId !== this.transactionSpanId) {
                    // We patch span.end() to pop an activity after setting an endTimestamp.
                    // eslint-disable-next-line @typescript-eslint/unbound-method
                    var originalEnd = span.end;
                    span.end = function() {
                        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
                            rest[_key] = arguments[_key];
                        }
                        _this._popActivity(span.spanContext().spanId);
                        return originalEnd.apply(span, rest);
                    };
                    // We should only push new activities if the span does not have an end timestamp.
                    if ((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_4__/* .spanToJSON */ .XU)(span).timestamp === undefined) {
                        this._pushActivity(span.spanContext().spanId);
                    }
                }
                (0,_swc_helpers_src_get_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_get_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(IdleTransactionSpanRecorder.prototype), "add", this).call(this, span);
            }
        }
    ]);
    return IdleTransactionSpanRecorder;
}(_span_js__WEBPACK_IMPORTED_MODULE_7__/* .SpanRecorder */ .g);
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ var IdleTransaction = /*#__PURE__*/ function(Transaction) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(IdleTransaction, Transaction);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(IdleTransaction);
    function IdleTransaction(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub) {
        var /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : TRACING_DEFAULTS.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : TRACING_DEFAULTS.finalTimeout, _heartbeatInterval = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : TRACING_DEFAULTS.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
        _onScope = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, IdleTransaction);
        var _this;
        _this = _super.call(this, transactionContext, _idleHub);
        _this._idleHub = _idleHub;
        _this._idleTimeout = _idleTimeout;
        _this._finalTimeout = _finalTimeout;
        _this._heartbeatInterval = _heartbeatInterval;
        _this._onScope = _onScope;
        _this.activities = {};
        _this._heartbeatCounter = 0;
        _this._finished = false;
        _this._idleTimeoutCanceledPermanently = false;
        _this._beforeFinishCallbacks = [];
        _this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[4];
        _this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            _debug_build_js__WEBPACK_IMPORTED_MODULE_8__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.log */ .kg.log("Setting idle transaction on scope. Span ID: ".concat(_this.spanContext().spanId));
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_this));
        }
        if (!delayAutoFinishUntilSignal) {
            _this._restartIdleTimeout();
        }
        setTimeout(function() {
            if (!_this._finished) {
                _this.setStatus("deadline_exceeded");
                _this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[3];
                _this.end();
            }
        }, _this._finalTimeout);
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(IdleTransaction, [
        {
            /** {@inheritDoc} */ key: "end",
            value: function end(endTimestamp) {
                var _this = this;
                var endTimestampInS = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_4__/* .spanTimeInputToSeconds */ .$k)(endTimestamp);
                this._finished = true;
                this.activities = {};
                // eslint-disable-next-line deprecation/deprecation
                if (this.op === "ui.action.click") {
                    this.setAttribute(FINISH_REASON_TAG, this._finishReason);
                }
                // eslint-disable-next-line deprecation/deprecation
                if (this.spanRecorder) {
                    _debug_build_js__WEBPACK_IMPORTED_MODULE_8__/* .DEBUG_BUILD */ .X && // eslint-disable-next-line deprecation/deprecation
                    _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.log */ .kg.log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this._beforeFinishCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var callback = _step.value;
                            callback(this, endTimestampInS);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // eslint-disable-next-line deprecation/deprecation
                    this.spanRecorder.spans = this.spanRecorder.spans.filter(function(span) {
                        // If we are dealing with the transaction itself, we just return it
                        if (span.spanContext().spanId === _this.spanContext().spanId) {
                            return true;
                        }
                        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                        if (!(0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_4__/* .spanToJSON */ .XU)(span).timestamp) {
                            span.setStatus("cancelled");
                            span.end(endTimestampInS);
                            _debug_build_js__WEBPACK_IMPORTED_MODULE_8__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.log */ .kg.log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                        }
                        var ref = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_4__/* .spanToJSON */ .XU)(span), startTime = ref.start_timestamp, endTime = ref.timestamp;
                        var spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                        // Add a delta with idle timeout so that we prevent false positives
                        var timeoutWithMarginOfError = (_this._finalTimeout + _this._idleTimeout) / 1000;
                        var spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                        if (_debug_build_js__WEBPACK_IMPORTED_MODULE_8__/* .DEBUG_BUILD */ .X) {
                            var stringifiedSpan = JSON.stringify(span, undefined, 2);
                            if (!spanStartedBeforeTransactionFinish) {
                                _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.log */ .kg.log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                            } else if (!spanEndedBeforeFinalTimeout) {
                                _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.log */ .kg.log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                            }
                        }
                        return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
                    });
                    _debug_build_js__WEBPACK_IMPORTED_MODULE_8__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.log */ .kg.log("[Tracing] flushing IdleTransaction");
                } else {
                    _debug_build_js__WEBPACK_IMPORTED_MODULE_8__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.log */ .kg.log("[Tracing] No active IdleTransaction");
                }
                // if `this._onScope` is `true`, the transaction put itself on the scope when it started
                if (this._onScope) {
                    // eslint-disable-next-line deprecation/deprecation
                    var scope = this._idleHub.getScope();
                    // eslint-disable-next-line deprecation/deprecation
                    if (scope.getTransaction() === this) {
                        // eslint-disable-next-line deprecation/deprecation
                        scope.setSpan(undefined);
                    }
                }
                return (0,_swc_helpers_src_get_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_get_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(IdleTransaction.prototype), "end", this).call(this, endTimestamp);
            }
        },
        {
            /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ key: "registerBeforeFinishCallback",
            value: function registerBeforeFinishCallback(callback) {
                this._beforeFinishCallbacks.push(callback);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "initSpanRecorder",
            value: function initSpanRecorder(maxlen) {
                var _this = this;
                // eslint-disable-next-line deprecation/deprecation
                if (!this.spanRecorder) {
                    var pushActivity = function(id) {
                        if (_this._finished) {
                            return;
                        }
                        _this._pushActivity(id);
                    };
                    var popActivity = function(id) {
                        if (_this._finished) {
                            return;
                        }
                        _this._popActivity(id);
                    };
                    // eslint-disable-next-line deprecation/deprecation
                    this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanContext().spanId, maxlen);
                    // Start heartbeat so that transactions do not run forever.
                    _debug_build_js__WEBPACK_IMPORTED_MODULE_8__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.log */ .kg.log("Starting heartbeat");
                    this._pingHeartbeat();
                }
                // eslint-disable-next-line deprecation/deprecation
                this.spanRecorder.add(this);
            }
        },
        {
            /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ key: "cancelIdleTimeout",
            value: function cancelIdleTimeout(endTimestamp) {
                var restartOnChildSpanChange = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                    restartOnChildSpanChange: true
                }).restartOnChildSpanChange;
                this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
                if (this._idleTimeoutID) {
                    clearTimeout(this._idleTimeoutID);
                    this._idleTimeoutID = undefined;
                    if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
                        this.end(endTimestamp);
                    }
                }
            }
        },
        {
            /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ key: "setFinishReason",
            value: function setFinishReason(reason) {
                this._finishReason = reason;
            }
        },
        {
            /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ key: "sendAutoFinishSignal",
            value: function sendAutoFinishSignal() {
                if (!this._autoFinishAllowed) {
                    _debug_build_js__WEBPACK_IMPORTED_MODULE_8__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.log */ .kg.log("[Tracing] Received finish signal for idle transaction.");
                    this._restartIdleTimeout();
                    this._autoFinishAllowed = true;
                }
            }
        },
        {
            /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ key: "_restartIdleTimeout",
            value: function _restartIdleTimeout(endTimestamp) {
                var _this = this;
                this.cancelIdleTimeout();
                this._idleTimeoutID = setTimeout(function() {
                    if (!_this._finished && Object.keys(_this.activities).length === 0) {
                        _this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[1];
                        _this.end(endTimestamp);
                    }
                }, this._idleTimeout);
            }
        },
        {
            /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ key: "_pushActivity",
            value: function _pushActivity(spanId) {
                this.cancelIdleTimeout(undefined, {
                    restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
                });
                _debug_build_js__WEBPACK_IMPORTED_MODULE_8__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.log */ .kg.log("[Tracing] pushActivity: ".concat(spanId));
                this.activities[spanId] = true;
                _debug_build_js__WEBPACK_IMPORTED_MODULE_8__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.log */ .kg.log("[Tracing] new activities count", Object.keys(this.activities).length);
            }
        },
        {
            /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ key: "_popActivity",
            value: function _popActivity(spanId) {
                if (this.activities[spanId]) {
                    _debug_build_js__WEBPACK_IMPORTED_MODULE_8__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.log */ .kg.log("[Tracing] popActivity ".concat(spanId));
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this.activities[spanId];
                    _debug_build_js__WEBPACK_IMPORTED_MODULE_8__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.log */ .kg.log("[Tracing] new activities count", Object.keys(this.activities).length);
                }
                if (Object.keys(this.activities).length === 0) {
                    var endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .timestampInSeconds */ .ph)();
                    if (this._idleTimeoutCanceledPermanently) {
                        if (this._autoFinishAllowed) {
                            this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
                            this.end(endTimestamp);
                        }
                    } else {
                        // We need to add the timeout here to have the real endtimestamp of the transaction
                        // Remember timestampInSeconds is in seconds, timeout is in ms
                        this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
                    }
                }
            }
        },
        {
            /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ key: "_beat",
            value: function _beat() {
                // We should not be running heartbeat if the idle transaction is finished.
                if (this._finished) {
                    return;
                }
                var heartbeatString = Object.keys(this.activities).join("");
                if (heartbeatString === this._prevHeartbeatString) {
                    this._heartbeatCounter++;
                } else {
                    this._heartbeatCounter = 1;
                }
                this._prevHeartbeatString = heartbeatString;
                if (this._heartbeatCounter >= 3) {
                    if (this._autoFinishAllowed) {
                        _debug_build_js__WEBPACK_IMPORTED_MODULE_8__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.log */ .kg.log("[Tracing] Transaction finished because of no change for 3 heart beats");
                        this.setStatus("deadline_exceeded");
                        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[0];
                        this.end();
                    }
                } else {
                    this._pingHeartbeat();
                }
            }
        },
        {
            /**
   * Pings the heartbeat
   */ key: "_pingHeartbeat",
            value: function _pingHeartbeat() {
                var _this = this;
                _debug_build_js__WEBPACK_IMPORTED_MODULE_8__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .logger.log */ .kg.log("pinging Heartbeat -> current counter: ".concat(this._heartbeatCounter));
                setTimeout(function() {
                    _this._beat();
                }, this._heartbeatInterval);
            }
        }
    ]);
    return IdleTransaction;
}(_transaction_js__WEBPACK_IMPORTED_MODULE_12__/* .Transaction */ .Y);
 //# sourceMappingURL=idletransaction.js.map


/***/ }),

/***/ 99770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ setMeasurement; }
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4124);

/**
 * Adds a measurement to the current active transaction.
 */ function setMeasurement(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    var transaction = (0,_utils_js__WEBPACK_IMPORTED_MODULE_0__/* .getActiveTransaction */ .x1)();
    if (transaction) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setMeasurement(name, value, unit);
    }
}
 //# sourceMappingURL=measurement.js.map


/***/ }),

/***/ 4249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ isValidSampleRate; },
/* harmony export */   "f": function() { return /* binding */ sampleTransaction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82222);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92957);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74020);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80107);
/* harmony import */ var _semanticAttributes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91292);
/* harmony import */ var _utils_hasTracingEnabled_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67007);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76190);






/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function sampleTransaction(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0,_utils_hasTracingEnabled_js__WEBPACK_IMPORTED_MODULE_0__/* .hasTracingEnabled */ .z)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute(_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_1__/* .SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */ .TE, Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    var sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute(_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_1__/* .SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */ .TE, Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) {
        sampleRate = samplingContext.parentSampled;
    } else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute(_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_1__/* .SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */ .TE, Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute(_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_1__/* .SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */ .TE, sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(sampleRate)) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log("[Tracing] Discarding transaction because ".concat(typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"));
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ".concat(Number(sampleRate), ")"));
        return transaction;
    }
    _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && // eslint-disable-next-line deprecation/deprecation
    _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log("[Tracing] starting ".concat(transaction.op, " transaction - ").concat((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_4__/* .spanToJSON */ .XU)(transaction).description));
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .isNaN */ .i2)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ".concat(JSON.stringify(rate), " of type ").concat(JSON.stringify(typeof rate === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(rate)), "."));
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ".concat(rate, "."));
        return false;
    }
    return true;
}
 //# sourceMappingURL=sampling.js.map


/***/ }),

/***/ 95293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Span; },
/* harmony export */   "g": function() { return /* binding */ SpanRecorder; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11591);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96233);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92957);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27389);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80107);
/* harmony import */ var _metrics_metric_summary_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(30268);
/* harmony import */ var _semanticAttributes_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91292);
/* harmony import */ var _utils_getRootSpan_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27606);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76190);
/* harmony import */ var _spanstatus_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86912);












/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ var SpanRecorder = /*#__PURE__*/ function() {
    "use strict";
    function SpanRecorder() {
        var maxlen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, SpanRecorder);
        this._maxlen = maxlen;
        this.spans = [];
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(SpanRecorder, [
        {
            /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ key: "add",
            value: function add(span) {
                if (this.spans.length > this._maxlen) {
                    // eslint-disable-next-line deprecation/deprecation
                    span.spanRecorder = undefined;
                } else {
                    this.spans.push(span);
                }
            }
        }
    ]);
    return SpanRecorder;
}();
/**
 * Span contains all data about a span
 */ var Span = /*#__PURE__*/ function() {
    "use strict";
    function Span() {
        var spanContext = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Span);
        this._traceId = spanContext.traceId || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .uuid4 */ .DM)();
        this._spanId = spanContext.spanId || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .uuid4 */ .DM)().substring(16);
        this._startTime = spanContext.startTimestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .timestampInSeconds */ .ph)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, spanContext.tags) : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, spanContext.data) : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this._attributes = {};
        var _obj;
        this.setAttributes((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _semanticAttributes_js__WEBPACK_IMPORTED_MODULE_6__/* .SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */ .S3, spanContext.origin || "manual"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _semanticAttributes_js__WEBPACK_IMPORTED_MODULE_6__/* .SEMANTIC_ATTRIBUTE_SENTRY_OP */ .$J, spanContext.op), _obj), spanContext.attributes));
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) {
            this._parentSpanId = spanContext.parentSpanId;
        }
        // We want to include booleans as well here
        if ("sampled" in spanContext) {
            this._sampled = spanContext.sampled;
        }
        if (spanContext.status) {
            this._status = spanContext.status;
        }
        if (spanContext.endTimestamp) {
            this._endTime = spanContext.endTimestamp;
        }
        if (spanContext.exclusiveTime !== undefined) {
            this._exclusiveTime = spanContext.exclusiveTime;
        }
        this._measurements = spanContext.measurements ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, spanContext.measurements) : {};
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Span, [
        {
            key: "name",
            get: // This rule conflicts with another eslint rule :(
            /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function get() {
                return this._name || "";
            },
            set: /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function set(name) {
                this.updateName(name);
            }
        },
        {
            key: "description",
            get: /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function get() {
                return this._name;
            },
            set: /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function set(description) {
                this._name = description;
            }
        },
        {
            key: "traceId",
            get: /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ function get() {
                return this._traceId;
            },
            set: /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ function set(traceId) {
                this._traceId = traceId;
            }
        },
        {
            key: "spanId",
            get: /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ function get() {
                return this._spanId;
            },
            set: /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ function set(spanId) {
                this._spanId = spanId;
            }
        },
        {
            key: "parentSpanId",
            get: /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ function get() {
                return this._parentSpanId;
            },
            set: /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ function set(string) {
                this._parentSpanId = string;
            }
        },
        {
            key: "sampled",
            get: /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ function get() {
                return this._sampled;
            },
            set: /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ function set(sampled) {
                this._sampled = sampled;
            }
        },
        {
            key: "attributes",
            get: /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ function get() {
                return this._attributes;
            },
            set: /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ function set(attributes) {
                this._attributes = attributes;
            }
        },
        {
            key: "startTimestamp",
            get: /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ function get() {
                return this._startTime;
            },
            set: /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ function set(startTime) {
                this._startTime = startTime;
            }
        },
        {
            key: "endTimestamp",
            get: /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ function get() {
                return this._endTime;
            },
            set: /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ function set(endTime) {
                this._endTime = endTime;
            }
        },
        {
            key: "status",
            get: /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ function get() {
                return this._status;
            },
            set: /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ function set(status) {
                this._status = status;
            }
        },
        {
            key: "op",
            get: /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ function get() {
                return this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_6__/* .SEMANTIC_ATTRIBUTE_SENTRY_OP */ .$J];
            },
            set: /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ function set(op) {
                this.setAttribute(_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_6__/* .SEMANTIC_ATTRIBUTE_SENTRY_OP */ .$J, op);
            }
        },
        {
            key: "origin",
            get: /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ function get() {
                return this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_6__/* .SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */ .S3];
            },
            set: /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ function set(origin) {
                this.setAttribute(_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_6__/* .SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */ .S3, origin);
            }
        },
        {
            /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ key: "spanContext",
            value: function spanContext() {
                var ref = this, spanId = ref._spanId, traceId = ref._traceId, sampled = ref._sampled;
                return {
                    spanId: spanId,
                    traceId: traceId,
                    traceFlags: sampled ? _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .TRACE_FLAG_SAMPLED */ .i0 : _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .TRACE_FLAG_NONE */ .ve
                };
            }
        },
        {
            /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ key: "startChild",
            value: function startChild(spanContext) {
                var childSpan = new Span((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, spanContext), {
                    parentSpanId: this._spanId,
                    sampled: this._sampled,
                    traceId: this._traceId
                }));
                // eslint-disable-next-line deprecation/deprecation
                childSpan.spanRecorder = this.spanRecorder;
                // eslint-disable-next-line deprecation/deprecation
                if (childSpan.spanRecorder) {
                    // eslint-disable-next-line deprecation/deprecation
                    childSpan.spanRecorder.add(childSpan);
                }
                var rootSpan = (0,_utils_getRootSpan_js__WEBPACK_IMPORTED_MODULE_9__/* .getRootSpan */ .G)(this);
                // TODO: still set span.transaction here until we have a more permanent solution
                // Probably similarly to the weakmap we hold in node-experimental
                // eslint-disable-next-line deprecation/deprecation
                childSpan.transaction = rootSpan;
                if (_debug_build_js__WEBPACK_IMPORTED_MODULE_10__/* .DEBUG_BUILD */ .X && rootSpan) {
                    var opStr = spanContext && spanContext.op || "< unknown op >";
                    var nameStr = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .spanToJSON */ .XU)(childSpan).description || "< unknown name >";
                    var idStr = rootSpan.spanContext().spanId;
                    var logMessage = "[Tracing] Starting '".concat(opStr, "' span on transaction '").concat(nameStr, "' (").concat(idStr, ").");
                    _sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .logger.log */ .kg.log(logMessage);
                    this._logMessage = logMessage;
                }
                return childSpan;
            }
        },
        {
            /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ key: "setTag",
            value: function setTag(key, value) {
                // eslint-disable-next-line deprecation/deprecation
                this.tags = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, this.tags), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, key, value));
                return this;
            }
        },
        {
            /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "setData",
            value: function setData(key, value) {
                // eslint-disable-next-line deprecation/deprecation
                this.data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, this.data), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, key, value));
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "setAttribute",
            value: function setAttribute(key, value) {
                if (value === undefined) {
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this._attributes[key];
                } else {
                    this._attributes[key] = value;
                }
            }
        },
        {
            /** @inheritdoc */ key: "setAttributes",
            value: function setAttributes(attributes) {
                var _this = this;
                Object.keys(attributes).forEach(function(key) {
                    return _this.setAttribute(key, attributes[key]);
                });
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setStatus",
            value: function setStatus(value) {
                this._status = value;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ key: "setHttpStatus",
            value: function setHttpStatus1(httpStatus) {
                (0,_spanstatus_js__WEBPACK_IMPORTED_MODULE_12__/* .setHttpStatus */ .Q0)(this, httpStatus);
                return this;
            }
        },
        {
            /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ key: "setName",
            value: function setName(name) {
                this.updateName(name);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "updateName",
            value: function updateName(name) {
                this._name = name;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ key: "isSuccess",
            value: function isSuccess() {
                return this._status === "ok";
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ key: "finish",
            value: function finish(endTimestamp) {
                return this.end(endTimestamp);
            }
        },
        {
            /** @inheritdoc */ key: "end",
            value: function end(endTimestamp) {
                // If already ended, skip
                if (this._endTime) {
                    return;
                }
                var rootSpan = (0,_utils_getRootSpan_js__WEBPACK_IMPORTED_MODULE_9__/* .getRootSpan */ .G)(this);
                if (_debug_build_js__WEBPACK_IMPORTED_MODULE_10__/* .DEBUG_BUILD */ .X && // Don't call this for transactions
                rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
                    var logMessage = this._logMessage;
                    if (logMessage) {
                        _sentry_utils__WEBPACK_IMPORTED_MODULE_11__/* .logger.log */ .kg.log(logMessage.replace("Starting", "Finishing"));
                    }
                }
                this._endTime = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .spanTimeInputToSeconds */ .$k)(endTimestamp);
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ key: "toTraceparent",
            value: function toTraceparent() {
                return (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .spanToTraceHeader */ .Hb)(this);
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ key: "toContext",
            value: function toContext() {
                return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .dropUndefinedKeys */ .Jr)({
                    data: this._getData(),
                    description: this._name,
                    endTimestamp: this._endTime,
                    // eslint-disable-next-line deprecation/deprecation
                    op: this.op,
                    parentSpanId: this._parentSpanId,
                    sampled: this._sampled,
                    spanId: this._spanId,
                    startTimestamp: this._startTime,
                    status: this._status,
                    // eslint-disable-next-line deprecation/deprecation
                    tags: this.tags,
                    traceId: this._traceId
                });
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ key: "updateWithContext",
            value: function updateWithContext(spanContext) {
                // eslint-disable-next-line deprecation/deprecation
                this.data = spanContext.data || {};
                // eslint-disable-next-line deprecation/deprecation
                this._name = spanContext.name || spanContext.description;
                this._endTime = spanContext.endTimestamp;
                // eslint-disable-next-line deprecation/deprecation
                this.op = spanContext.op;
                this._parentSpanId = spanContext.parentSpanId;
                this._sampled = spanContext.sampled;
                this._spanId = spanContext.spanId || this._spanId;
                this._startTime = spanContext.startTimestamp || this._startTime;
                this._status = spanContext.status;
                // eslint-disable-next-line deprecation/deprecation
                this.tags = spanContext.tags || {};
                this._traceId = spanContext.traceId || this._traceId;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ key: "getTraceContext",
            value: function getTraceContext() {
                return (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .spanToTraceContext */ .wy)(this);
            }
        },
        {
            /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ key: "getSpanJSON",
            value: function getSpanJSON() {
                return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_13__/* .dropUndefinedKeys */ .Jr)({
                    data: this._getData(),
                    description: this._name,
                    op: this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_6__/* .SEMANTIC_ATTRIBUTE_SENTRY_OP */ .$J],
                    parent_span_id: this._parentSpanId,
                    span_id: this._spanId,
                    start_timestamp: this._startTime,
                    status: this._status,
                    // eslint-disable-next-line deprecation/deprecation
                    tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
                    timestamp: this._endTime,
                    trace_id: this._traceId,
                    origin: this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_6__/* .SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */ .S3],
                    _metrics_summary: (0,_metrics_metric_summary_js__WEBPACK_IMPORTED_MODULE_14__/* .getMetricSummaryJsonForSpan */ .y)(this),
                    profile_id: this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_6__/* .SEMANTIC_ATTRIBUTE_PROFILE_ID */ .p6],
                    exclusive_time: this._exclusiveTime,
                    measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
                });
            }
        },
        {
            /** @inheritdoc */ key: "isRecording",
            value: function isRecording() {
                return !this._endTime && !!this._sampled;
            }
        },
        {
            /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ key: "toJSON",
            value: function toJSON() {
                return this.getSpanJSON();
            }
        },
        {
            /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ key: "_getData",
            value: function _getData() {
                // eslint-disable-next-line deprecation/deprecation
                var ref = this, data = ref.data, attributes = ref._attributes;
                var hasData = Object.keys(data).length > 0;
                var hasAttributes = Object.keys(attributes).length > 0;
                if (!hasData && !hasAttributes) {
                    return undefined;
                }
                if (hasData && hasAttributes) {
                    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, data, attributes);
                }
                return hasData ? data : attributes;
            }
        }
    ]);
    return Span;
}();
 //# sourceMappingURL=span.js.map


/***/ }),

/***/ 86912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q0": function() { return /* binding */ setHttpStatus; },
/* harmony export */   "Zd": function() { return /* binding */ spanStatusfromHttpCode; },
/* harmony export */   "ix": function() { return /* binding */ getSpanStatusFromHttpCode; }
/* harmony export */ });
/* unused harmony export SpanStatus */
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var SpanStatus;
(function(SpanStatus) {
    /** The operation completed successfully. */ var Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ var DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ var Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ var PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ var NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ var ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ var InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ var Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ var Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ var InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ var UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ var Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ var AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ var FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ var Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ var OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ var DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})(SpanStatus || (SpanStatus = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) {
        return "ok";
    }
    if (httpStatus >= 400 && httpStatus < 500) {
        switch(httpStatus){
            case 401:
                return "unauthenticated";
            case 403:
                return "permission_denied";
            case 404:
                return "not_found";
            case 409:
                return "already_exists";
            case 413:
                return "failed_precondition";
            case 429:
                return "resource_exhausted";
            default:
                return "invalid_argument";
        }
    }
    if (httpStatus >= 500 && httpStatus < 600) {
        switch(httpStatus){
            case 501:
                return "unimplemented";
            case 503:
                return "unavailable";
            case 504:
                return "deadline_exceeded";
            default:
                return "internal_error";
        }
    }
    return "unknown_error";
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ var spanStatusfromHttpCode = getSpanStatusFromHttpCode;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function setHttpStatus(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag("http.status_code", String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData("http.response.status_code", httpStatus);
    var spanStatus = getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus !== "unknown_error") {
        span.setStatus(spanStatus);
    }
}
 //# sourceMappingURL=spanstatus.js.map


/***/ }),

/***/ 19381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GK": function() { return /* binding */ startSpan; },
/* harmony export */   "HN": function() { return /* binding */ getActiveSpan; },
/* harmony export */   "I1": function() { return /* binding */ getCapturedScopesOnSpan; },
/* harmony export */   "V0": function() { return /* binding */ startSpanManual; },
/* harmony export */   "g4": function() { return /* binding */ trace; },
/* harmony export */   "qp": function() { return /* binding */ startInactiveSpan; },
/* harmony export */   "yn": function() { return /* binding */ continueTrace; }
/* harmony export */ });
/* unused harmony export startActiveSpan */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84907);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92957);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27389);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80107);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19217);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76190);
/* harmony import */ var _dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(63055);
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77668);
/* harmony import */ var _utils_handleCallbackErrors_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15968);
/* harmony import */ var _utils_hasTracingEnabled_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67007);












/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function trace(context, callback) {
    var // eslint-disable-next-line @typescript-eslint/no-empty-function
    onError = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {}, // eslint-disable-next-line @typescript-eslint/no-empty-function
    afterFinish = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {};
    // eslint-disable-next-line deprecation/deprecation
    var hub = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
    var scope = (0,_exports_js__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentScope */ .nZ)();
    // eslint-disable-next-line deprecation/deprecation
    var parentSpan = scope.getSpan();
    var spanContext = normalizeContext(context);
    var activeSpan = createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0,_utils_handleCallbackErrors_js__WEBPACK_IMPORTED_MODULE_2__/* .handleCallbackErrors */ .i)(function() {
        return callback(activeSpan);
    }, function(error) {
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, function() {
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function startSpan(context, callback) {
    var spanContext = normalizeContext(context);
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .runWithAsyncContext */ .Ok)(function() {
        return (0,_exports_js__WEBPACK_IMPORTED_MODULE_1__/* .withScope */ .$e)(context.scope, function(scope) {
            // eslint-disable-next-line deprecation/deprecation
            var hub = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
            // eslint-disable-next-line deprecation/deprecation
            var parentSpan = scope.getSpan();
            var shouldSkipSpan = context.onlyIfParent && !parentSpan;
            var activeSpan = shouldSkipSpan ? undefined : createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0,_utils_handleCallbackErrors_js__WEBPACK_IMPORTED_MODULE_2__/* .handleCallbackErrors */ .i)(function() {
                return callback(activeSpan);
            }, function() {
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    var status = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(activeSpan).status;
                    if (!status || status === "ok") {
                        activeSpan.setStatus("internal_error");
                    }
                }
            }, function() {
                return activeSpan && activeSpan.end();
            });
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ var startActiveSpan = (/* unused pure expression or super */ null && (startSpan));
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function startSpanManual(context, callback) {
    var spanContext = normalizeContext(context);
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .runWithAsyncContext */ .Ok)(function() {
        return (0,_exports_js__WEBPACK_IMPORTED_MODULE_1__/* .withScope */ .$e)(context.scope, function(scope) {
            var finishAndSetSpan = function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            };
            // eslint-disable-next-line deprecation/deprecation
            var hub = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
            // eslint-disable-next-line deprecation/deprecation
            var parentSpan = scope.getSpan();
            var shouldSkipSpan = context.onlyIfParent && !parentSpan;
            var activeSpan = shouldSkipSpan ? undefined : createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0,_utils_handleCallbackErrors_js__WEBPACK_IMPORTED_MODULE_2__/* .handleCallbackErrors */ .i)(function() {
                return callback(activeSpan, finishAndSetSpan);
            }, function() {
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    var status = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(activeSpan).status;
                    if (!status || status === "ok") {
                        activeSpan.setStatus("internal_error");
                    }
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function startInactiveSpan(context) {
    if (!(0,_utils_hasTracingEnabled_js__WEBPACK_IMPORTED_MODULE_4__/* .hasTracingEnabled */ .z)()) {
        return undefined;
    }
    var spanContext = normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    var hub = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
    var parentSpan = context.scope ? context.scope.getSpan() : getActiveSpan();
    var shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) {
        return undefined;
    }
    var scope = context.scope || (0,_exports_js__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentScope */ .nZ)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    var temporaryScope = scope.clone();
    return createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function getActiveSpan() {
    // eslint-disable-next-line deprecation/deprecation
    return (0,_exports_js__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentScope */ .nZ)().getSpan();
}
var continueTrace = function(param, callback) {
    var sentryTrace = param.sentryTrace, baggage = param.baggage;
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ var currentScope = (0,_exports_js__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentScope */ .nZ)();
    // eslint-disable-next-line deprecation/deprecation
    var ref = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .tracingContextFromHeaders */ .KA)(sentryTrace, baggage), traceparentData = ref.traceparentData, dynamicSamplingContext = ref.dynamicSamplingContext, propagationContext = ref.propagationContext;
    currentScope.setPropagationContext(propagationContext);
    if (_debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && traceparentData) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .logger.log */ .kg.log("[Tracing] Continuing trace ".concat(traceparentData.traceId, "."));
    }
    var transactionContext = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, traceparentData), {
        metadata: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_10__/* .dropUndefinedKeys */ .Jr)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    });
    if (!callback) {
        return transactionContext;
    }
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .runWithAsyncContext */ .Ok)(function() {
        return callback(transactionContext);
    });
};
function createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, param) {
    var parentSpan = param.parentSpan, spanContext = param.spanContext, forceTransaction = param.forceTransaction, scope = param.scope;
    if (!(0,_utils_hasTracingEnabled_js__WEBPACK_IMPORTED_MODULE_4__/* .hasTracingEnabled */ .z)()) {
        return undefined;
    }
    var isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
    var span;
    if (parentSpan && !forceTransaction) {
        // eslint-disable-next-line deprecation/deprecation
        span = parentSpan.startChild(spanContext);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        var dsc = (0,_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_11__/* .getDynamicSamplingContextFromSpan */ .j)(parentSpan);
        var ref = parentSpan.spanContext(), traceId = ref.traceId, parentSpanId = ref.spanId;
        var sampled = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanIsSampled */ .Tt)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled
        }, spanContext), {
            metadata: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                dynamicSamplingContext: dsc
            }, spanContext.metadata)
        }));
    } else {
        var ref1 = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, isolationScope.getPropagationContext(), scope.getPropagationContext()), traceId1 = ref1.traceId, dsc1 = ref1.dsc, parentSpanId1 = ref1.parentSpanId, sampled1 = ref1.sampled;
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            traceId: traceId1,
            parentSpanId: parentSpanId1,
            parentSampled: sampled1
        }, spanContext), {
            metadata: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                dynamicSamplingContext: dsc1
            }, spanContext.metadata)
        }));
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function normalizeContext(context) {
    if (context.startTime) {
        var ctx = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, context);
        ctx.startTimestamp = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanTimeInputToSeconds */ .$k)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
var SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
var ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_10__/* .addNonEnumerableProperty */ .xp)(span, ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_10__/* .addNonEnumerableProperty */ .xp)(span, SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function getCapturedScopesOnSpan(span) {
    return {
        scope: span[SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}
 //# sourceMappingURL=trace.js.map


/***/ }),

/***/ 365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Transaction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_get_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45785);
/* harmony import */ var _swc_helpers_src_get_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82662);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71418);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(27389);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(92957);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(80107);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19217);
/* harmony import */ var _metrics_metric_summary_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(30268);
/* harmony import */ var _semanticAttributes_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91292);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76190);
/* harmony import */ var _dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63055);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95293);
/* harmony import */ var _trace_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(19381);


















/** JSDoc */ var Transaction = /*#__PURE__*/ function(Span) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(Transaction, Span);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Transaction);
    function Transaction(transactionContext, hub) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, Transaction);
        var _this;
        _this = _super.call(this, transactionContext);
        _this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        _this._hub = hub || (0,_hub_js__WEBPACK_IMPORTED_MODULE_3__/* .getCurrentHub */ .Gd)();
        _this._name = transactionContext.name || "";
        _this._metadata = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, transactionContext.metadata);
        _this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        _this.transaction = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this);
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        var incomingDynamicSamplingContext = _this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) {
            // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
            _this._frozenDynamicSamplingContext = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, incomingDynamicSamplingContext);
        }
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(Transaction, [
        {
            key: "name",
            get: // This sadly conflicts with the getter/setter ordering :(
            /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function get() {
                return this._name;
            },
            set: /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ function set(newName) {
                // eslint-disable-next-line deprecation/deprecation
                this.setName(newName);
            }
        },
        {
            key: "metadata",
            get: /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ function get() {
                // We merge attributes in for backwards compatibility
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    // Defaults
                    // eslint-disable-next-line deprecation/deprecation
                    source: "custom",
                    spanMetadata: {}
                }, this._metadata, this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_7__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj] && {
                    source: this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_7__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj]
                }, this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_7__/* .SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */ .TE] && {
                    sampleRate: this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_7__/* .SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */ .TE]
                });
            },
            set: /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ function set(metadata) {
                this._metadata = metadata;
            }
        },
        {
            /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ key: "setName",
            value: function setName(name) {
                var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "custom";
                this._name = name;
                this.setAttribute(_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_7__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .Zj, source);
            }
        },
        {
            /** @inheritdoc */ key: "updateName",
            value: function updateName(name) {
                this._name = name;
                return this;
            }
        },
        {
            /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ key: "initSpanRecorder",
            value: function initSpanRecorder() {
                var maxlen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
                // eslint-disable-next-line deprecation/deprecation
                if (!this.spanRecorder) {
                    // eslint-disable-next-line deprecation/deprecation
                    this.spanRecorder = new _span_js__WEBPACK_IMPORTED_MODULE_8__/* .SpanRecorder */ .g(maxlen);
                }
                // eslint-disable-next-line deprecation/deprecation
                this.spanRecorder.add(this);
            }
        },
        {
            /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ key: "setContext",
            value: function setContext(key, context) {
                if (context === null) {
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this._contexts[key];
                } else {
                    this._contexts[key] = context;
                }
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ key: "setMeasurement",
            value: function setMeasurement(name, value) {
                var unit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
                this._measurements[name] = {
                    value: value,
                    unit: unit
                };
            }
        },
        {
            /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ key: "setMetadata",
            value: function setMetadata(newMetadata) {
                this._metadata = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, this._metadata, newMetadata);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "end",
            value: function end(endTimestamp) {
                var timestampInS = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_9__/* .spanTimeInputToSeconds */ .$k)(endTimestamp);
                var transaction = this._finishTransaction(timestampInS);
                if (!transaction) {
                    return undefined;
                }
                // eslint-disable-next-line deprecation/deprecation
                return this._hub.captureEvent(transaction);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "toContext",
            value: function toContext() {
                // eslint-disable-next-line deprecation/deprecation
                var spanContext = (0,_swc_helpers_src_get_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_get_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(Transaction.prototype), "toContext", this).call(this);
                return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .dropUndefinedKeys */ .Jr)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, spanContext), {
                    name: this._name,
                    trimEnd: this._trimEnd
                }));
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "updateWithContext",
            value: function updateWithContext(transactionContext) {
                // eslint-disable-next-line deprecation/deprecation
                (0,_swc_helpers_src_get_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_get_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(Transaction.prototype), "updateWithContext", this).call(this, transactionContext);
                this._name = transactionContext.name || "";
                this._trimEnd = transactionContext.trimEnd;
                return this;
            }
        },
        {
            /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ key: "getDynamicSamplingContext",
            value: function getDynamicSamplingContext() {
                return (0,_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_14__/* .getDynamicSamplingContextFromSpan */ .j)(this);
            }
        },
        {
            /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setHub",
            value: function setHub(hub) {
                this._hub = hub;
            }
        },
        {
            /**
   * Get the profile id of the transaction.
   */ key: "getProfileId",
            value: function getProfileId() {
                if (this._contexts !== undefined && this._contexts["profile"] !== undefined) {
                    return this._contexts["profile"].profile_id;
                }
                return undefined;
            }
        },
        {
            /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ key: "_finishTransaction",
            value: function _finishTransaction(endTimestamp) {
                var _this = this;
                // This transaction is already finished, so we should not flush it again.
                if (this._endTime !== undefined) {
                    return undefined;
                }
                if (!this._name) {
                    _debug_build_js__WEBPACK_IMPORTED_MODULE_15__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_16__/* .logger.warn */ .kg.warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
                    this._name = "<unlabeled transaction>";
                }
                // just sets the end timestamp
                (0,_swc_helpers_src_get_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_get_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(Transaction.prototype), "end", this).call(this, endTimestamp);
                // eslint-disable-next-line deprecation/deprecation
                var client = this._hub.getClient();
                if (client && client.emit) {
                    client.emit("finishTransaction", this);
                }
                if (this._sampled !== true) {
                    // At this point if `sampled !== true` we want to discard the transaction.
                    _debug_build_js__WEBPACK_IMPORTED_MODULE_15__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_16__/* .logger.log */ .kg.log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
                    if (client) {
                        client.recordDroppedEvent("sample_rate", "transaction");
                    }
                    return undefined;
                }
                // eslint-disable-next-line deprecation/deprecation
                var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function(span) {
                    return span !== _this && (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_9__/* .spanToJSON */ .XU)(span).timestamp;
                }) : [];
                if (this._trimEnd && finishedSpans.length > 0) {
                    var endTimes = finishedSpans.map(function(span) {
                        return (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_9__/* .spanToJSON */ .XU)(span).timestamp;
                    }).filter(Boolean);
                    this._endTime = endTimes.reduce(function(prev, current) {
                        return prev > current ? prev : current;
                    });
                }
                var ref = (0,_trace_js__WEBPACK_IMPORTED_MODULE_17__/* .getCapturedScopesOnSpan */ .I1)(this), capturedSpanScope = ref.scope, capturedSpanIsolationScope = ref.isolationScope;
                // eslint-disable-next-line deprecation/deprecation
                var metadata = this.metadata;
                // eslint-disable-next-line deprecation/deprecation
                var source = metadata.source;
                var transaction = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    contexts: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, this._contexts), {
                        // We don't want to override trace context
                        trace: (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_9__/* .spanToTraceContext */ .wy)(this)
                    }),
                    // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
                    spans: finishedSpans,
                    start_timestamp: this._startTime,
                    // eslint-disable-next-line deprecation/deprecation
                    tags: this.tags,
                    timestamp: this._endTime,
                    transaction: this._name,
                    type: "transaction",
                    sdkProcessingMetadata: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, metadata), {
                        capturedSpanScope: capturedSpanScope,
                        capturedSpanIsolationScope: capturedSpanIsolationScope
                    }), (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_12__/* .dropUndefinedKeys */ .Jr)({
                        dynamicSamplingContext: (0,_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_14__/* .getDynamicSamplingContextFromSpan */ .j)(this)
                    })),
                    _metrics_summary: (0,_metrics_metric_summary_js__WEBPACK_IMPORTED_MODULE_18__/* .getMetricSummaryJsonForSpan */ .y)(this)
                }, source && {
                    transaction_info: {
                        source: source
                    }
                });
                var hasMeasurements = Object.keys(this._measurements).length > 0;
                if (hasMeasurements) {
                    _debug_build_js__WEBPACK_IMPORTED_MODULE_15__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_16__/* .logger.log */ .kg.log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
                    transaction.measurements = this._measurements;
                }
                // eslint-disable-next-line deprecation/deprecation
                _debug_build_js__WEBPACK_IMPORTED_MODULE_15__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_16__/* .logger.log */ .kg.log("[Tracing] Finishing ".concat(this.op, " transaction: ").concat(this._name, "."));
                return transaction;
            }
        }
    ]);
    return Transaction;
}(_span_js__WEBPACK_IMPORTED_MODULE_8__/* .Span */ .D);
 //# sourceMappingURL=transaction.js.map


/***/ }),

/***/ 4124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qG": function() { return /* binding */ extractTraceparentData; },
/* harmony export */   "x1": function() { return /* binding */ getActiveTransaction; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84907);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19217);



/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function getActiveTransaction(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    var hub = maybeHub || (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
    // eslint-disable-next-line deprecation/deprecation
    var scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ var extractTraceparentData = _sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .extractTraceparentData */ .qG;
 //# sourceMappingURL=utils.js.map


/***/ }),

/***/ 25576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ createTransport; }
});

// UNUSED EXPORTS: DEFAULT_TRANSPORT_BUFFER_SIZE

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/error.js
var esm_error = __webpack_require__(16901);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(21200);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/promisebuffer.js


/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function makePromiseBuffer(limit) {
    var isReady = function isReady() {
        return limit === undefined || buffer.length < limit;
    };
    var remove = /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    };
    var add = /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) {
            return (0,syncpromise/* rejectedSyncPromise */.$2)(new esm_error/* SentryError */.b("Not adding Promise because buffer limit was reached."));
        }
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) {
            buffer.push(task);
        }
        void task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    };
    var drain = /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new syncpromise/* SyncPromise */.cW(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) {
                return resolve(true);
            }
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(function() {
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    };
    var buffer = [];
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}
 //# sourceMappingURL=promisebuffer.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/envelope.js
var esm_envelope = __webpack_require__(62486);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/ratelimit.js
var ratelimit = __webpack_require__(95542);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(92957);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/debug-build.js
var debug_build = __webpack_require__(80107);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/base.js



var DEFAULT_TRANSPORT_BUFFER_SIZE = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function createTransport(options, makeRequest) {
    var buffer = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : makePromiseBuffer(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE);
    var send = function send(envelope) {
        var filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0,esm_envelope/* forEachEnvelopeItem */.gv)(envelope, function(item, type) {
            var dataCategory = (0,esm_envelope/* envelopeItemTypeToDataCategory */.mL)(type);
            if ((0,ratelimit/* isRateLimited */.Q)(rateLimits, dataCategory)) {
                var event = getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else {
                filteredEnvelopeItems.push(item);
            }
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) {
            return (0,syncpromise/* resolvedSyncPromise */.WD)();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var filteredEnvelope = (0,esm_envelope/* createEnvelope */.Jd)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        var recordEnvelopeLoss = function(reason) {
            (0,esm_envelope/* forEachEnvelopeItem */.gv)(filteredEnvelope, function(item, type) {
                var event = getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0,esm_envelope/* envelopeItemTypeToDataCategory */.mL)(type), event);
            });
        };
        var requestTask = function() {
            return makeRequest({
                body: (0,esm_envelope/* serializeEnvelope */.V$)(filteredEnvelope, options.textEncoder)
            }).then(function(response) {
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
                    debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("Sentry responded with status code ".concat(response.statusCode, " to sent event."));
                }
                rateLimits = (0,ratelimit/* updateRateLimits */.WG)(rateLimits, response);
                return response;
            }, function(error) {
                recordEnvelopeLoss("network_error");
                throw error;
            });
        };
        return buffer.add(requestTask).then(function(result) {
            return result;
        }, function(error) {
            if ((0,_instanceof/* default */.Z)(error, esm_error/* SentryError */.b)) {
                debug_build/* DEBUG_BUILD */.X && logger/* logger.error */.kg.error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0,syncpromise/* resolvedSyncPromise */.WD)();
            } else {
                throw error;
            }
        });
    };
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") {
        return undefined;
    }
    return Array.isArray(item) ? item[1] : undefined;
}
 //# sourceMappingURL=base.js.map


/***/ }),

/***/ 15968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ handleCallbackErrors; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74020);

/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function handleCallbackErrors(fn, onError) {
    var // eslint-disable-next-line @typescript-eslint/no-empty-function
    onFinally = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {};
    var maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
        // @ts-expect-error - the isThenable check returns the "wrong" type here
        return value.then(function(res) {
            onFinally();
            return res;
        }, function(e) {
            onError(e);
            onFinally();
            throw e;
        });
    }
    onFinally();
    return value;
}
 //# sourceMappingURL=handleCallbackErrors.js.map


/***/ }),

/***/ 67007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ hasTracingEnabled; }
/* harmony export */ });
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77668);

// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function hasTracingEnabled(maybeOptions) {
    if (true) {
        return false;
    }
    var client = (0,_exports_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .s3)();
    var options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}
 //# sourceMappingURL=hasTracingEnabled.js.map


/***/ }),

/***/ 27115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ isSentryRequestUrl; }
/* harmony export */ });
/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ // eslint-disable-next-line deprecation/deprecation
function isSentryRequestUrl(url, hubOrClient) {
    var client = hubOrClient && isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    var dsn = client && client.getDsn();
    var tunnel = client && client.getOptions().tunnel;
    return checkDsn(url, dsn) || checkTunnel(url, tunnel);
}
function checkTunnel(url, tunnel) {
    if (!tunnel) {
        return false;
    }
    return removeTrailingSlash(url) === removeTrailingSlash(tunnel);
}
function checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
// eslint-disable-next-line deprecation/deprecation
function isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}
 //# sourceMappingURL=isSentryRequestUrl.js.map


/***/ }),

/***/ 88633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ applySdkMetadata; }
/* harmony export */ });
/* harmony import */ var _version_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63935);

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function applySdkMetadata(options, name) {
    var names = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
        name
    ], source = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "npm";
    var metadata = options._metadata || {};
    if (!metadata.sdk) {
        metadata.sdk = {
            name: "sentry.javascript.".concat(name),
            packages: names.map(function(name) {
                return {
                    name: "".concat(source, ":@sentry/").concat(name),
                    version: _version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .J
                };
            }),
            version: _version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .J
        };
    }
    options._metadata = metadata;
}
 //# sourceMappingURL=sdkMetadata.js.map


/***/ }),

/***/ 6157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ rewriteFramesIntegration; }
});

// UNUSED EXPORTS: RewriteFrames

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/integration.js
var integration = __webpack_require__(62909);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/path.js
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */ function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = parts.length - 1; i >= 0; i--){
        var last = parts[i];
        if (last === ".") {
            parts.splice(i, 1);
        } else if (last === "..") {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) {
        for(; up--; up){
            parts.unshift("..");
        }
    }
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */ function splitPath(filename) {
    // Truncate files names greater than 1024 characters to avoid regex dos
    // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
    var truncated = filename.length > 1024 ? "<truncated>".concat(filename.slice(-1024)) : filename;
    var parts = splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */ function resolve() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var resolvedPath = "";
    var resolvedAbsolute = false;
    for(var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        var path = i >= 0 ? args[i] : "/";
        // Skip empty entries
        if (!path) {
            continue;
        }
        resolvedPath = "".concat(path, "/").concat(resolvedPath);
        resolvedAbsolute = path.charAt(0) === "/";
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split("/").filter(function(p) {
        return !!p;
    }), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
/** JSDoc */ function trim(arr) {
    var start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") {
            break;
        }
    }
    var end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") {
            break;
        }
    }
    if (start > end) {
        return [];
    }
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */ function relative(from, to) {
    /* eslint-disable no-param-reassign */ from = resolve(from).slice(1);
    to = resolve(to).slice(1);
    /* eslint-enable no-param-reassign */ var fromParts = trim(from.split("/"));
    var toParts = trim(to.split("/"));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for(var i = 0; i < length; i++){
        if (fromParts[i] !== toParts[i]) {
            samePartsLength = i;
            break;
        }
    }
    var outputParts = [];
    for(var i1 = samePartsLength; i1 < fromParts.length; i1++){
        outputParts.push("..");
    }
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
// path.normalize(path)
// posix version
/** JSDoc */ function normalizePath(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.slice(-1) === "/";
    // Normalize the path
    var normalizedPath = normalizeArray(path.split("/").filter(function(p) {
        return !!p;
    }), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) {
        normalizedPath = ".";
    }
    if (normalizedPath && trailingSlash) {
        normalizedPath += "/";
    }
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
// posix version
/** JSDoc */ function isAbsolute(path) {
    return path.charAt(0) === "/";
}
// posix version
/** JSDoc */ function join() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return normalizePath(args.join("/"));
}
/** JSDoc */ function dirname(path) {
    var result = splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) {
        // No dirname whatsoever
        return ".";
    }
    if (dir) {
        // It has a dirname, strip trailing slash
        dir = dir.slice(0, dir.length - 1);
    }
    return root + dir;
}
/** JSDoc */ function basename(path, ext) {
    var f = splitPath(path)[2];
    if (ext && f.slice(ext.length * -1) === ext) {
        f = f.slice(0, f.length - ext.length);
    }
    return f;
}
 //# sourceMappingURL=path.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/rewriteframes.js




var INTEGRATION_NAME = "RewriteFrames";
var _rewriteFramesIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _processExceptionsEvent = /** Process an exception event. */ function _processExceptionsEvent(event) {
        try {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, event), {
                exception: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, event.exception), {
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map(function(value) {
                        return (0,_object_spread/* default */.Z)({}, value, value.stacktrace && {
                            stacktrace: _processStacktrace(value.stacktrace)
                        });
                    })
                })
            });
        } catch (_oO) {
            return event;
        }
    };
    var _processStacktrace = /** Process a stack trace. */ function _processStacktrace(stacktrace) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, stacktrace), {
            frames: stacktrace && stacktrace.frames && stacktrace.frames.map(function(f) {
                return iteratee(f);
            })
        });
    };
    var root = options.root;
    var prefix = options.prefix || "app:///";
    var iteratee = options.iteratee || function(frame) {
        if (!frame.filename) {
            return frame;
        }
        // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
        var isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes("\\") && !frame.filename.includes("/");
        // Check if the frame filename begins with `/`
        var startsWithSlash = /^\//.test(frame.filename);
        if (isWindowsFrame || startsWithSlash) {
            var filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "") // remove Windows-style prefix
            .replace(/\\/g, "/") // replace all `\\` instances with `/`
             : frame.filename;
            var base = root ? relative(root, filename) : basename(filename);
            frame.filename = "".concat(prefix).concat(base);
        }
        return frame;
    };
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        processEvent: function processEvent(originalEvent) {
            var processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
                processedEvent = _processExceptionsEvent(processedEvent);
            }
            return processedEvent;
        }
    };
};
var rewriteFramesIntegration = (0,integration/* defineIntegration */._I)(_rewriteFramesIntegration);
/**
 * Rewrite event frames paths.
 * @deprecated Use `rewriteFramesIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var RewriteFrames = (0,integration/* convertIntegrationFnToClass */.RN)(INTEGRATION_NAME, rewriteFramesIntegration);
 //# sourceMappingURL=rewriteframes.js.map


/***/ }),

/***/ 6837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ applyAggregateErrorsToEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74020);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68813);





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser) {
    var maxValueLimit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 250, key = arguments.length > 3 ? arguments[3] : void 0, limit = arguments.length > 4 ? arguments[4] : void 0, event = arguments.length > 5 ? arguments[5] : void 0, hint = arguments.length > 6 ? arguments[6] : void 0;
    if (!event.exception || !event.exception.values || !hint || !(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(hint.originalException, Error)) {
        return;
    }
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    var originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) {
        event.exception.values = truncateAggregateExceptions(aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
    }
}
function aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) {
        return prevExceptions;
    }
    var newExceptions = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(prevExceptions);
    // Recursively call this function in order to walk down a chain of errors
    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(error[key], Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId);
        var newException = exceptionFromErrorImplementation(parser, error[key]);
        var newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(newExceptions)), newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) {
        error.errors.forEach(function(childError, i) {
            if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(childError, Error)) {
                applyExceptionGroupFieldsForParentException(exception, exceptionId);
                var newException = exceptionFromErrorImplementation(parser, childError);
                var newExceptionId = newExceptions.length;
                applyExceptionGroupFieldsForChildException(newException, "errors[".concat(i, "]"), newExceptionId, exceptionId);
                newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                    newException
                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(newExceptions)), newException, newExceptionId);
            }
        });
    }
    return newExceptions;
}
function applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, exception.mechanism, exception.type === "AggregateError" && {
        is_exception_group: true
    }), {
        exception_id: exceptionId
    });
}
function applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, exception.mechanism), {
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    });
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map(function(exception) {
        if (exception.value) {
            exception.value = (0,_string_js__WEBPACK_IMPORTED_MODULE_4__/* .truncate */ .$G)(exception.value, maxValueLength);
        }
        return exception;
    });
}
 //# sourceMappingURL=aggregate-errors.js.map


/***/ }),

/***/ 42712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ _nullishCoalesce; }
/* harmony export */ });
// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function _nullishCoalesce(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}
// Sucrase version:
// function _nullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return rhsFn();
//   }
// }
 //# sourceMappingURL=_nullishCoalesce.js.map


/***/ }),

/***/ 57374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ _optionalChain; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36305);
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ 
function _optionalChain(ops) {
    var lastAccessLHS = undefined;
    var value = ops[0];
    var i = 1;
    while(i < ops.length){
        var op = ops[i];
        var fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) {
            // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
            return;
        }
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            var _value;
            value = fn(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_value = value).call.apply(_value, [
                    lastAccessLHS
                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(args)));
            });
            lastAccessLHS = undefined;
        }
    }
    return value;
}
// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }
 //# sourceMappingURL=_optionalChain.js.map


/***/ }),

/***/ 74094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RA": function() { return /* binding */ dsnToString; },
/* harmony export */   "U4": function() { return /* binding */ dsnFromString; },
/* harmony export */   "vK": function() { return /* binding */ makeDsn; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35614);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92957);



/** Regular expression used to parse a Dsn. */ var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function dsnToString(dsn) {
    var withPassword = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return "".concat(protocol, "://").concat(publicKey).concat(withPassword && pass ? ":".concat(pass) : "") + "@".concat(host).concat(port ? ":".concat(port) : "", "/").concat(path ? "".concat(path, "/") : path).concat(projectId);
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function dsnFromString(str) {
    var match = DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0,_logger_js__WEBPACK_IMPORTED_MODULE_0__/* .consoleSandbox */ .Cf)(function() {
            // eslint-disable-next-line no-console
            console.error("Invalid Sentry Dsn: ".concat(str));
        });
        return undefined;
    }
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(match.slice(1), 6), protocol = ref[0], publicKey = ref[1], tmp = ref[2], pass = tmp === void 0 ? "" : tmp, host = ref[3], tmp1 = ref[4], port = tmp1 === void 0 ? "" : tmp1, lastPath = ref[5];
    var path = "";
    var projectId = lastPath;
    var split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) {
            projectId = projectMatch[0];
        }
    }
    return dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function validateDsn(dsn) {
    if (!_debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X) {
        return true;
    }
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    var hasMissingRequiredComponent = requiredComponents.find(function(component) {
        if (!dsn[component]) {
            _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error("Invalid Sentry Dsn: ".concat(component, " missing"));
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) {
        return false;
    }
    if (!projectId.match(/^\d+$/)) {
        _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error("Invalid Sentry Dsn: Invalid projectId ".concat(projectId));
        return false;
    }
    if (!isValidProtocol(protocol)) {
        _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error("Invalid Sentry Dsn: Invalid protocol ".concat(protocol));
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .kg.error("Invalid Sentry Dsn: Invalid port ".concat(port));
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function makeDsn(from) {
    var components = typeof from === "string" ? dsnFromString(from) : dsnFromComponents(from);
    if (!components || !validateDsn(components)) {
        return undefined;
    }
    return components;
}
 //# sourceMappingURL=dsn.js.map


/***/ }),

/***/ 87840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getSDKSource; },
/* harmony export */   "n": function() { return /* binding */ isBrowserBundle; }
/* harmony export */ });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function getSDKSource() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}
 //# sourceMappingURL=env.js.map


/***/ }),

/***/ 62486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BO": function() { return /* binding */ addItemToEnvelope; },
/* harmony export */   "Cd": function() { return /* binding */ createEventEnvelopeHeaders; },
/* harmony export */   "HY": function() { return /* binding */ getSdkMetadataForEnvelopeHeader; },
/* harmony export */   "Jd": function() { return /* binding */ createEnvelope; },
/* harmony export */   "R": function() { return /* binding */ envelopeContainsItemType; },
/* harmony export */   "V$": function() { return /* binding */ serializeEnvelope; },
/* harmony export */   "f4": function() { return /* binding */ parseEnvelope; },
/* harmony export */   "gv": function() { return /* binding */ forEachEnvelopeItem; },
/* harmony export */   "mL": function() { return /* binding */ envelopeItemTypeToDataCategory; },
/* harmony export */   "zQ": function() { return /* binding */ createAttachmentEnvelopeItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);
/* harmony import */ var _dsn_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74094);
/* harmony import */ var _normalize_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92276);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27389);







/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function createEnvelope(headers) {
    var items = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function addItemToEnvelope(envelope, newItem) {
    var _envelope = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(envelope, 2), headers = _envelope[0], items = _envelope[1];
    return [
        headers,
        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(items).concat([
            newItem
        ])
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function forEachEnvelopeItem(envelope, callback) {
    var envelopeItems = envelope[1];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = envelopeItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var envelopeItem = _step.value;
            var envelopeItemType = envelopeItem[0].type;
            var result = callback(envelopeItem, envelopeItemType);
            if (result) {
                return true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function envelopeContainsItemType(envelope, types) {
    return forEachEnvelopeItem(envelope, function(_, type) {
        return types.includes(type);
    });
}
/**
 * Encode a string to UTF8.
 */ function encodeUTF8(input, textEncoder) {
    var utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function serializeEnvelope(envelope, textEncoder) {
    var append = function append(next) {
        if (typeof parts === "string") {
            parts = typeof next === "string" ? parts + next : [
                encodeUTF8(parts, textEncoder),
                next
            ];
        } else {
            parts.push(typeof next === "string" ? encodeUTF8(next, textEncoder) : next);
        }
    };
    var _envelope = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(envelope, 2), envHeaders = _envelope[0], items = _envelope[1];
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    var parts = JSON.stringify(envHeaders);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var _item = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(item, 2), itemHeaders = _item[0], payload = _item[1];
            append("\n".concat(JSON.stringify(itemHeaders), "\n"));
            if (typeof payload === "string" || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(payload, Uint8Array)) {
                append(payload);
            } else {
                var stringifiedPayload = void 0;
                try {
                    stringifiedPayload = JSON.stringify(payload);
                } catch (e) {
                    // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                    // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                    // performance impact but in this case a performance hit is better than throwing.
                    stringifiedPayload = JSON.stringify((0,_normalize_js__WEBPACK_IMPORTED_MODULE_3__/* .normalize */ .Fv)(payload));
                }
                append(stringifiedPayload);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return typeof parts === "string" ? parts : concatBuffers(parts);
}
function concatBuffers(buffers) {
    var totalLength = buffers.reduce(function(acc, buf) {
        return acc + buf.length;
    }, 0);
    var merged = new Uint8Array(totalLength);
    var offset = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var buffer = _step.value;
            merged.set(buffer, offset);
            offset += buffer.length;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return merged;
}
/**
 * Parses an envelope
 */ function parseEnvelope(env, textEncoder, textDecoder) {
    var readBinary = function readBinary(length) {
        var bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    };
    var readJson = function readJson() {
        var i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) {
            i = buffer.length;
        }
        return JSON.parse(textDecoder.decode(readBinary(i)));
    };
    var buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    var envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var items = [];
    while(buffer.length){
        var itemHeader = readJson();
        var binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function createAttachmentEnvelopeItem(attachment, textEncoder) {
    var buffer = typeof attachment.data === "string" ? encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0,_object_js__WEBPACK_IMPORTED_MODULE_4__/* .dropUndefinedKeys */ .Jr)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer, 
    ];
}
var ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function envelopeItemTypeToDataCategory(type) {
    return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) {
        return;
    }
    var _sdk = metadataOrEvent.sdk, name = _sdk.name, version = _sdk.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn) {
    var dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0,_dsn_js__WEBPACK_IMPORTED_MODULE_6__/* .dsnToString */ .RA)(dsn)
    }, dynamicSamplingContext && {
        trace: (0,_object_js__WEBPACK_IMPORTED_MODULE_4__/* .dropUndefinedKeys */ .Jr)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, dynamicSamplingContext))
    });
}
 //# sourceMappingURL=envelope.js.map


/***/ }),

/***/ 16901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SentryError; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25892);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71418);
/** An error emitted by Sentry SDKs and related utilities. */ 





var SentryError = /*#__PURE__*/ function _target(Error1) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(SentryError, Error1);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(SentryError);
    function SentryError(message) {
        var logLevel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "warn";
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, SentryError);
        var _this;
        _this = _super.call(this, message);
        _this.message = message;
        _this.name = ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, SentryError) ? this.constructor : void 0).prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_this), ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, SentryError) ? this.constructor : void 0).prototype);
        _this.logLevel = logLevel;
        return _this;
    }
    return SentryError;
}((0,_swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Error));
 //# sourceMappingURL=error.js.map


/***/ }),

/***/ 18996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D2": function() { return /* binding */ maybeInstrument; },
/* harmony export */   "Hj": function() { return /* binding */ addHandler; },
/* harmony export */   "rK": function() { return /* binding */ triggerHandlers; }
/* harmony export */ });
/* unused harmony export resetInstrumentationHandlers */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35614);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92957);
/* harmony import */ var _stacktrace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91987);



// We keep the handlers globally
var handlers = {};
var instrumented = {};
/** Add a handler function. */ function addHandler(type, handler) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function resetInstrumentationHandlers() {
    Object.keys(handlers).forEach(function(key) {
        handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function maybeInstrument(type, instrumentFn) {
    if (!instrumented[type]) {
        instrumentFn();
        instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function triggerHandlers(type, data) {
    var typeHandlers = type && handlers[type];
    if (!typeHandlers) {
        return;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = typeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            try {
                handler(data);
            } catch (e) {
                _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .kg.error("Error while triggering instrumentation handler.\nType: ".concat(type, "\nName: ").concat((0,_stacktrace_js__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(handler), "\nError:"), e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
 //# sourceMappingURL=_handlers.js.map


/***/ }),

/***/ 43445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ addConsoleInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92957);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27389);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74672);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18996);




/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addConsoleInstrumentationHandler(handler) {
    var type = "console";
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .Hj)(type, handler);
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .D2)(type, instrumentConsole);
}
function instrumentConsole() {
    if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ */ .n2)) {
        return;
    }
    _logger_js__WEBPACK_IMPORTED_MODULE_2__/* .CONSOLE_LEVELS.forEach */ .RU.forEach(function(level) {
        if (!(level in _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.console */ .n2.console)) {
            return;
        }
        (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(_worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.console */ .n2.console, level, function(originalConsoleMethod) {
            _logger_js__WEBPACK_IMPORTED_MODULE_2__/* .originalConsoleMethods */ .LD[level] = originalConsoleMethod;
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var handlerData = {
                    args: args,
                    level: level
                };
                (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)("console", handlerData);
                var log = _logger_js__WEBPACK_IMPORTED_MODULE_2__/* .originalConsoleMethods */ .LD[level];
                log && log.apply(_worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.console */ .n2.console, args);
            };
        });
    });
}
 //# sourceMappingURL=console.js.map


/***/ }),

/***/ 89232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ addClickKeypressInstrumentationHandler; }
/* harmony export */ });
/* unused harmony export instrumentDOM */
/* harmony import */ var _misc_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11591);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27389);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74672);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18996);




var WINDOW = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2;
var DEBOUNCE_DURATION = 1000;
var debounceTimerID;
var lastCapturedEventType;
var lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addClickKeypressInstrumentationHandler(handler) {
    var type = "dom";
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .addHandler */ .Hj)(type, handler);
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .maybeInstrument */ .D2)(type, instrumentDOM);
}
/** Exported for tests only. */ function instrumentDOM() {
    if (!WINDOW.document) {
        return;
    }
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = _handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .triggerHandlers.bind */ .rK.bind(null, "dom");
    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = WINDOW[target] && WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) {
            return;
        }
        (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") {
                    try {
                        var el = this;
                        var handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers[type] = handlers[type] || {
                            refCount: 0
                        };
                        if (!handlerForType.handler) {
                            var handler = makeDOMEventHandler(triggerDOMHandler);
                            handlerForType.handler = handler;
                            originalAddEventListener.call(this, type, handler, options);
                        }
                        handlerForType.refCount++;
                    } catch (e) {
                    // Accessing dom properties is always fragile.
                    // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") {
                    try {
                        var el = this;
                        var handlers = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers[type];
                        if (handlerForType) {
                            handlerForType.refCount--;
                            // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                            if (handlerForType.refCount <= 0) {
                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                                handlerForType.handler = undefined;
                                delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                            }
                            // If there are no longer any custom handlers of any type on this element, cleanup everything.
                            if (Object.keys(handlers).length === 0) {
                                delete el.__sentry_instrumentation_handlers__;
                            }
                        }
                    } catch (e) {
                    // Accessing dom properties is always fragile.
                    // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== lastCapturedEventType) {
        return false;
    }
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== lastCapturedEventTargetId) {
            return false;
        }
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") {
        return false;
    }
    if (!target || !target.tagName) {
        return true;
    }
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) {
        return false;
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function makeDOMEventHandler(handler) {
    var globalListener = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) {
            return;
        }
        var target = getEventTarget(event);
        // We always want to skip _some_ events.
        if (shouldSkipDOMEvent(event.type, target)) {
            return;
        }
        // Mark event as "seen"
        (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .xp)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) {
            // Add UUID to event target so we can identify if
            (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .xp)(target, "_sentryId", (0,_misc_js__WEBPACK_IMPORTED_MODULE_3__/* .uuid4 */ .DM)());
        }
        var name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!isSimilarToLastCapturedEvent(event)) {
            var handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            lastCapturedEventType = event.type;
            lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout(debounceTimerID);
        debounceTimerID = WINDOW.setTimeout(function() {
            lastCapturedEventTargetId = undefined;
            lastCapturedEventType = undefined;
        }, DEBOUNCE_DURATION);
    };
}
function getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}
 //# sourceMappingURL=dom.js.map


/***/ }),

/***/ 99096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ addFetchInstrumentationHandler; }
/* harmony export */ });
/* unused harmony export parseFetchArgs */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10253);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27389);
/* harmony import */ var _supports_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59036);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74672);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18996);







/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addFetchInstrumentationHandler(handler) {
    var type = "fetch";
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .Hj)(type, handler);
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .D2)(type, instrumentFetch);
}
function instrumentFetch() {
    if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_1__/* .supportsNativeFetch */ .t$)()) {
        return;
    }
    (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(_worldwide_js__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_OBJ */ .n2, "fetch", function(originalFetch) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var ref = parseFetchArgs(args), method = ref.method, url = ref.url;
            var handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)("fetch", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(_worldwide_js__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_OBJ */ .n2, args).then(function(response) {
                var finishedHandlerData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                });
                (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)("fetch", finishedHandlerData);
                return response;
            }, function(error) {
                var erroredHandlerData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                });
                (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function getUrlFromResource(resource) {
    if (typeof resource === "string") {
        return resource;
    }
    if (!resource) {
        return "";
    }
    if (hasProp(resource, "url")) {
        return resource.url;
    }
    if (resource.toString) {
        return resource.toString();
    }
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) {
        return {
            method: "GET",
            url: ""
        };
    }
    if (fetchArgs.length === 2) {
        var _fetchArgs = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(fetchArgs, 2), url = _fetchArgs[0], options = _fetchArgs[1];
        return {
            url: getUrlFromResource(url),
            method: hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    var arg = fetchArgs[0];
    return {
        url: getUrlFromResource(arg),
        method: hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
 //# sourceMappingURL=fetch.js.map


/***/ }),

/***/ 62869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ addGlobalErrorInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74672);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18996);


var _oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addGlobalErrorInstrumentationHandler(handler) {
    var type = "error";
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .Hj)(type, handler);
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .D2)(type, instrumentError);
}
function instrumentError() {
    _oldOnErrorHandler = _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onerror */ .n2.onerror;
    _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onerror */ .n2.onerror = function(msg, url, line, column, error) {
        var handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)("error", handlerData);
        if (_oldOnErrorHandler && !_oldOnErrorHandler.__SENTRY_LOADER__) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
    _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ */ .n2.onerror.__SENTRY_INSTRUMENTED__ = true;
}
 //# sourceMappingURL=globalError.js.map


/***/ }),

/***/ 25534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ addGlobalUnhandledRejectionInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74672);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18996);


var _oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    var type = "unhandledrejection";
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .Hj)(type, handler);
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .D2)(type, instrumentUnhandledRejection);
}
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onunhandledrejection */ .n2.onunhandledrejection;
    _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onunhandledrejection */ .n2.onunhandledrejection = function(e) {
        var handlerData = e;
        (0,_handlers_js__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .rK)("unhandledrejection", handlerData);
        if (_oldOnUnhandledRejectionHandler && !_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
    _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ */ .n2.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
 //# sourceMappingURL=globalUnhandledRejection.js.map


/***/ }),

/***/ 41549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ addHistoryInstrumentationHandler; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(27389);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(74672);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/vendor/supportsHistory.js

// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
var WINDOW = (0,worldwide/* getGlobalObject */.Rf)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chromeVar = WINDOW.chrome;
    var isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = "history" in WINDOW && !!WINDOW.history.pushState && !!WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
 //# sourceMappingURL=supportsHistory.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument/_handlers.js
var _handlers = __webpack_require__(18996);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/instrument/history.js






var history_WINDOW = worldwide/* GLOBAL_OBJ */.n2;
var lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addHistoryInstrumentationHandler(handler) {
    var type = "history";
    (0,_handlers/* addHandler */.Hj)(type, handler);
    (0,_handlers/* maybeInstrument */.D2)(type, instrumentHistory);
}
function instrumentHistory() {
    var historyReplacementFunction = function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                var handlerData = {
                    from: from,
                    to: to
                };
                (0,_handlers/* triggerHandlers */.rK)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    };
    if (!supportsHistory()) {
        return;
    }
    var oldOnPopState = history_WINDOW.onpopstate;
    history_WINDOW.onpopstate = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var to = history_WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        var handlerData = {
            from: from,
            to: to
        };
        (0,_handlers/* triggerHandlers */.rK)("history", handlerData);
        if (oldOnPopState) {
            // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
            // https://github.com/getsentry/sentry-javascript/issues/3344
            // https://github.com/bugsnag/bugsnag-js/issues/469
            try {
                return oldOnPopState.apply(this, args);
            } catch (_oO) {
            // no-empty
            }
        }
    };
    (0,object/* fill */.hl)(history_WINDOW.history, "pushState", historyReplacementFunction);
    (0,object/* fill */.hl)(history_WINDOW.history, "replaceState", historyReplacementFunction);
}
 //# sourceMappingURL=history.js.map


/***/ }),

/***/ 33224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UK": function() { return /* binding */ addXhrInstrumentationHandler; },
/* harmony export */   "xU": function() { return /* binding */ SENTRY_XHR_DATA_KEY; }
/* harmony export */ });
/* unused harmony export instrumentXHR */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74020);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27389);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74672);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18996);





var WINDOW = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2;
var SENTRY_XHR_DATA_KEY = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addXhrInstrumentationHandler(handler) {
    var type = "xhr";
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .addHandler */ .Hj)(type, handler);
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .maybeInstrument */ .D2)(type, instrumentXHR);
}
/** Exported only for tests. */ function instrumentXHR() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!WINDOW.XMLHttpRequest) {
        return;
    }
    var xhrproto = XMLHttpRequest.prototype;
    (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(xhrproto, "open", function(originalOpen) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _this = this;
            var startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            var method = (0,_is_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(args[0]) ? args[0].toUpperCase() : undefined;
            var url = parseUrl(args[1]);
            if (!method || !url) {
                return originalOpen.apply(this, args);
            }
            this[SENTRY_XHR_DATA_KEY] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) {
                this.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function() {
                // For whatever reason, this is not the same instance here as from the outer method
                var xhrInfo = _this[SENTRY_XHR_DATA_KEY];
                if (!xhrInfo) {
                    return;
                }
                if (_this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = _this.status;
                    } catch (e) {
                    /* do nothing */ }
                    var handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: _this
                    };
                    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .triggerHandlers */ .rK)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") {
                (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(this, "onreadystatechange", function(original) {
                    return function() {
                        for(var _len = arguments.length, readyStateArgs = new Array(_len), _key = 0; _key < _len; _key++){
                            readyStateArgs[_key] = arguments[_key];
                        }
                        onreadystatechangeHandler();
                        return original.apply(this, readyStateArgs);
                    };
                });
            } else {
                this.addEventListener("readystatechange", onreadystatechangeHandler);
            }
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(this, "setRequestHeader", function(original) {
                return function() {
                    for(var _len = arguments.length, setRequestHeaderArgs = new Array(_len), _key = 0; _key < _len; _key++){
                        setRequestHeaderArgs[_key] = arguments[_key];
                    }
                    var _setRequestHeaderArgs = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(setRequestHeaderArgs, 2), header = _setRequestHeaderArgs[0], value = _setRequestHeaderArgs[1];
                    var xhrInfo = this[SENTRY_XHR_DATA_KEY];
                    if (xhrInfo && (0,_is_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(header) && (0,_is_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(value)) {
                        xhrInfo.request_headers[header.toLowerCase()] = value;
                    }
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0,_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .hl)(xhrproto, "send", function(originalSend) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var sentryXhrData = this[SENTRY_XHR_DATA_KEY];
            if (!sentryXhrData) {
                return originalSend.apply(this, args);
            }
            if (args[0] !== undefined) {
                sentryXhrData.body = args[0];
            }
            var handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .triggerHandlers */ .rK)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function parseUrl(url) {
    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_3__/* .isString */ .HD)(url)) {
        return url;
    }
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}
 //# sourceMappingURL=xhr.js.map


/***/ }),

/***/ 99506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ isBrowser; }
/* harmony export */ });
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65210);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74672);


/**
 * Returns true if we are in the browser.
 */ function isBrowser() {
    // eslint-disable-next-line no-restricted-globals
    return  true && (!(0,_node_js__WEBPACK_IMPORTED_MODULE_0__/* .isNodeEnv */ .KV)() || isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.process */ .n2.process !== undefined && _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ.process.type */ .n2.process.type === "renderer");
}
 //# sourceMappingURL=isBrowser.js.map


/***/ }),

/***/ 65210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ isNodeEnv; }
/* harmony export */ });
/* unused harmony exports dynamicRequire, loadModule */
/* harmony import */ var _env_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87840);
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(34155);

/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0,_env_js__WEBPACK_IMPORTED_MODULE_0__/* .isBrowserBundle */ .n)() && Object.prototype.toString.call(typeof process !== "undefined" ? process : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, "process").cwd;
        mod = dynamicRequire(module, "".concat(cwd(), "/node_modules/").concat(moduleName));
    } catch (e1) {
    // no-empty
    }
    return mod;
}
 //# sourceMappingURL=node.js.map


/***/ }),

/***/ 95542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JY": function() { return /* binding */ parseRetryAfterHeader; },
/* harmony export */   "Q": function() { return /* binding */ isRateLimited; },
/* harmony export */   "WG": function() { return /* binding */ updateRateLimits; }
/* harmony export */ });
/* unused harmony exports DEFAULT_RETRY_AFTER, disabledUntil */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend


var DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function parseRetryAfterHeader(header) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    var headerDelay = parseInt("".concat(header), 10);
    if (!isNaN(headerDelay)) {
        return headerDelay * 1000;
    }
    var headerDate = Date.parse("".concat(header));
    if (!isNaN(headerDate)) {
        return headerDate - now;
    }
    return DEFAULT_RETRY_AFTER;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function isRateLimited(limits, dataCategory) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    return disabledUntil(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function updateRateLimits(limits, param) {
    var statusCode = param.statusCode, headers = param.headers, now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    var updatedRateLimits = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    var retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for(var _iterator = rateLimitHeader.trim().split(",")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var limit = _step.value;
                var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(limit.split(":", 5), 5), retryAfter = ref[0], categories = ref[1], namespaces = ref[4];
                var headerDelay = parseInt(retryAfter, 10);
                var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
                if (!categories) {
                    updatedRateLimits.all = now + delay;
                } else {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = categories.split(";")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var category = _step1.value;
                            if (category === "metric_bucket") {
                                // namespaces will be present when category === 'metric_bucket'
                                if (!namespaces || namespaces.split(";").includes("custom")) {
                                    updatedRateLimits[category] = now + delay;
                                }
                            } else {
                                updatedRateLimits[category] = now + delay;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else if (retryAfterHeader) {
        updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
    } else if (statusCode === 429) {
        updatedRateLimits.all = now + 60 * 1000;
    }
    return updatedRateLimits;
}
 //# sourceMappingURL=ratelimit.js.map


/***/ }),

/***/ 41824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VT": function() { return /* binding */ severityLevelFromString; }
/* harmony export */ });
/* unused harmony exports severityFromString, validSeverityLevels */
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
var validSeverityLevels = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function severityFromString(level) {
    return severityLevelFromString(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function severityLevelFromString(level) {
    return level === "warn" ? "warning" : validSeverityLevels.includes(level) ? level : "log";
}
 //# sourceMappingURL=severity.js.map


/***/ }),

/***/ 59036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; },
/* harmony export */   "zb": function() { return /* binding */ supportsReportingObserver; }
/* harmony export */ });
/* unused harmony exports supportsDOMError, supportsDOMException, supportsErrorEvent, supportsReferrerPolicy */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35614);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92957);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74672);



// eslint-disable-next-line deprecation/deprecation
var WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function supportsErrorEvent() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function supportsDOMException() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function supportsFetch() {
    if (!("fetch" in WINDOW)) {
        return false;
    }
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function supportsNativeFetch() {
    if (typeof EdgeRuntime === "string") {
        return true;
    }
    if (!supportsFetch()) {
        return false;
    }
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(WINDOW.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") {
        try {
            var sandbox = doc.createElement("iframe");
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        } catch (err) {
            _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X && _logger_js__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
        }
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function supportsReportingObserver() {
    return "ReportingObserver" in WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}
 //# sourceMappingURL=supports.js.map


/***/ }),

/***/ 57323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ getNumberOfUrlSegments; },
/* harmony export */   "en": function() { return /* binding */ parseUrl; },
/* harmony export */   "rt": function() { return /* binding */ stripUrlQueryAndFragment; }
/* harmony export */ });
/* unused harmony export getSanitizedUrlString */
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || "";
    var fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function getNumberOfUrlSegments(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter(function(s) {
        return s.length > 0 && s !== ",";
    }).length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function getSanitizedUrlString(url) {
    var protocol = url.protocol, host = url.host, path = url.path;
    var filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return "".concat(protocol ? "".concat(protocol, "://") : "").concat(filteredHost).concat(path);
}
 //# sourceMappingURL=url.js.map


/***/ }),

/***/ 45785:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _get; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_super_prop_base.mjs


function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = (0,_get_prototype_of/* default */.Z)(object);
    if (object === null) break;
  }

  return object;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get.mjs


function get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    get = Reflect.get;
  } else {
    get = function get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver || target);
      }

      return desc.value;
    };
  }

  return get(target, property, receiver);
}

function _get(target, property, receiver) {
  return get(target, property, receiver);
}


/***/ })

}]);